export default {
  "接口文档": "接口文档",
  "动态电子秤": "动态电子秤",
  "数据接收开放接口": "数据接收开放接口",
  "技术说明": "技术说明",
  "适用于动态电子称（品牌-型号）数据回传场景，用于电子称数据的接收。": "适用于动态电子称（品牌-型号）数据回传场景，用于电子称数据的接收。",
  "请先基础设置菜单的第三方硬件中配置，以及对方系统的技术开发。": "请先基础设置菜单的第三方硬件中配置，以及对方系统的技术开发。",
  "接收后数据处理，解析标签编号ID对应的分拣任务状态更新、商品分拣重量累加。": "接收后数据处理，解析标签编号ID对应的分拣任务状态更新、商品分拣重量累加。",
  "重复标签编号时，以最后一次接收重量为准。": "重复标签编号时，以最后一次接收重量为准。",
  "打印类型": "打印类型",
  "按客户打印": "按客户打印",
  "按客户下单份数打印": "按客户下单份数打印",
  "销售扣点结算单": "销售扣点结算单",
  "未结算": "未结算",
  "结算中": "结算中",
  "销售扣点结算": "销售扣点结算",
  "销售扣点报账": "销售扣点报账",
  "列表仅统计已完结订单的商品": "列表仅统计已完结订单的商品",
  "查询出库时间范围内订单的商品": "查询出库时间范围内订单的商品",
  "销售金额不含优惠": "销售金额不含优惠",
  "结算状态体现商品在该天是否结算及金额": "结算状态体现商品在该天是否结算及金额",
  "距离阶梯计费": "距离阶梯计费",
  "推广": "推广",
  "推广者ID": "推广者ID",
  "非协议特价类": "非协议特价类",
  "协议特价类": "协议特价类",
  "售后补偿": "售后补偿",
  "体现优惠详情": "体现优惠详情",
  "订单收费方式": "订单收费方式",
  "一天中多单收一单配送费": "一天中多单收一单配送费",
  "每单都收配送费": "每单都收配送费",
  "到款开始时间": "到款开始时间",
  "到款结束时间": "到款结束时间",
  "批次标签": "批次标签",
  "按规格统计": "按规格统计",
  "打印标签": "打印标签",
  "请选择打印批次": "请选择打印批次",
  "打印模板": "打印模板",
  "标签页码": "标签页码",
  "过期日期": "过期日期",
  "入库日期": "入库日期",
  "二维码包含溯源链接": "二维码包含溯源链接",
  "将本商品的采购量进行拆分为多家采买或更换采买对方。确认提交后，将会自动产出供货任务或采购任务至对方账号中，由其进行线下供货。最新报价为各供货商账号在APP上报价提供。": "将本商品的采购量进行拆分为多家采买或更换采买对方。确认提交后，将会自动产出供货任务或采购任务至对方账号中，由其进行线下供货。最新报价为各供货商账号在APP上报价提供。",
  "指定供货": "指定供货",
  "供货方案": "供货方案",
  "批量指定": "批量指定",
  "代提": "代提",
  "送货单打印时自动验货出库量": "送货单打印时自动验货出库量",
  "送货单打印时是否自动验货出库量": "送货单打印时是否自动验货出库量",
  "收费方式": "收费方式",
  "按重量": "按重量",
  "按分拣包数": "按分拣包数",
  "清单": "清单",
  "天数": "天数",
  "商品名称筛选": "商品名称筛选",
  "两者多选时，运费为金额相加": "两者多选时，运费为金额相加",
  "人员管理": "人员管理",
  "用户协议": "用户协议",
  "隐私政策": "隐私政策",
  "销售经理": "销售经理",
  "平台电话": "平台电话",
  "账号注销": "账号注销",
  "获取付款码": "获取付款码",
  "成品": "成品",
  "下单": "下单",
  "订单付款": "订单付款",
  "退款": "退款",
  "送货": "送货",
  "送达": "送达",
  "收货": "收货",
  "发起结算": "发起结算",
  "结算付款": "结算付款",
  "取消": "取消",
  "完成": "完成",
  "差额补付": "差额补付",
  "禁止业务员在APP端编辑客户详情中的结算方式": "禁止业务员在APP端编辑客户详情中的结算方式",
  "限客户注册时间，最近天数": "限客户注册时间，最近天数",
  "填价方式": "填价方式",
  "按单位": "按单位",
  "按规格": "按规格",
  "启用基础与规格的切算方式": "启用基础与规格的切算方式",
  "库存商品展示": "库存商品展示",
  "显示已下架的商品": "显示已下架的商品",
  "运费计算": "运费计算",
  "订单金额更新时，运费不重算": "订单金额更新时，运费不重算",
  "代采费计算": "代采费计算",
  "订单金额更新时，代采费不重算": "订单金额更新时，代采费不重算",
  "订单时价显示": "订单时价显示",
  "出库后订单的详情页价格正常显示": "出库后订单的详情页价格正常显示",
  "周转筐信息不打印": "周转筐信息不打印",
  "指定送货日期+保鲜天数": "指定送货日期+保鲜天数",
  "打印日期+保鲜天数": "打印日期+保鲜天数",
  "下单时，禁止修改单价": "下单时，禁止修改单价",
  "下单时，禁止修改数量": "下单时，禁止修改数量",
  "下单时，禁止删除商品": "下单时，禁止删除商品",
  "请先输入翻译词": "请先输入翻译词",
  "户名": "户名",
  "当前登录账号未开设在线收款账户!": "当前登录账号未开设在线收款账户!",
  "账户在第三方申核中，请等待!": "账户在第三方申核中，请等待!",
  "账户开设成功，未绑定银行卡!": "账户开设成功，未绑定银行卡!",
  "同步其他客户": "同步其他客户",
  "确认将该客户配置同步至已选客户配置？": "确认将该客户配置同步至已选客户配置？",
  "将该账户金额发起提现申请!": "将该账户金额发起提现申请!",
  "请输入手机 {phone} 短信码": "请输入手机 {phone} 短信码",
  "收款码": "收款码",
  "点击发送": "点击发送",
  "请上传微信收款码": "请上传微信收款码",
  "提现": "提现",
  "验证码": "验证码",
  "{num}秒后重试": "{num}秒后重试",
  "余额不足，无法提现": "余额不足，无法提现",
  "供应商说明": "供应商说明",
  "税费金额": "税费金额",
  "主商品": "主商品",
  "汇付支付": "汇付支付",
  "直接取供货任务的金额": "直接取供货任务的金额",
  "入库单据自动报账": "入库单据自动报账",
  "创建入库单据表后自动发起报账，指定时间/小时": "创建入库单据表后自动发起报账，指定时间/小时",
  "入库报账单自动完成": "入库报账单自动完成",
  "入库报账表指定时间自动完成，并创建财务流水，指定时间/小时": "入库报账表指定时间自动完成，并创建财务流水，指定时间/小时",
  "线上账户": "线上账户",
  "采购对账单自动生成": "采购对账单自动生成",
  "采购任务及供货任务完成后自动发起对账单，指定时间/小时": "采购任务及供货任务完成后自动发起对账单，指定时间/小时",
  "采购对账单自动完成": "采购对账单自动完成",
  "采购对账单在指定时间自动完成，并生成账户流水，指定时间/小时": "采购对账单在指定时间自动完成，并生成账户流水，指定时间/小时",
  "供货结算": "供货结算",
  "禁止供货商在APP完成结算": "禁止供货商在APP完成结算",
  "请选择待处理数据": "请选择待处理数据",
  "对方账户": "对方账户",
  "申请人类型": "申请人类型",
  "用户": "用户",
  "申请人账号": "申请人账号",
  "付款中": "付款中",
  "已付款": "已付款",
  "付款失败": "付款失败",
  "第三方线上支付": "第三方线上支付",
  "处理开始时间": "处理开始时间",
  "处理结束时间": "处理结束时间",
  "付款信息": "付款信息",
  "付款备注": "付款备注",
  "账户提现": "账户提现",
  "银行": "银行",
  "证号": "证号",
  "手机": "手机",
  "银行": "银行",
  "证号": "证号",
  "银行卡信息": "银行卡信息",
  "银行名称及开户支行": "银行名称及开户支行",
  "银行卡账号": "银行卡账号",
  "银行卡对应身份证": "银行卡对应身份证",
  "预留手机": "预留手机",
  "银行卡预留手机号": "银行卡预留手机号",
  "请输入银行名称及开户支行": "请输入银行名称及开户支行",
  "请输入银行卡账号": "请输入银行卡账号",
  "请输入银行卡对应身份证": "请输入银行卡对应身份证",
  "请输入银行卡预留手机号": "请输入银行卡预留手机号",
  "线上-对方系统账户": "线上-对方系统账户",
  "编辑银行卡": "编辑银行卡",

  "账户调额": "账户调额",
  "订单提前执行": "订单提前执行",
  "指定送货日期不变": "指定送货日期不变",
  "银行卡预留的手机号": "银行卡预留的手机号",
  "银行卡对应的身份证": "银行卡对应的身份证",
  "结算银行": "结算银行",
  "结算银行卡": "结算银行卡",
  "共同分拣": "共同分拣",
  "体现分拣中标识，商品或订单禁止其他账号进入参与分拣": "体现分拣中标识，商品或订单禁止其他账号进入参与分拣",
  "下架商品": "下架商品",
  "允许加入代客下单和入库单据": "允许加入代客下单和入库单据",
  "将该客户指定日期类型的订单，再指定送货日期的前几天，自动创建生成各种任务。系统默认为前1天": "将该客户指定日期类型的订单，再指定送货日期的前几天，自动创建生成各种任务。系统默认为前1天",
  "订单修改成功，请注意到送货列表打印出库单据！": "订单修改成功，请注意到送货列表打印出库单据！",
  "原值": "原值",
  "中文": "中文",
  "英文": "英文",
  "泰文": "泰文",
  "高棉语": "高棉语",
  "商城端多语言": "商城端多语言",
  "SPU总量": "SPU总量",
  "分拣抢单": "分拣抢单",
  "启用：分拣账号按订单逐一抢单拣货": "启用：分拣账号按订单逐一抢单拣货",
  "该线路下客户来单，参与分拣员抢单分配": "该线路下客户来单，参与分拣员抢单分配",
  "优先级": "优先级",
  "参与抢单": "参与抢单",
  "已开启分拣抢单": "已开启分拣抢单",
  "数字越小优先级高，0优先级最低": "数字越小优先级高，0优先级最低",
  "商品销售统计": "商品销售统计",
  "按订单统计": "按订单统计",
  "启用：按线路排列订单的顺序": "启用：按线路排列订单的顺序",
  "下单份数": "下单份数",
  "账户原价": "账户原价",
  "压缩比": "压缩比",
  "仅近7天": "仅近7天",
  "售后量显示": "售后量显示",
  "近7天售后": "近7天售后",
  "近7天销售": "近7天销售",
  "选择文件": "选择文件",
  "是": "是",
  "否": "否",
  "新建": "新建",
  "独立子账号": "独立子账号",
  "独立收货信息": "独立收货信息",
  "账号或名称": "账号或名称",
  "子账号": "子账号",
  "批量替换商品": "批量替换商品",
  "替换商品": "替换商品",
  "仅适用于商品未执行采购、分拣、出库的订单！替换后，订单中原来商品的采购任务、分拣任务、出库任务，都将会更新为所替换商品。下单数量不变。商品单价及订单金额也将重新取价计算。": "仅适用于商品未执行采购、分拣、出库的订单！替换后，订单中原来商品的采购任务、分拣任务、出库任务，都将会更新为所替换商品。下单数量不变。商品单价及订单金额也将重新取价计算。",
  "下单商品": "下单商品",
  "替换为": "替换为",
  "商品替换功能只支持状态为待生效和已生效处理中的订单": "商品替换功能只支持状态为待生效和已生效处理中的订单",
  "请选取收获地址": "请选取收获地址",
  "请输入收获地址": "请输入收获地址",
  "商品包装": "商品包装",
  "散装称重": "散装称重",
  "标品包装": "标品包装",
  "请输入岗位名称": "请输入岗位名称",
  "请输入人员姓名": "请输入人员姓名",
  "请输入手机号账号": "请输入手机号账号",
  "请输入收获姓名": "请输入收获姓名",
  "请输入收获电话": "请输入收获电话",
  "确认删除该子账号?": "确认删除该子账号?",
  "权限配置": "权限配置",
  "账号登录": "账号登录",
  "商品下单": "商品下单",
  "收货验货": "收货验货",
  "价格可见": "价格可见",
  "下单免主号审核": "下单免主号审核",
  "收货姓名": "收货姓名",
  "收货电话": "收货电话",
  "权限": "权限",
  "子账号基础信息编辑，及该账号在商城端的操作权限。": "子账号基础信息编辑，及该账号在商城端的操作权限。",
  "创建为独立的企业账号": "创建为独立的企业账号",
  "商品税名称": "商品税名称",
  "体现商品税": "体现商品税",
  "请输入图形验证码": "请输入图形验证码",
  "查询子账户": "查询子账户",
  "指定时间": "指定时间",
  "按供应商导出": "按供应商导出",
  "需求统计": "需求统计",
  "余额账户提现": "余额账户提现",
  "允许用户的余额提现": "允许用户的余额提现",
  "在账户列表页面发起申请，后台财务审核，线下支付": "在账户列表页面发起申请，后台财务审核，线下支付",
  "提现申请": "提现申请",
  "币种": "币种",
  "商品税": "商品税",
  "开票税": "开票税",
  "税费": "税费",
  "体现税费": "体现税费",
  "税费{num}{yuan}": "税费{num}{yuan}",
  "发票单导出": "发票单导出",
  "商品税费": "商品税费",
  "订单商品按客户账户计算税费": "订单商品按客户账户计算税费",
  "财务结算时，订单金额+税费": "财务结算时，订单金额+税费",
  "商品税率": "商品税率",
  "订单生成时，商品金额+税费": "订单生成时，商品金额+税费",
  "企业全称": "企业全称",
  "发票单据模板": "发票单据模板",
  "公司信息": "公司信息",
  "收款二维码": "收款二维码",
  "协议原价": "协议原价",
  "非协议原价": "非协议原价",
  "企业客户分销": "企业客户分销",
  "开启企业客户二维码，佣金到客户账户余额": "开启企业客户二维码，佣金到客户账户余额",
  "点击配置": "点击配置",
  "创建角色": "创建角色",
  "角色名称": "角色名称",
  "请输入角色名称": "请输入角色名称",
  "菜单功能限制": "菜单功能限制",
  "页面内容限制": "页面内容限制",
  "修改部门": "修改部门",
  "禁用": "禁用",
  "确认保存角色权限?": "确认保存角色权限?",
  "确认删除该部门?": "确认删除该部门?",
  "温湿度计": "温湿度计",
  "未分组账号": "未分组账号",
  "最多四层级部门，部门下是员工": "最多四层级部门，部门下是员工",
  "直接上级": "直接上级",
  "组织名称": "组织名称",
  "请输入，默认50": "请输入，默认50",
  "请输入组织名称": "请输入组织名称",
  "添加下级": "添加下级",
  "商品隐藏": "商品隐藏",
  "组织架构": "组织架构",
  "手机账号": "手机账号",
  "创建部门": "创建部门",
  "角色管理": "角色管理",
  "添加成员": "添加成员",
  "角色": "角色",
  "部门": "部门",
  "配送员的账号登录手机，到了客户坐标范围时才能刷新密码": "配送员的账号登录手机，到了客户坐标范围时才能刷新密码",
  "配送员的车载设备，到了客户坐标范围时才能刷新密码": "配送员的车载设备，到了客户坐标范围时才能刷新密码",
  "车载监控": "车载监控",
  "车牌": "车牌",
  "速度": "速度",
  "今日里程": "今日里程",
  "报警": "报警",
  "视频": "视频",
  "请先联系硬件平台商，获取以下参数": "请先联系硬件平台商，获取以下参数",
  "回调地址": "回调地址",
  "送达开始日期": "送达开始日期",
  "送达结束日期": "送达结束日期",
  "送货存放备注": "送货存放备注",
  "要求份量/实拣份量": "要求份量/实拣份量",
  "硬件管理": "硬件管理",
  "序列号": "序列号",
  "员工": "员工",
  "添加设备": "添加设备",
  "型号": "型号",
  "绑定员工": "绑定员工",
  "请选择设备类型": "请选择设备类型",
  "请输入设备序列号": "请输入设备序列号",
  "请输入设备名称": "请输入设备名称",
  "请选择绑定员工": "请选择绑定员工",
  "请选择厂商品牌": "请选择厂商品牌",
  "设备类型": "设备类型",
  "设备序列号": "设备序列号",
  "搜索并选择": "搜索并选择",
  "设备名称": "设备名称",
  "厂商品牌": "厂商品牌",
  "设备日志": "设备日志",
  "接口": "接口",
  "查看密码": "查看密码",
  "以下为电子锁设备的开锁密码，请在指定设备上使用": "以下为电子锁设备的开锁密码，请在指定设备上使用",
  "密码未使用时，刷新无效。当密码本次已经开锁使用后，可手动刷新，获取下次开锁密码。": "密码未使用时，刷新无效。当密码本次已经开锁使用后，可手动刷新，获取下次开锁密码。",
  "短信方式发送": "短信方式发送",
  "开锁": "开锁",
  "关锁": "关锁",
  "确认发送开锁指令?": "确认发送开锁指令?",
  "确认删除该设备?": "确认删除该设备?",
  "发送": "发送",
  "企业信息": "企业信息",
  "小程序/支付": "小程序/支付",
  "短信": "短信",
  "高德地图": "高德地图",
  "车载设备": "车载设备",
  "电子锁": "电子锁",
  "第三方配置": "第三方配置",
  "高德地图官方网站": "高德地图官方网站",
  "注册账号并认证，创建web类型应用，复制以下参数。": "注册账号并认证，创建web类型应用，复制以下参数。",
  "配送员在APP送货任务列表开锁": "配送员在APP送货任务列表开锁",
  "客户在商城端订单管理查看并提供密码给配送员": "客户在商城端订单管理查看并提供密码给配送员",
  "确认将该团长转换为个人用户。": "确认将该团长转换为个人用户。",
  "该团长账户及下级用户有未完成的订单时不能退回。": "该团长账户及下级用户有未完成的订单时不能退回。",
  "退回后该团长的下级用户需要重新选择团长。": "退回后该团长的下级用户需要重新选择团长。",
  "退回个人用户": "退回个人用户",
  "订单溯源": "订单溯源",
  "指定送达日期": "指定送达日期",
  "批次采购数量": "批次采购数量",
  "从入库批次纬度统计": "从入库批次纬度统计",
  "批次数": "批次数",
  "用户分销提成": "用户分销提成",
  "请输入搜索并选择客户单位": "请输入搜索并选择客户单位",
  "请输入单位或商户名称": "请输入单位或商户名称",
  "请选取单位地址": "请选取单位地址",
  "确认删除该供应商的所有商品报价?": "确认删除该供应商的所有商品报价?",
  "请先导入供应商报价": "请先导入供应商报价",
  "请先保存": "请先保存",
  "点击批量采用操作后，定价将不可取消回退！！！": "点击批量采用操作后，定价将不可取消回退！！！",
  "定位": "定位",
  "询价报价单": "询价报价单",
  "询价报价单模板": "询价报价单模板",
  "导入报价": "导入报价",
  "报价表": "报价表",
  "比价": "比价",
  "需求": "需求",
  "比价商品": "比价商品",
  "历史下单量": "历史下单量",
  "在线报价": "在线报价",
  "历史统计": "历史统计",
  "批量采用": "批量采用",
  "将选中的供应商及报价，批量同步到商品报价成本信息中。": "将选中的供应商及报价，批量同步到商品报价成本信息中。",
  "并将该规格的供应报价设置为当前供货状态，其他降为停供。": "并将该规格的供应报价设置为当前供货状态，其他降为停供。",
  "如缺少规格报价则新建，并处理供货状态。": "如缺少规格报价则新建，并处理供货状态。",
  "该规格商品的供货任务都将分配给该供应商。": "该规格商品的供货任务都将分配给该供应商。",
  "用户分销提成：按推荐注册账号的关系，下级交易订单时向推荐者进行提成": "用户分销提成：按推荐注册账号的关系，下级交易订单时向推荐者进行提成",
  "字体": "字体",
  "体现商品件数": "体现商品件数",
  "即分拣时包裹数量": "即分拣时包裹数量",
  "商品{num}件": "商品{num}件",
  "建单时间": "建单时间",
  "售后退款金额": "售后退款金额",
  "回退到待送货": "回退到待送货",
  "确认将已选送货任务回退到待送货状态?": "确认将已选送货任务回退到待送货状态?",
  "账号自动停用": "账号自动停用",
  "账号连续未下单，则自动转为停用状态": "账号连续未下单，则自动转为停用状态",
  "请选择已取消订单进行删除": "请选择已取消订单进行删除",
  "确认删除已选择订单?": "确认删除已选择订单?",
  "送货单打印设置": "送货单打印设置",
  "售后单打印设置": "售后单打印设置",
  "转库存入库": "转库存入库",
  "转库存出库": "转库存出库",
  "包裹数": "包裹数",
  "启用，该客户收货地址为本平台地址": "启用，该客户收货地址为本平台地址",
  "启用：要求分拣时录入包裹数量": "启用：要求分拣时录入包裹数量",
  "请选择原商品": "请选择原商品",
  "请选择转换商品": "请选择转换商品",
  "不显示小计数据": "不显示小计数据",
  "不显示合计数据": "不显示合计数据",
  "市场价": "市场价",
  "统计每日下单商品流通情况": "统计每日下单商品流通情况",
  "合计该日所有下单商品的订单量和需求量": "合计该日所有下单商品的订单量和需求量",
  "合计该日已经执行完成的采购量和金额": "合计该日已经执行完成的采购量和金额",
  "合计该日各种入库类型的入库量和金额": "合计该日各种入库类型的入库量和金额",
  "生产分拣环节的领料出库数量": "生产分拣环节的领料出库数量",
  "生产分拣环节的成品拣货完成数量": "生产分拣环节的成品拣货完成数量",
  "生产分拣环节的余料退还入库数量": "生产分拣环节的余料退还入库数量",
  "订单出库时数量和销售出库金额": "订单出库时数量和销售出库金额",
  "该日订单售后申请的处理数量和金额": "该日订单售后申请的处理数量和金额",
  "该日入库和出库后的库存量结余": "该日入库和出库后的库存量结余",
  "出库金额-退货金额-入库金额(不含结余量价值)": "出库金额-退货金额-入库金额(不含结余量价值)",
  "对时间范围内的每日经营时的各项数据统计": "对时间范围内的每日经营时的各项数据统计",
  "执行完成的采购任务的总额": "执行完成的采购任务的总额",
  "采购入库记录的总额": "采购入库记录的总额",
  "订单出库时的商品成本总额": "订单出库时的商品成本总额",
  "订单实际出库量的总额": "订单实际出库量的总额",
  "出库金额-出库成本": "出库金额-出库成本",
  "领料": "领料",
  "还料": "还料",
  "结余": "结余",
  "商品流通": "商品流通",
  "请预先在小程序对接页面中，设置短信平台信息，以及在短信宝后台完成实名认证和短信模板备案": "请预先在小程序对接页面中，设置短信平台信息，以及在短信宝后台完成实名认证和短信模板备案",
  "加入客户报价方案": "加入客户报价方案",
  "加入分类折扣方案": "加入分类折扣方案",
  "分钟": "分钟",
  "商品加入购物车以后，未提交则自动清空购物车，并释放库存": "商品加入购物车以后，未提交则自动清空购物车，并释放库存",
  "待结差额": "待结差额",
  "售后类型": "售后类型",
  "售后状态": "售后状态",
  "售后处理原因": "售后处理原因",
  "售后处理责任": "售后处理责任",
  "售后处理结果": "售后处理结果",
  "售后处理时间": "售后处理时间",
  "供货商ID": "供货商ID",
  "实际售后量": "实际售后量",
  "退款平台承担金额": "退款平台承担金额",
  "退款供应商承担金额": "退款供应商承担金额",
  "走访寻访": "走访寻访",
  "部分图片处理失败": "部分图片处理失败",
  "蔬果云图片库": "蔬果云图片库",
  "账户续费提示": "账户续费提示",
  "尊敬的用户您好": "尊敬的用户您好",
  "我知道了": "我知道了",
  "贵单位账号的服务年费将于{days}天后到期({time})，为不影响正常业务经营及服务，请尽快完成续费，您可以线下联系销售经理处理，或售后服务群中反馈，如您已续费请忽略。": "贵单位账号的服务年费将于{days}天后到期({time})，为不影响正常业务经营及服务，请尽快完成续费，您可以线下联系销售经理处理，或售后服务群中反馈，如您已续费请忽略。",
  "新账号注册时，默认成为会员": "新账号注册时，默认成为会员",
  "原商品": "原商品",
  "转换为": "转换为",
  "库存转换": "库存转换",
  "转换详情": "转换详情",
  "收付款账户": "收付款账户",
  "温湿度": "温湿度",
  "定位设备": "定位设备",
  "支持品牌：大昱丰，设备名：远程温湿度计": "支持品牌：大昱丰，设备名：远程温湿度计",
  "请添加设备背后编码": "请添加设备背后编码",
  "检测基数": "检测基数",
  "按重量循环使用": "按重量循环使用",
  "不选则打印全部": "不选则打印全部",
  "规格单位名(无则空)": "规格单位名(无则空)",
  "图片多选": "图片多选",
  "最多选择{num}张图片": "最多选择{num}张图片",
  "请输入编号": "请输入编号",
  "指定日期无检测报告时，自动查询指定日期之前的有效期内历史报告": "指定日期无检测报告时，自动查询指定日期之前的有效期内历史报告",
  "检测打印": "检测打印",
  "批量检测打印": "批量检测打印",
  "样品编号": "样品编号",
  "样品名称": "样品名称",
  "检测项目": "检测项目",
  "检测值": "检测值",
  "检测日期": "检测日期",
  "检测结果": "检测结果",
  "检测结果描述": "检测结果描述",
  "自检类报告将采用报告模板内容样式，外检类将报告的图片按A4纸打印": "自检类报告将采用报告模板内容样式，外检类将报告的图片按A4纸打印",
  "打印日期": "打印日期",
  "取当前操作的时间点": "取当前操作的时间点",
  "签名": "签名",
  "盖章": "盖章",
  "产品检测详情": "产品检测详情",
  "商品检测": "商品检测",
  "商品检测详情": "商品检测详情",
  "选择": "选择",
  "检测开始时间": "检测开始时间",
  "检测结束时间": "检测结束时间",
  "检测值": "检测值",
  "描述": "描述",
  "入库批次": "入库批次",
  "批次有效期": "批次有效期",
  "硬件设置": "硬件设置",
  "报告模板": "报告模板",
  "请选择检测项目": "请选择检测项目",
  "请选择检测时间": "请选择检测时间",
  "样品来源": "样品来源",
  "报告结果图片": "报告结果图片",
  "硬件上传数据": "硬件上传数据",
  "检测内容": "检测内容",
  "样品名称": "样品名称",
  "基数": "基数",
  "报告有效期": "报告有效期",
  "合格": "合格",
  "不合格": "不合格",
  "上传结果拍照": "上传结果拍照",
  "请添加检测内容": "请添加检测内容",
  "适用模板": "适用模板",
  "自检": "自检",
  "农药残留": "农药残留",
  "重金属镉": "重金属镉",
  "外检": "外检",
  "肉品品质": "肉品品质",
  "动物检疫": "动物检疫",
  "原订单号": "原订单号",
  "农残报告模板": "农残报告模板",
  "入库单打印设置": "入库单打印设置",
  "表格": "表格",
  "分析": "分析",
  "表格补单": "表格补单",
  "按模板格式导入表格数据，批量生成补录单，原有相同单号的订单将覆盖": "按模板格式导入表格数据，批量生成补录单，原有相同单号的订单将覆盖",
  "商品规格(基础量)": "商品规格(基础量)",
  "启用：点送货出库时，订单中商品成本取批次成本（缺少时取库存成本）": "启用：点送货出库时，订单中商品成本取批次成本（缺少时取库存成本）",
  "对本批次商品的成本进行调整，将创建一条数量为0的入库日志，调整后商品出库将采用新的成本金额。": "对本批次商品的成本进行调整，将创建一条数量为0的入库日志，调整后商品出库将采用新的成本金额。",
  "对本批次商品的余量进行盘点调整，差额将创建一条盘点日志。": "对本批次商品的余量进行盘点调整，差额将创建一条盘点日志。",
  "请输入成本": "请输入成本",
  "请输入余量": "请输入余量",
  "进展": "进展",
  "未发货": "未发货",
  "已发货": "已发货",
  "接收库房": "接收库房",
  "调拨单": "调拨单",
  "出库仓": "出库仓",
  "集采单": "集采单",
  "集采任务": "集采任务",
  "汇总": "汇总",
  "报单": "报单",
  "批量报单": "批量报单",
  "未报单": "未报单",
  "已报单": "已报单",
  "集采报单": "集采报单",
  "向本品牌商的总仓，进行集采报单。": "向本品牌商的总仓，进行集采报单。",
  "报采": "报采",
  "限集采类商品": "限集采类商品",
  "将分仓作为客户进行关联，以便受理分仓的订单，请预先到客户列表创建一个账号，作为分仓客户账号。为空则不建立关联。": "将分仓作为客户进行关联，以便受理分仓的订单，请预先到客户列表创建一个账号，作为分仓客户账号。为空则不建立关联。",
  "集采商品库": "集采商品库",
  "关联": "关联",
  "集采": "集采",
  "关联集采商品库": "关联集采商品库",
  "集采商品采购将分配品牌商总部集中采购，不创建平台仓采购任务": "集采商品采购将分配品牌商总部集中采购，不创建平台仓采购任务",
  "分类折扣价 （在以上机制取价后，再进行符合折扣方案的折扣，且与客户账户折扣机制叠加）。": "分类折扣价 （在以上机制取价后，再进行符合折扣方案的折扣，且与客户账户折扣机制叠加）。",
  "分类折扣是在商品取价后(协议价、星级价)，再按所符合条件的折扣方案，进行折扣计算。": "分类折扣是在商品取价后(协议价、星级价)，再按所符合条件的折扣方案，进行折扣计算。",
  "分类折扣与客户账户折扣同时设置时，将叠加使用，即折上折。": "分类折扣与客户账户折扣同时设置时，将叠加使用，即折上折。",
  "当一个客户或商品符合多个折扣方案条件时，仅采用最大编号的方案执行。": "当一个客户或商品符合多个折扣方案条件时，仅采用最大编号的方案执行。",
  "请选择关联客户": "请选择关联客户",
  "请选择有效期": "请选择有效期",
  "二级分类名称": "二级分类名称",
  "分类折扣": "分类折扣",
  "显示商品成本": "显示商品成本",
  "显示商品市场售价": "显示商品市场售价",
  "显示商品折扣率": "显示商品折扣率",
  "显示内部备注": "显示内部备注",
  "显示商品成本": "显示商品成本",
  "订单标签已开启，至少需新增一条标签": "订单标签已开启，至少需新增一条标签",
  "标签名已存在": "标签名已存在",
  "请选择订单标签": "请选择订单标签",
  "订单标签": "订单标签",
  "下单时给订单标记标签": "下单时给订单标记标签",
  "标签选项": "标签选项",
  "新增标签": "新增标签",
  "下单备注": "下单备注",
  "禁用商品备注": "禁用商品备注",
  "禁用订单备注": "禁用订单备注",
  "最多筛选61天时间范围数据": "最多筛选61天时间范围数据",
  "折扣率必须大于0": "折扣率必须大于0",
  "规格单位名": "规格单位名",
  "计算折扣率": "计算折扣率",
  "账户折扣率": "账户折扣率",
  "商品折扣率": "商品折扣率",
  "库存量=0": "库存量=0",
  "库存量<0": "库存量<0",
  "库存量>0": "库存量>0",
  "应用折扣": "应用折扣",
  "集采商品": "集采商品",
  "加工工艺": "加工工艺",
  "财务账户": "财务账户",
  "会员期账户折扣": "会员期账户折扣",
  "到期后账户折扣": "到期后账户折扣",
  "原单": "原单",
  "创建新订单": "创建新订单",
  "使用当前最新价格": "使用当前最新价格",
  "使用所选订单当时价格": "使用所选订单当时价格",
  "拼合下单": "拼合下单",
  "将所选中的多个订单的商品复制出来，为指定客户创建生成新的线下类型订单，原单请自行手动取消。": "将所选中的多个订单的商品复制出来，为指定客户创建生成新的线下类型订单，原单请自行手动取消。",
  "相同规格商品相同价格时，商品合并且数量累加，订单备注和商品备注追加；但当不同价时，商品不合并": "相同规格商品相同价格时，商品合并且数量累加，订单备注和商品备注追加；但当不同价时，商品不合并",
  "客户拜访统计": "客户拜访统计",
  "建档": "建档",
  "删除菜谱": "删除菜谱",
  "确认删除该菜谱?": "确认删除该菜谱?",
  "请按一人份餐的份量，来配比食材!": "请按一人份餐的份量，来配比食材!",
  "菜品信息": "菜品信息",
  "食材": "食材",
  "请选择餐别": "请选择餐别",
  "请选择星期": "请选择星期",
  "加入推荐": "加入推荐",
  "营养菜谱": "营养菜谱",
  "上传": "上传",
  "检测": "检测",
  "早餐": "早餐",
  "中餐": "中餐",
  "晚餐": "晚餐",
  "加餐": "加餐",
  "推荐菜谱": "推荐菜谱",
  "用户菜谱": "用户菜谱",
  "星期": "星期",
  "餐别": "餐别",
  "菜品": "菜品",
  "检测名称": "检测名称",
  "检测描述": "检测描述",
  "结果拍照": "结果拍照",
  "检测时间": "检测时间",
  "不填则长期有效": "不填则长期有效",
  "操作者": "操作者",
  "到期开始时间": "到期开始时间",
  "到期结束时间": "到期结束时间",
  "上传检测": "上传检测",
  "生产商": "生产商",
  "生产电话": "生产电话",
  "生产许可证号": "生产许可证号",
  "贮存条件": "贮存条件",
  "供应商地址": "供应商地址",
  "供应商电话": "供应商电话",
  "资质证照": "资质证照",
  "生产环境照": "生产环境照",
  "产品标准代号": "产品标准代号",
  "商品名称采用匹配时的商品别名": "商品名称采用匹配时的商品别名",
  "订单详情中商品点击查看溯源信息": "订单详情中商品点击查看溯源信息",
  "跟进": "跟进",
  "肖像": "肖像",
  "客户自提": "客户自提",
  "自提货": "自提货",
  "取货方式": "取货方式",
  "配置": "配置",
  "供应商直供": "供应商直供",
  "需分别配置指定供货商和客户的送货服务开关": "需分别配置指定供货商和客户的送货服务开关",
  "供应商扣点": "供应商扣点",
  "需分别配置指定供货商的服务扣点方案": "需分别配置指定供货商的服务扣点方案",
  "加长": "加长",
  "采购任务通知": "采购任务通知",
  "供货商任务通知": "供货商任务通知",
  "客户标签": "客户标签",
  "下单成功!": "下单成功!",
  "启用：入库审核时，将单价和数量都更新到采购任务": "启用：入库审核时，将单价和数量都更新到采购任务",
  "净重数量": "净重数量",
  "净重/毛重显示": "净重/毛重显示",
  "订单动态": "订单动态",
  "近3天订单": "近3天订单",
  "坐标远近优先显示": "坐标远近优先显示",
  "按下单时间顺序": "按下单时间顺序",
  "循环": "循环",
  "循环播放": "循环播放",
  "轮播一次": "轮播一次",
  "未停用": "未停用",
  "首单开始日期": "首单开始日期",
  "首单结束日期": "首单结束日期",
  "末单开始日期": "末单开始日期",
  "末单结束日期": "末单结束日期",
  "拜访次数": "拜访次数",
  "未结算单": "未结算单",
  "商城浏览开始日期": "商城浏览开始日期",
  "商城浏览结束日期": "商城浏览结束日期",
  "关联用户": "关联用户",
  "推广用户": "推广用户",
  "未收货": "未收货",
  "默认分类排序": "默认分类排序",
  "浏览量排序": "浏览量排序",
  "历史下单量排序": "历史下单量排序",
  "购买": "购买",
  "浏览": "浏览",
  "次数": "次数",
  "日均": "日均",
  "商品浏览": "商品浏览",
  "浏览次数": "浏览次数",
  "用户数": "用户数",
  "分类统计": "分类统计",
  "仅适用于已生效但未结算状态的订单": "仅适用于已生效但未结算状态的订单",
  "所选中的订单，在符合条件报价方案中的条件项时，会执行商品改价，及重算订单金额": "所选中的订单，在符合条件报价方案中的条件项时，会执行商品改价，及重算订单金额",
  "已经发结算及以后状态的订单不起效": "已经发结算及以后状态的订单不起效",
  "拣货号": "拣货号",
  "拣货单": "拣货单",
  "分拣量": "分拣量",
  "代收点商品清单": "代收点商品清单",
  "未生成B账单": "未生成B账单",
  "改单退单": "改单退单",
  "下单后禁止修改订单": "下单后禁止修改订单",
  "下单后禁止取消订单": "下单后禁止取消订单",
  "默认15天": "默认15天",
  "范围天数": "范围天数",
  "取价": "取价",
  "报价方案取价": "报价方案取价",
  "投篮号": "投篮号",
  "小计分类商品的金额": "小计分类商品的金额",
  "本页小计": "本页小计",
  "合计大写": "合计大写",
  "每页小计": "每页小计",
  "合计金额总值大写": "合计金额总值大写",
  "处理中": "处理中",
  "待到款": "待到款",
  "已到款": "已到款",
  "是否直送": "是否直送",
  "直送": "直送",
  "商品汇总": "商品汇总",
  "筛选订单": "筛选订单",
  "筛选商品": "筛选商品",
  "从订单关联商品返回入库单时，单价取入库单对方的上一历史入库单中商品单价，数量取订单中商品下单数量": "从订单关联商品返回入库单时，单价取入库单对方的上一历史入库单中商品单价，数量取订单中商品下单数量",
  "下载商品库": "下载商品库",
  "规格编号": "规格编号",
  "线路编号": "线路编号",
  "送货员编号": "送货员编号",
  "链接含参数值，仅供分拣上位机识别": "链接含参数值，仅供分拣上位机识别",
  "发单员": "发单员",
  "结算清单": "结算清单",
  "确认人": "确认人",
  "售价采用上一订单中商品的售价": "售价采用上一订单中商品的售价",
  "余款": "余款",
  "免审核时间": "免审核时间",
  "下单时，禁止修改单价和数量": "下单时，禁止修改单价和数量",
  "禁止在收银台修改历史单": "禁止在收银台修改历史单",
  "禁止在收银台取消订单": "禁止在收银台取消订单",
  "收银端": "收银端",
  "分页重复打印": "分页重复打印",
  "表格区域必须设置固定空行": "表格区域必须设置固定空行",
  "录入添加": "录入添加",
  "支持历史报价单导入": "支持历史报价单导入",
  "付款类目": "付款类目",
  "应报": "应报",
  "实报": "实报",
  "确认将该记录申请报账?": "确认将该记录申请报账?",
  "已报账": "已报账",
  "周转筐报账表": "周转筐报账表",
  "确认取消该报账?": "确认取消该报账?",
  "取消报账": "取消报账",
  "历史记录": "历史记录",
  "支付状态": "支付状态",
  "请选择经手员工": "请选择经手员工",
  "已付押金，申请报账": "已付押金，申请报账",
  "周转筐库存不足": "周转筐库存不足",
  "超出最大可退还数量": "超出最大可退还数量",
  "收到退筐，原路退回押金": "收到退筐，原路退回押金",
  "收到退筐，不退押金": "收到退筐，不退押金",
  "客户报价优先级次于客户协议特价": "客户报价优先级次于客户协议特价",
  "协议定价": "协议定价",
  "报价方案": "报价方案",
  "启用方案": "启用方案",
  "请输入名称": "请输入名称",
  "请选择时间范围": "请选择时间范围",
  "启用中": "启用中",
  "客户报价": "客户报价",
  "库存筐": "库存筐",
  "客户借筐": "客户借筐",
  "来筐": "来筐",
  "创建篮筐": "创建篮筐",
  "启用周转筐v2流程": "启用周转筐v2流程",
  "周转筐v2": "周转筐v2",
  "历史": "历史",
  "出筐": "出筐",
  "批准人": "批准人",
  "商品汇总导出": "商品汇总导出",
  "送达日期": "送达日期",
  "自定义编码": "自定义编码",
  "内部备注": "内部备注",
  "周转筐押金纳入计算": "周转筐押金纳入计算",
  "配送轨迹": "配送轨迹",
  "任务路径": "任务路径",
  "任务路径距离": "任务路径距离",
  "订单开始时间": "订单开始时间",
  "订单结束时间": "订单结束时间",
  "导出明细": "导出明细",
  "配送运费": "配送运费",
  "启用配送费": "启用配送费",
  "距离、重量计费": "距离、重量计费",
  "商品金额阶梯计费": "商品金额阶梯计费",
  "价值": "价值",
  "再来一单": "再来一单",
  "按商品数量计费": "按商品数量计费",
  "按商品金额阶梯计费": "按商品金额阶梯计费",
  "收费方案": "收费方案",
  "服务费率": "服务费率",
  "体现本单实收": "体现本单实收",
  "体现本单欠款": "体现本单欠款",
  "体现此前欠款": "体现此前欠款",
  "体现累计欠款": "体现累计欠款",
  "本单实收{num}{yuan}": "本单实收{num}{yuan}",
  "本单欠款{num}{yuan}": "本单欠款{num}{yuan}",
  "此前欠款{num}{yuan}": "此前欠款{num}{yuan}",
  "累计欠款{num}{yuan}": "累计欠款{num}{yuan}",
  "即本单已付金额": "即本单已付金额",
  "即本单合计金额-已付金额": "即本单合计金额-已付金额",
  "即所有出库后订单及未到款结算单的欠款金额，不含本单": "即所有出库后订单及未到款结算单的欠款金额，不含本单",
  "即所有出库后订单及未到款结算单的欠款金额": "即所有出库后订单及未到款结算单的欠款金额",
  "二维码标签": "二维码标签",
  "隐藏客户电话": "隐藏客户电话",
  "保存后刷新生效": "保存后刷新生效",
  "送货单金额": "送货单金额",
  "强制平帐": "强制平帐",
  "商品金额四舍五入差额记到最后商品，以保证金额与订单合计一致，避免误差": "商品金额四舍五入差额记到最后商品，以保证金额与订单合计一致，避免误差",
  "微信发货管理": "微信发货管理",
  "是否微信自动发货": "是否微信自动发货",
  "售后开始时间": "售后开始时间",
  "售后结束时间": "售后结束时间",
  "售后统计": "售后统计",
  "补货统计": "补货统计",
  "换货": "换货",
  "退差价": "退差价",
  "岗位": "岗位",
  "岗位及原因": "岗位及原因",
  "注：对售后申请记录为处理完状态统计": "注：对售后申请记录为处理完状态统计",
  "商品减量，订单重算": "商品减量，订单重算",
  "售后数量": "售后数量",
  "订单优惠补偿": "订单优惠补偿",
  "优惠补偿金额将累加到订单优惠金额栏，减少订单金额。": "优惠补偿金额将累加到订单优惠金额栏，减少订单金额。",
  "优惠金额": "优惠金额",
  "订单共优惠": "订单共优惠",
  "同时也提前分包和送货": "同时也提前分包和送货",
  "清除扣点": "清除扣点",
  "确认清除该供应商扣点设置?": "确认清除该供应商扣点设置?",
  "充值赠送": "充值赠送",
  "启用充值赠送功能": "启用充值赠送功能",
  "客户在商城余额页面进行充值，成功则另外获赠金额。系统生成对应流水记录。": "客户在商城余额页面进行充值，成功则另外获赠金额。系统生成对应流水记录。",
  "待生效": "待生效",
  "生效中": "生效中",
  "充值": "充值",
  "充值金额": "充值金额",
  "赠送金额": "赠送金额",
  "请输入活动名称": "请输入活动名称",
  "请输入充值金额": "请输入充值金额",
  "请选择有效时间范围": "请选择有效时间范围",
  "赠送": "赠送",
  "价格&成本趋势": "价格&成本趋势",
  "该客户近期30个历史订单中本商品的成本和售价": "该客户近期30个历史订单中本商品的成本和售价",
  "扣点类型": "扣点类型",
  "扣点率": "扣点率",
  "供货合计": "供货合计",
  "销售合计": "销售合计",
  "注": "注",
  "合计=供货+扣点-罚款-退款-退补": "合计=供货+扣点-罚款-退款-退补",
  "合计=销售-扣点-罚款-退款-退补": "合计=销售-扣点-罚款-退款-退补",
  "门头照、营业执照是否必填": "门头照、营业执照是否必填",
  "已收货": "已收货",
  "待收货": "待收货",
  "送货服务": "送货服务",
  "同意将货品直接配送给客户地址": "同意将货品直接配送给客户地址",
  "默认供货商只配送到平台": "默认供货商只配送到平台",
  "请设置下单时间范围": "请设置下单时间范围",
  "自主收货": "自主收货",
  "允许该客户在商城端验货收货提交数量": "允许该客户在商城端验货收货提交数量",
  "优先由供应商直送": "优先由供应商直送",
  "默认平台统一配送": "默认平台统一配送",
  "级别高于商城通用下单截止时间": "级别高于商城通用下单截止时间",
  "收货异常": "收货异常",
  "收货少量": "收货少量",
  "收货超量": "收货超量",
  "少量超量": "少量超量",
  "收货量": "收货量",
  "出库状态": "出库状态",
  "直送任务": "直送任务",
  "待拣货": "待拣货",
  "送货开始时间": "送货开始时间",
  "送货结束时间": "送货结束时间",
  "双方": "双方",
  "待拣货": "待拣货",
  "供应商直送客户": "供应商直送客户",
  "送货时创建入库记录": "送货时创建入库记录",
  "送货时创建供货完成任务": "送货时创建供货完成任务",
  "距离": "距离",
  "不足1公里按1公里算": "不足1公里按1公里算",
  "起送": "起送",
  "不足1Kg按1Kg算，出库时按实际重量重新计算运费及订单": "不足1Kg按1Kg算，出库时按实际重量重新计算运费及订单",
  "起送：$SPLIT${yuan}/单，$SPLIT$kg内免费": "起送：$SPLIT${yuan}/单，$SPLIT$kg内免费",
  "每增：$SPLIT$kg，运费加$SPLIT${yuan}": "每增：$SPLIT$kg，运费加$SPLIT${yuan}",
  "不满标准无法下单": "不满标准无法下单",
  "代采费": "代采费",
  "添加方案": "添加方案",
  "代采收费": "代采收费",
  "启用代采收费模式": "启用代采收费模式",
  "代采模式": "代采模式",
  "平台为客户提供商品代采服务，订单结算时，在商品金额之外，再增加代采费和运费。": "平台为客户提供商品代采服务，订单结算时，在商品金额之外，再增加代采费和运费。",
  "订单计算时，会执行所有方案，符合条件时，金额都将累加到订单，所以方案设置时，请勿重复数据。": "订单计算时，会执行所有方案，符合条件时，金额都将累加到订单，所以方案设置时，请勿重复数据。",
  "客户星级": "客户星级",
  "指定客户": "指定客户",
  "默认收费": "默认收费",
  "单位量": "单位量",
  "如：斤、件": "如：斤、件",
  "收费优先级": "收费优先级",
  "商品、分类、默认": "商品、分类、默认",
  "按分类": "按分类",
  "收费标准": "收费标准",
  "请填写默认收费": "请填写默认收费",
  "体现代采费": "体现代采费",
  "代采费{num}{yuan}": "代采费{num}{yuan}",
  "出库时是否合并同一单中同规格、分拣状态、成本、售价、备注的商品": "出库时是否合并同一单中同规格、分拣状态、成本、售价、备注的商品",
  "搜索商品并选择": "搜索商品并选择",
  "制定加工任务": "制定加工任务",
  "制定加工": "制定加工",
  "加工数量": "加工数量",
  "启用：点送货出库时，订单中商品成本取商品定价的成本": "启用：点送货出库时，订单中商品成本取商品定价的成本",
  "启用：点送货出库时，订单中商品成本取库存商品的均衡成本": "启用：点送货出库时，订单中商品成本取库存商品的均衡成本",
  "余额参与支付": "余额参与支付",
  "余额与在线独立支付": "余额与在线独立支付",
  "余额与在线综合支付": "余额与在线综合支付",
  "退款时优先退在线额": "退款时优先退在线额",
  "登录安全码": "登录安全码",
  "员工账号凭安全码登录": "员工账号凭安全码登录",
  "登录缓存": "登录缓存",
  "清空缓存": "清空缓存",
  "一键强制清空员工登录缓存，促使退出登录状态": "一键强制清空员工登录缓存，促使退出登录状态",
  "请输入登录安全码": "请输入登录安全码",
  "客户注册": "客户注册",
  "客户量": "客户量",
  "平均成本": "平均成本",
  "权限不足": "权限不足",
  "导出订单清单": "导出订单清单",
  "页码": "页码",
  "显示页码": "显示页码",
  "开启页码显示须设置固定行数": "开启页码显示须设置固定行数",
  "请填写模板名称": "请填写模板名称",
  "模块背景": "模块背景",
  "请选择图片": "请选择图片",
  "素材库": "素材库",
  "选择素材": "选择素材",
  "优惠券数量不足": "优惠券数量不足",
  "用户自主领取": "用户自主领取",
  "新用户账号注册时发放到账户": "新用户账号注册时发放到账户",
  "发券": "发券",
  "确认发送该优惠券?": "确认发送该优惠券?",
  "选择模板": "选择模板",
  "保存为模板": "保存为模板",
  "示例模板": "示例模板",
  "系统模板": "系统模板",
  "我的模板": "我的模板",
  "应用": "应用",
  "点击预览，先在页面正文区域体验效果。": "点击预览，先在页面正文区域体验效果。",
  "确认效果后，点击页面右上角保存按钮，将效果应用到商城小程序端，不可退回。如果效果不理想，请勿点击保存。": "确认效果后，点击页面右上角保存按钮，将效果应用到商城小程序端，不可退回。如果效果不理想，请勿点击保存。",
  "首页只显示第一级商品分类的图标。请到管理菜单的商品分类页面，管理分类图标": "首页只显示第一级商品分类的图标。请到管理菜单的商品分类页面，管理分类图标",
  "请预先到商城菜单主题活动页面中，创建和管理主题活动。再填入正确的活动ID": "请预先到商城菜单主题活动页面中，创建和管理主题活动。再填入正确的活动ID",
  "请预先在商城菜单的特价活动页面中，创建和管理活动信息，再分别在模块中设置对应的活动名称": "请预先在商城菜单的特价活动页面中，创建和管理活动信息，再分别在模块中设置对应的活动名称",
  "点确定按钮后清空搜索词重新录入": "点确定按钮后清空搜索词重新录入",
  "规格条码": "规格条码",
  "账户折扣": "账户折扣",
  "自定义商城": "自定义商城",
  "发放方式": "发放方式",
  "优惠券管理": "优惠券管理",
  "请设置商城下单时间": "请设置商城下单时间",
  "分拣包数": "分拣包数",
  "居左": "居左",
  "居中": "居中",
  "分拣状态": "分拣状态",
  "配送开始日期": "配送开始日期",
  "配送结束日期": "配送结束日期",
  "寄售": "寄售",
  "请选择送货时间": "请选择送货时间",
  "计划时间": "计划时间",
  "班次": "班次",
  "全部班次": "全部班次",
  "工作班次": "工作班次",
  "默认名称": "默认名称",
  "班次名称": "班次名称",
  "班次时间": "班次时间",
  "将运营时间划分为多个工作班次。设置项为空视为全天班。多个班次时，时间段要连续，但不可重叠，不可超过运营时间。": "将运营时间划分为多个工作班次。设置项为空视为全天班。多个班次时，时间段要连续，但不可重叠，不可超过运营时间。",
  "订单创建时，判断配送时间，是否在各班次的时间范围内；如无班次对应，则下单失败，返回提示。如有，则在对应班次分配订单及任务": "订单创建时，判断配送时间，是否在各班次的时间范围内；如无班次对应，则下单失败，返回提示。如有，则在对应班次分配订单及任务",
  "订单合并时判断班次，同一班次的订单才允许合并。": "订单合并时判断班次，同一班次的订单才允许合并。",
  "采购任务、分包任务创建时，如果同一班次中有待完成的任务，则追加；如无则新建任务。": "采购任务、分包任务创建时，如果同一班次中有待完成的任务，则追加；如无则新建任务。",
  "规格换算量": "规格换算量",
  "库存方式": "库存方式",
  "规格属性": "规格属性",
  "订单时间": "订单时间",
  "不可重复添加": "不可重复添加",
  "模块组件": "模块组件",
  "加入页面": "加入页面",
  "页面预览": "页面预览",
  "组件配置": "组件配置",
  "商城首页": "商城首页",
  "头部背景": "头部背景",
  "搜索栏": "搜索栏",
  "轮播图": "轮播图",
  "公告栏": "公告栏",
  "优惠券领取": "优惠券领取",
  "团长站点": "团长站点",
  "同类组件添加已超出上限": "同类组件添加已超出上限",
  "已添加": "已添加",
  "页面配置": "页面配置",
  "页面主色": "页面主色",
  "页面底色": "页面底色",
  "高度": "高度",
  "占位高度": "占位高度",
  "样式": "样式",
  "背景": "背景",
  "提示语": "提示语",
  "颜色": "颜色",
  "当天下单时间": "当天下单时间",
  "指定送货顺序": "指定送货顺序",
  "行": "行",
  "列": "列",
  "显示icon图标": "显示icon图标",
  "悬浮在页面顶部": "悬浮在页面顶部",
  "商品类目管理": "商品类目管理",
  "文字": "文字",
  "活动": "活动",
  "跳转": "跳转",
  "底图": "底图",
  "色块": "色块",
  "请选择活动": "请选择活动",
  "活动已失效": "活动已失效",
  "店名": "店名",
  "推荐店铺管理": "推荐店铺管理",
  "规则选中": "规则选中",
  "默认商品排列规则": "默认商品排列规则",
  "按商品指定排序": "按商品指定排序",
  "按销量排列": "按销量排列",
  "按价格由低到高": "按价格由低到高",
  "瀑布流式商品模块": "瀑布流式商品模块",
  "通栏式商品模块": "通栏式商品模块",
  "方格式3列商品模块": "方格式3列商品模块",
  "商城端主要页面，通过组件方式自定化灵活配置，以个性化装修展现": "商城端主要页面，通过组件方式自定化灵活配置，以个性化装修展现",
  "商城经营内容的配置": "商城经营内容的配置",
  "个人中心功能开关": "个人中心功能开关",
  "团长推广背景图": "团长推广背景图",
  "商城首页有修改且未保存": "商城首页有修改且未保存",
  "商城配置有修改且未保存": "商城配置有修改且未保存",
  "数值越小越靠前": "数值越小越靠前",
  "出品率=已加工/(已领料-已退还)*100": "出品率=已加工/(已领料-已退还)*100",
  "损耗率=损耗/(领料-退还)": "损耗率=损耗/(领料-退还)",
  "每页显示{num}条": "每页显示{num}条",
  "事由": "事由",
  "一级类目": "一级类目",
  "二级类目": "二级类目",
  "收支单据": "收支单据",
  "新增类目": "新增类目",
  "级别": "级别",
  "分类类型": "分类类型",
  "收入类目": "收入类目",
  "支出类目": "支出类目",
  "新增一级分类": "新增一级分类",
  "请完善分类名称": "请完善分类名称",
  "收款单": "收款单",
  "付款单": "付款单",
  "公司运营时产生的费用支出和业务收入的财务记录": "公司运营时产生的费用支出和业务收入的财务记录",
  "用于维护收款的类目，便于分类统计": "用于维护收款的类目，便于分类统计",
  "请选择入账日期": "请选择入账日期",
  "请填写对方名称": "请填写对方名称",
  "请填写事由": "请填写事由",
  "请选择一级类目": "请选择一级类目",
  "请选择二级类目": "请选择二级类目",
  "请选择经办人": "请选择经办人",
  "收款方式": "收款方式",
  "小写": "小写",
  "大写": "大写",
  "人民币大写": "人民币大写",
  "经办": "经办",
  "入账": "入账",
  "主管": "主管",
  "出纳": "出纳",
  "①存 ②客 ③账": "①存 ②客 ③账",
  "入账日期": "入账日期",
  "收支报表": "收支报表",
  "类目维护": "类目维护",
  "对公司收付款记录进行分析统计": "对公司收付款记录进行分析统计",
  "账户报表": "账户报表",
  "一级": "一级",
  "对各账户收支记录统计": "对各账户收支记录统计",
  "期初": "期初",
  "期末": "期末",
  "收入笔数": "收入笔数",
  "收入金额": "收入金额",
  "支出笔数": "支出笔数",
  "支出金额": "支出金额",
  "笔数": "笔数",
  "比例": "比例",
  "收支概况": "收支概况",
  "盈亏": "盈亏",
  "账户统计": "账户统计",
  "账户收支明细": "账户收支明细",
  "收款类目": "收款类目",
  "创建收付款单据": "创建收付款单据",
  "生成付款记录": "生成付款记录",
  "会员等级购买": "会员等级购买",
  "销售分类统计": "销售分类统计",
  "占比": "占比",
  "小票打印": "小票打印",
  "来单自动无线打印小票": "来单自动无线打印小票",
  "指定'飞鹅'品牌无线打印机设备": "指定'飞鹅'品牌无线打印机设备",
  "机身编号": "机身编号",
  "机身密钥": "机身密钥",
  "请填写打印机机身编号": "请填写打印机机身编号",
  "请填写打印机机身密钥": "请填写打印机机身密钥",
  "绑定": "绑定",
  "订单收款": "订单收款",
  "批量星级": "批量星级",
  "设置为": "设置为",
  "生成收付款单": "生成收付款单",
  "收付款单": "收付款单",
  "收付款单据": "收付款单据",
  "订单成本": "订单成本",
  "启用：点送货出库时，订单中商品成本不自动更新": "启用：点送货出库时，订单中商品成本不自动更新",
  "门头照上传": "门头照上传",
  "营业执照上传": "营业执照上传",
  "账户信息修改": "账户信息修改",
  "不支持企业类客户自主修改账户信息": "不支持企业类客户自主修改账户信息",
  "满{ladder}{unit} {num}{yuan}/{unit}": "满{ladder}{unit} {num}{yuan}/{unit}",
  "无客诉·口碑好货": "无客诉·口碑好货",
  "同类商品销量第一": "同类商品销量第一",
  "券后{num}{yuan}/{unit}起": "券后{num}{yuan}/{unit}起",
  "时价": "时价",
  "{num}万+": "{num}万+",
  "起": "起",
  "多规格": "多规格",
  "{num}{unit}起购": "{num}{unit}起购",
  "热销": "热销",
  "秒杀": "秒杀",
  "进店": "进店",
  "企业注册": "企业注册",
  "前端商城只展示协议价商品": "前端商城只展示协议价商品",
  "收银台只展示协议价商品": "收银台只展示协议价商品",
  "加工包装统计": "加工包装统计",
  "客户补付差额": "客户补付差额",
  "新订单支付时合并一同支付": "新订单支付时合并一同支付",
  "上单的补差额在购物车结算时先行支付": "上单的补差额在购物车结算时先行支付",
  "划线价显示": "划线价显示",
  "原存量": "原存量",
  "现存量": "现存量",
  "重量过秤": "重量过秤",
  "标品点数": "标品点数",
  "总存量": "总存量",
  "上限": "上限",
  "下限": "下限",
  "搜索商品 新鲜到家": "搜索商品 新鲜到家",
  "精选推荐": "精选推荐",
  "更多": "更多",
  "去看看": "去看看",
  "推荐店铺": "推荐店铺",
  "实力商家": "实力商家",
  "优质商家": "优质商家",
  "切换站点": "切换站点",
  "距当前位置:{num}": "距当前位置:{num}",
  "导航": "导航",
  "精选推荐": "精选推荐",
  "价格特惠": "价格特惠",
  "畅销热卖": "畅销热卖",
  "宋体": "宋体",
  "黑体": "黑体",
  "楷体": "楷体",
  "属性": "属性",
  "添加组件": "添加组件",
  "保存模板后，在分拣端的设置页面，点击刷新!": "保存模板后，在分拣端的设置页面，点击刷新!",
  "采": "采",
  "刷新图片": "刷新图片",
  "选择图片": "选择图片",
  "参数": "参数",
  "文本": "文本",
  "包装品标签": "包装品标签",
  "入库标签": "入库标签",
  "分包标签": "分包标签",
  "保鲜天数": "保鲜天数",
  "分拣员名称": "分拣员名称",
  "公司地址": "公司地址",
  "指定送货日期": "指定送货日期",
  "分拣日期": "分拣日期",
  "订单编号后四位": "订单编号后四位",
  "任务编号": "任务编号",
  "商品下单备注": "商品下单备注",
  "下单单价": "下单单价",
  "实际称重": "实际称重",
  "多方案时，满减金额及等级须由小到大设置": "多方案时，满减金额及等级须由小到大设置",
  "尺寸": "尺寸",
  "加工": "加工",
  "标签打印模板": "标签打印模板",
  "显示商品库存量": "显示商品库存量",
  "添加属性": "添加属性",
  "最多创建2级属性": "最多创建2级属性",
  "属性名": "属性名",
  "属性值": "属性值",
  "最多20个": "最多20个",
  "下单量小数": "下单量小数",
  "名称拼接": "名称拼接",
  "显示时价": "显示时价",
  "商品SPU": "商品SPU",
  "规格SKU": "规格SKU",
  "库存量独立不共用": "库存量独立不共用",
  "本次采购": "本次采购",
  "采购时价": "采购时价",
  "现场支付": "现场支付",
  "单据上传": "单据上传",
  "减库存量": "减库存量",
  "请填写采购数量": "请填写采购数量",
  "采购需求": "采购需求",
  "SPU库存": "SPU库存",
  "SKU库存": "SKU库存",
  "采购进度": "采购进度",
  "到期时间": "到期时间",
  "损益原因": "损益原因",
  "商品当日应采总量": "商品当日应采总量",
  "规格当日应采总量": "规格当日应采总量",
  "商品库存": "商品库存",
  "规格库存": "规格库存",
  "对账备注": "对账备注",
  "订单毛利": "订单毛利",
  "营销": "营销",
  "报表": "报表",
  "定价管理": "定价管理",
  "采购管理": "采购管理",
  "最近一周": "最近一周",
  "最近一个月": "最近一个月",
  "最近三个月": "最近三个月",
  "上传文件不得大于{num}MB": "上传文件不得大于{num}MB",
  "取消警报": "取消警报",
  "最多可上传10张图片": "最多可上传10张图片",
  "设置库存商品成功!": "设置库存商品成功!",
  "启用：采购自动调成本时，同步更新该普通类商品的所有规格的成本": "启用：采购自动调成本时，同步更新该普通类商品的所有规格的成本",
  "历史和热搜商品显示": "历史和热搜商品显示",
  "知道了，7日不再显示": "知道了，7日不再显示",
  "永久关闭": "永久关闭",
  "付款开始日期": "付款开始日期",
  "付款结束日期": "付款结束日期",
  "送货排序": "送货排序",
  "管理后台": "管理后台",
  "管理后台-注册": "管理后台-注册",
  "管理后台-登录": "管理后台-登录",
  "订货云商贸经营管理系统": "订货云商贸经营管理系统",
  "欢迎登录-订货云商贸经营管理系统": "欢迎登录-订货云商贸经营管理系统",
  "平均售价": "平均售价",
  "审核价": "审核价",
  "定价警告": "定价警告",
  "购物车中有商品的价格超出涨跌幅度限制，确认是否提交申请定价审核?": "购物车中有商品的价格超出涨跌幅度限制，确认是否提交申请定价审核?",
  "请修改商品，或者审核申请通过后，重新提交订单": "请修改商品，或者审核申请通过后，重新提交订单",
  "提交审核": "提交审核",
  "审核定价为": "审核定价为",
  "价格审核": "价格审核",
  "环节": "环节",
  "申请信息": "申请信息",
  "申请人": "申请人",
  "申请价格": "申请价格",
  "来源": "来源",
  "审核信息": "审核信息",
  "审核人": "审核人",
  "审核时间": "审核时间",
  "审核价格": "审核价格",
  "确认拒绝该审核?": "确认拒绝该审核?",
  "指定": "指定",
  "成本利润": "成本利润",
  "成本+扣点": "成本+扣点",
  "趋势": "趋势",
  "商品定价审核": "商品定价审核",
  "定价价格都免审核直接起效": "定价价格都免审核直接起效",
  "对手动商品定价及代客下单指定价格操作时，自动联动调价不含": "对手动商品定价及代客下单指定价格操作时，自动联动调价不含",
  "定价价格都触发定价审核，审核后价格才起效": "定价价格都触发定价审核，审核后价格才起效",
  "该定价格涨幅超过$SPLIT$%，或者跌幅超过$SPLIT$%，才触发审核": "该定价格涨幅超过$SPLIT$%，或者跌幅超过$SPLIT$%，才触发审核",
  "业务员修改结算单": "业务员修改结算单",
  "启用：禁止业务员在APP端进行业务确款与修改结算单": "启用：禁止业务员在APP端进行业务确款与修改结算单",
  "规格调价": "规格调价",
  "启用：禁止在APP端的规格调价页面，进行删除和编辑规格": "启用：禁止在APP端的规格调价页面，进行删除和编辑规格",
  "关闭分包任务": "关闭分包任务",
  "启用：订单送达时，自动关闭该单未完成的商品分包任务": "启用：订单送达时，自动关闭该单未完成的商品分包任务",
  "启用：采购自动调成本时，同步更新同一加工商品的所有规格的成本": "启用：采购自动调成本时，同步更新同一加工商品的所有规格的成本",
  "启用：采购自动调成本时，自动更新所关联的包装商品的成本价格": "启用：采购自动调成本时，自动更新所关联的包装商品的成本价格",
  "显示商品规格成本价": "显示商品规格成本价",
  "允许设置商品定价": "允许设置商品定价",
  "定价审核": "定价审核",
  "打印状态": "打印状态",
  "推广奖励": "推广奖励",
  "团长代收点直接推荐的用户的消费时给予的奖励": "团长代收点直接推荐的用户的消费时给予的奖励",
  "请选择分类": "请选择分类",
  "提成方式": "提成方式",
  "按下单商品金额": "按下单商品金额",
  "按下单商品重量": "按下单商品重量",
  "默认提成": "默认提成",
  "结算优先级先后：商品提成——分类提成——默认提成": "结算优先级先后：商品提成——分类提成——默认提成",
  "不重复参与": "不重复参与",
  "提成方式": "提成方式",
  "提成信息": "提成信息",
  "提成模式": "提成模式",
  "提成时间": "提成时间",
  "当日应采总量": "当日应采总量",
  "收款人": "收款人",
  "授权人签名": "授权人签名",
  "批量提前分包": "批量提前分包",
  "m_开头为主列，若自定义勾选导出列时，必须选择最少一个主列": "m_开头为主列，若自定义勾选导出列时，必须选择最少一个主列",
  "选项": "选项",
  "导出选项": "导出选项",
  "商品分包任务分配机制": "商品分包任务分配机制",
  "付款日期": "付款日期",
  "指定日期：为指定送货日期类型订单的商品，允许进行提前生成当日任务的操作": "指定日期：为指定送货日期类型订单的商品，允许进行提前生成当日任务的操作",
  "批量提前采购": "批量提前采购",
  "提前": "提前",
  "客户下单模板": "客户下单模板",
  "下载客户下单模板": "下载客户下单模板",
  "日期格式": "日期格式",
  "禁止取消订单": "禁止取消订单",
  "商城下单时间外，已下订单不可取消": "商城下单时间外，已下订单不可取消",
  "请添加数量": "请添加数量",
  "入库单据打印设置": "入库单据打印设置",
  "打印设置": "打印设置",
  "空值": "空值",
  "分拣出库": "分拣出库",
  "启用：订单商品必须经过分拣环节才能出库操作": "启用：订单商品必须经过分拣环节才能出库操作",
  "关联单号": "关联单号",
  "周转筐": "周转筐",
  "份数": "份数",
  "新增出库": "新增出库",
  "出库单据表": "出库单据表",
  "打印区域": "打印区域",
  "打印宽度": "打印宽度",
  "表格内容超出将被打印不出": "表格内容超出将被打印不出",
  "标题栏": "标题栏",
  "标题": "标题",
  "字号": "字号",
  "加粗": "加粗",
  "行高": "行高",
  "页头": "页头",
  "页尾": "页尾",
  "顺序": "顺序",
  "取值": "取值",
  "页尾签名": "页尾签名",
  "一行4个": "一行4个",
  "固定签名": "固定签名",
  "设置": "设置",
  "分栏": "分栏",
  "分页重复打印页头": "分页重复打印页头",
  "表格区域": "表格区域",
  "表项字段": "表项字段",
  "宽度": "宽度",
  "表格记录": "表格记录",
  "表格行高": "表格行高",
  "固定空行": "固定空行",
  "商品优先按分类归类排列": "商品优先按分类归类排列",
  "商品分类横向一行": "商品分类横向一行",
  "数据项中打印单位": "数据项中打印单位",
  "分拣缺货的商品要打印": "分拣缺货的商品要打印",
  "合计栏": "合计栏",
  "体现下单金额": "体现下单金额",
  "体现运费": "体现运费",
  "体现优惠金额积分抵扣": "体现优惠金额积分抵扣",
  "体现出库金额": "体现出库金额",
  "体现合计金额": "体现合计金额",
  "如": "如",
  "下单金额{num}{yuan}": "下单金额{num}{yuan}",
  "运费{num}{yuan}": "运费{num}{yuan}",
  "优惠{num}{yuan}": "优惠{num}{yuan}",
  "出库金额{num}{yuan}": "出库金额{num}{yuan}",
  "出库含周转筐押金": "出库含周转筐押金",
  "合计金额{num}{yuan}": "合计金额{num}{yuan}",
  "合计=出库+运费+代采费-优惠": "合计=出库+运费+代采费-优惠",
  "附表说明区域": "附表说明区域",
  "右侧联别": "右侧联别",
  "右侧竖向联别": "右侧竖向联别",
  "预览": "预览",
  "客户电话": "客户电话",
  "送货线路": "送货线路",
  "送达时间": "送达时间",
  "基础单位": "基础单位",
  "基础单价": "基础单价",
  "基础下单量": "基础下单量",
  "规格成本": "规格成本",
  "基础成本": "基础成本",
  "折扣单价": "折扣单价",
  "折扣率": "折扣率",
  "规格出库数量": "规格出库数量",
  "基础出库数量": "基础出库数量",
  "请选择标准类型的打印模板": "请选择标准类型的打印模板",
  "自定义模板": "自定义模板",
  "单位数量必须大于0!": "单位数量必须大于0!",
  "请完善规格信息": "请完善规格信息",
  "业务查看全部供应商": "业务查看全部供应商",
  "单价同步协议价": "单价同步协议价",
  "净重审核": "净重审核",
  "去皮审核": "去皮审核",
  "领料出库": "领料出库",
  "无可打印商品": "无可打印商品",
  "打印失败": "打印失败",
  "缺货商品": "缺货商品",
  "公司名称": "公司名称",
  "编号名称": "编号名称",
  "日期名称": "日期名称",
  "批量星级不可见": "批量星级不可见",
  "设置规格不可见": "设置规格不可见",
  "设置星级后，对应的星级客户在小程序不可见此规格": "设置星级后，对应的星级客户在小程序不可见此规格",
  "不可见": "不可见",
  "送货方": "送货方",
  "收货方": "收货方",
  "请完善转单数据": "请完善转单数据",
  "回库量": "回库量",
  "猜你喜欢商品推荐": "猜你喜欢商品推荐",
  "商品售后": "商品售后",
  "必须上传图片证据": "必须上传图片证据",
  "订单商品金额小数位计算": "订单商品金额小数位计算",
  "两位小数，余数四舍五入": "两位小数，余数四舍五入",
  "一位小数，余数全舍弃": "一位小数，余数全舍弃",
  "针对线下结算类型订单，认单在执行出库操作时，将按此处理商品金额小数，及订单总额": "针对线下结算类型订单，认单在执行出库操作时，将按此处理商品金额小数，及订单总额",
  "TFG": "TFG",
  "平台": "平台",
  "公司旗下": "公司旗下",
  "JustGreen 生鲜ERP系统": "JustGreen 生鲜ERP系统",
  "采购任务导出": "采购任务导出",
  "明细换行": "明细换行",
  "明细不换行": "明细不换行",
  "无可匹配商品": "无可匹配商品",
  "未匹配": "未匹配",
  "匹配失败": "匹配失败",
  "无数据": "无数据",
  "匹配多条数据": "匹配多条数据",
  "匹配中": "匹配中",
  "未匹配成功": "未匹配成功",
  "匹配商品": "匹配商品",
  "商品成品率低于$SPLIT$%时进行警告": "商品成品率低于$SPLIT$%时进行警告",
  "低成品率警告（近1日）": "低成品率警告（近1日）",
  "请选择商品名称": "请选择商品名称",
  "客户行业类别": "客户行业类别",
  "税率税费": "税率税费",
  "寄售销售表": "寄售销售表",
  "导入销售表": "导入销售表",
  "下载销售表模板": "下载销售表模板",
  "清空销售记录": "清空销售记录",
  "分拣成品统计": "分拣成品统计",
  "按分拣员统计": "按分拣员统计",
  "成品率": "成品率",
  "出品率=已分拣/(已领料-已退还)*100": "出品率=已分拣/(已领料-已退还)*100",
  "损耗量=已领料-已退还-已分拣": "损耗量=已领料-已退还-已分拣",
  "成品率": "成品率",
  "应分拣": "应分拣",
  "国家": "国家",
  "中国": "中国",
  "美国": "美国",
  "泰国": "泰国",
  "柬埔寨": "柬埔寨",
  "公众号APPID": "公众号APPID",
  "公众号密钥": "公众号密钥",
  "超量记差额": "超量记差额",
  "应采=商品下单量的汇总数": "应采=商品下单量的汇总数",
  "损耗=下单量*损耗率": "损耗=下单量*损耗率",
  "已采=本商品今日已采购数量": "已采=本商品今日已采购数量",
  "库存=本商品当前库存量": "库存=本商品当前库存量",
  "建议量=应采+损耗-已采-库存；为0表示库存足": "建议量=应采+损耗-已采-库存；为0表示库存足",
  "20000字以内": "20000字以内",
  "24时订单": "24时订单",
  "3000字以内": "3000字以内",
  "32字符内": "32字符内",
  "50字内,默认为空": "50字内,默认为空",
  "APP 微信appid": "APP 微信appid",
  "APP 支付宝appid": "APP 支付宝appid",
  "APP 支付宝公钥": "APP 支付宝公钥",
  "APP 支付宝私钥": "APP 支付宝私钥",
  "APP工作端配送员送达拍照功能": "APP工作端配送员送达拍照功能",
  "APP端": "APP端",
  "B账": "B账",
  "Ctrl加方向键切换表格项": "Ctrl加方向键切换表格项",
  "EXCEL下单": "EXCEL下单",
  "IP地址": "IP地址",
  "PC端": "PC端",
  "PC管理端": "PC管理端",
  "Tab表格录单": "Tab表格录单",
  "[平台名称] 您的订单[订单号后6位]下单已出库，请注意收货!": "[平台名称] 您的订单[订单号后6位]下单已出库，请注意收货!",
  "[平台名称] 您的订单[订单号后6位]下单成功!": "[平台名称] 您的订单[订单号后6位]下单成功!",
  "[平台名称] 您的订单[订单号后6位]订单已取消!": "[平台名称] 您的订单[订单号后6位]订单已取消!",
  "[平台名称] 您的订单[订单号后6位]订单已送达!": "[平台名称] 您的订单[订单号后6位]订单已送达!",
  "appid不能为空": "appid不能为空",
  "logo不能为空": "logo不能为空",
  "yyyy年MM月dd日": "yyyy年MM月dd日",
  "{date}{name} 配送结果": "{date}{name} 配送结果",
  "{num}{yuan}/月": "{num}{yuan}/月",
  "{num}天": "{num}天",
  "{num}天周期": "{num}天周期",
  "{num}日": "{num}日",
  "{num}条记录": "{num}条记录",
  "起送：$SPLIT${yuan}/单，$SPLIT$公里内免费": "起送：$SPLIT${yuan}/单，$SPLIT$公里内免费",
  "①存根白 ②客户红 ③回单黄": "①存根白 ②客户红 ③回单黄",
  "一个客户单位只分配到一条送货线路，如已分配，请在原线路删除后，在此处添加": "一个客户单位只分配到一条送货线路，如已分配，请在原线路删除后，在此处添加",
  "一个订单内促销商品总额满": "一个订单内促销商品总额满",
  "一位小数": "一位小数",
  "一分钟注册": "一分钟注册",
  "一单购买数量 ≥$SPLIT${unit}时，毛利$SPLIT${yuan}/{unit}": "一单购买数量 ≥$SPLIT${unit}时，毛利$SPLIT${yuan}/{unit}",
  "一周前": "一周前",
  "一级分类": "一级分类",
  "一级标签": "一级标签",
  "一键关闭库存量足任务": "一键关闭库存量足任务",
  "一键库存量为负数置零": "一键库存量为负数置零",
  "三级标签": "三级标签",
  "上一级区域仓": "上一级区域仓",
  "上下架状态": "上下架状态",
  "上传凭证": "上传凭证",
  "上传图片": "上传图片",
  "上传图片只能是 jpg、jpeg、png 格式!": "上传图片只能是 jpg、jpeg、png 格式!",
  "上传图片大小不能超过 2MB!": "上传图片大小不能超过 2MB!",
  "上报单位": "上报单位",
  "上报岗位人员姓名": "上报岗位人员姓名",
  "上报时间/岗位人员": "上报时间/岗位人员",
  "上架": "上架",
  "上架中": "上架中",
  "上架商品前，请确认商品分类、价格方案": "上架商品前，请确认商品分类、价格方案",
  "上架成功": "上架成功",
  "上级主公司": "上级主公司",
  "上级岗位": "上级岗位",
  "上限警报": "上限警报",
  "下单出借": "下单出借",
  "下单利润": "下单利润",
  "下单商品统计": "下单商品统计",
  "下单客户": "下单客户",
  "下单客户排名": "下单客户排名",
  "下单客户数": "下单客户数",
  "下单开始日期": "下单开始日期",
  "下单开始时间": "下单开始时间",
  "下单开始时间不能为空": "下单开始时间不能为空",
  "下单总量": "下单总量",
  "下单总量是否打印": "下单总量是否打印",
  "下单成功通知": "下单成功通知",
  "下单数量": "下单数量",
  "下单数量：订单商品的下单数量*售价的和": "下单数量：订单商品的下单数量*售价的和",
  "下单方式": "下单方式",
  "下单日期": "下单日期",
  "下单时间": "下单时间",
  "下单时间不能相同!": "下单时间不能相同!",
  "下单结束日期": "下单结束日期",
  "下单结束时间": "下单结束时间",
  "下单采购成本": "下单采购成本",
  "下单量": "下单量",
  "下单量采购成本": "下单量采购成本",
  "下单金额": "下单金额",
  "下单金额是否打印": "下单金额是否打印",
  "下发订单": "下发订单",
  "下架": "下架",
  "下架中": "下架中",
  "下架成功": "下架成功",
  "下架时间": "下架时间",
  "下载": "下载",
  "下载Excel模板": "下载Excel模板",
  "下载商品清单模板": "下载商品清单模板",
  "下载导入模板": "下载导入模板",
  "下载模板": "下载模板",
  "下限警报": "下限警报",
  "不允许小数": "不允许小数",
  "不创建出入库记录": "不创建出入库记录",
  "不勾选则兼顾非会员制用户下单": "不勾选则兼顾非会员制用户下单",
  "不可全部删除": "不可全部删除",
  "不可提交相同规格商品": "不可提交相同规格商品",
  "不合并": "不合并",
  "不同状态下不能发起多单收款，请选择相同状态订单": "不同状态下不能发起多单收款，请选择相同状态订单",
  "不含：协议价、指定价、特价商品": "不含：协议价、指定价、特价商品",
  "不启用": "不启用",
  "不打印": "不打印",
  "不打印分拣员": "不打印分拣员",
  "不打印单价、金额、合计": "不打印单价、金额、合计",
  "不显示": "不显示",
  "不显示库存量为0的商品": "不显示库存量为0的商品",
  "不能低于最低起购量!请检查购买数量": "不能低于最低起购量!请检查购买数量",
  "业务": "业务",
  "业务专员": "业务专员",
  "业务人员": "业务人员",
  "业务协议": "业务协议",
  "业务单号": "业务单号",
  "业务单号/送货单": "业务单号/送货单",
  "业务员": "业务员",
  "业务员业绩排名": "业务员业绩排名",
  "业务员抽成金额": "业务员抽成金额",
  "业务员提成": "业务员提成",
  "业务员提成：按账户创建关系，该客户的订单进行提成": "业务员提成：按账户创建关系，该客户的订单进行提成",
  "业务员查看全部订单": "业务员查看全部订单",
  "业务员编辑客户折扣": "业务员编辑客户折扣",
  "业务员编辑客户是否可修改折扣和星级": "业务员编辑客户是否可修改折扣和星级",
  "业务总额": "业务总额",
  "业务提成": "业务提成",
  "业务统计": "业务统计",
  "业务订单": "业务订单",
  "两位小数": "两位小数",
  "严格分拣流程，统计分拣损耗": "严格分拣流程，统计分拣损耗",
  "个": "个",
  "个人": "个人",
  "个人中心供货商申请": "个人中心供货商申请",
  "个人中心广告位": "个人中心广告位",
  "个人中心背景图": "个人中心背景图",
  "个人信息授权": "个人信息授权",
  "个人名称或账号": "个人名称或账号",
  "个人客户": "个人客户",
  "个人用户": "个人用户",
  "中转篮筐押金": "中转篮筐押金",
  "临时补单": "临时补单",
  "主动说明": "主动说明",
  "主营": "主营",
  "主营商品": "主营商品",
  "主语言": "主语言",
  "主账号": "主账号",
  "主账号密码": "主账号密码",
  "主页公告": "主页公告",
  "主页背景": "主页背景",
  "主题促销区": "主题促销区",
  "主题活动": "主题活动",
  "主题活动二": "主题活动二",
  "主题活动管理": "主题活动管理",
  "举例：设置客户账期为周六，今天刚好到周六了，那么周六之前有订单未结算的 话则无法下单；此时将结账日调整到周日或者周一，就又可以下单了": "举例：设置客户账期为周六，今天刚好到周六了，那么周六之前有订单未结算的 话则无法下单；此时将结账日调整到周日或者周一，就又可以下单了",
  "乙方签字盖章": "乙方签字盖章",
  "买赔": "买赔",
  "买赔对象": "买赔对象",
  "买赔数量": "买赔数量",
  "二级分类": "二级分类",
  "二维码": "二维码",
  "亏损": "亏损",
  "云商品库": "云商品库",
  "交强保险单": "交强保险单",
  "交易日期": "交易日期",
  "交易类型": "交易类型",
  "产品": "产品",
  "产品溯源": "产品溯源",
  "产地": "产地",
  "产地溯源": "产地溯源",
  "享受权益期间的货品代买和配送上门服务，时间到期或代买额度不足就不能下单了。订单货款另外结算。": "享受权益期间的货品代买和配送上门服务，时间到期或代买额度不足就不能下单了。订单货款另外结算。",
  "人为遗失损耗": "人为遗失损耗",
  "人员": "人员",
  "人员头像": "人员头像",
  "人员姓名": "人员姓名",
  "人员性别": "人员性别",
  "人员筛选": "人员筛选",
  "人员绩效": "人员绩效",
  "人员账号 (点击员工账号可编辑)": "人员账号 (点击员工账号可编辑)",
  "人员账号配置": "人员账号配置",
  "人数": "人数",
  "仅一个仓库有效": "仅一个仓库有效",
  "仅付费会员用户才能下单": "仅付费会员用户才能下单",
  "仅限商圈内地址的客户才能下单": "仅限商圈内地址的客户才能下单",
  "今天": "今天",
  "今日下单": "今日下单",
  "今日任务": "今日任务",
  "今日概况": "今日概况",
  "今日特价分类": "今日特价分类",
  "今日经营": "今日经营",
  "今日订单": "今日订单",
  "今日销售额": "今日销售额",
  "今日销量": "今日销量",
  "仓库": "仓库",
  "仓库仓位": "仓库仓位",
  "仓库信息": "仓库信息",
  "仓库入库操作时的成本价自动成为售卖方式的成本价": "仓库入库操作时的成本价自动成为售卖方式的成本价",
  "仓库区域": "仓库区域",
  "仓库名称": "仓库名称",
  "仓库收到": "仓库收到",
  "仓库收货": "仓库收货",
  "仓库管理": "仓库管理",
  "仓库详情": "仓库详情",
  "仓库领料": "仓库领料",
  "仓管人员": "仓管人员",
  "付款": "付款",
  "付款企业名称": "付款企业名称",
  "付款方式": "付款方式",
  "付款类型": "付款类型",
  "付款统计": "付款统计",
  "付款记录": "付款记录",
  "付款金额": "付款金额",
  "付讫": "付讫",
  "付讫状态": "付讫状态",
  "付费会员制": "付费会员制",
  "代买额度": "代买额度",
  "代客": "代客",
  "代客下单": "代客下单",
  "代客下单完成!": "代客下单完成!",
  "代客下单流程": "代客下单流程",
  "代收": "代收",
  "代收点": "代收点",
  "代收点地址": "代收点地址",
  "代收点提成": "代收点提成",
  "代收点提成：按关联绑定关系，所关联的个人用户订单进行提成": "代收点提成：按关联绑定关系，所关联的个人用户订单进行提成",
  "以“EXCEL下单”或“微信下单”生成客户商品清单": "以“EXCEL下单”或“微信下单”生成客户商品清单",
  "以后该客户都使用该模板格式": "以后该客户都使用该模板格式",
  "以此时间点起止的24小时周期，为本配送中心的运营时间，解决跨天运营情况": "以此时间点起止的24小时周期，为本配送中心的运营时间，解决跨天运营情况",
  "件": "件",
  "价格": "价格",
  "价格信息": "价格信息",
  "价格公式": "价格公式",
  "价格区间不可见": "价格区间不可见",
  "价格必须大于0": "价格必须大于0",
  "价格折扣": "价格折扣",
  "价格最多输入两位小数": "价格最多输入两位小数",
  "价格核算先后机制": "价格核算先后机制",
  "价格走势首页显示": "价格走势首页显示",
  "任务主线": "任务主线",
  "任务数": "任务数",
  "任务状态": "任务状态",
  "任务详情": "任务详情",
  "份": "份",
  "份量": "份量",
  "企业": "企业",
  "企业LOGO": "企业LOGO",
  "企业传真": "企业传真",
  "企业名称": "企业名称",
  "企业地址": "企业地址",
  "企业客户": "企业客户",
  "企业微信客服": "企业微信客服",
  "企业概要介绍": "企业概要介绍",
  "企业注册号": "企业注册号",
  "企业用户": "企业用户",
  "企业电话": "企业电话",
  "企业简介": "企业简介",
  "企业编号": "企业编号",
  "企业编码": "企业编码",
  "优化若干问题": "优化若干问题",
  "优惠": "优惠",
  "优惠减扣": "优惠减扣",
  "优惠券": "优惠券",
  "优惠券审核": "优惠券审核",
  "优惠券页主图": "优惠券页主图",
  "优惠卡券": "优惠卡券",
  "优惠折扣": "优惠折扣",
  "会员价/月": "会员价/月",
  "会员价格": "会员价格",
  "会员权益": "会员权益",
  "会员等级": "会员等级",
  "会员管理": "会员管理",
  "传真": "传真",
  "位置": "位置",
  "低量警报": "低量警报",
  "余料退还": "余料退还",
  "余量": "余量",
  "余额": "余额",
  "余额流水": "余额流水",
  "余额调节": "余额调节",
  "使用": "使用",
  "使用中": "使用中",
  "使用均衡成本": "使用均衡成本",
  "使用帮助": "使用帮助",
  "使用情况": "使用情况",
  "供应": "供应",
  "供应单": "供应单",
  "供应商": "供应商",
  "供应商+采购员": "供应商+采购员",
  "供应商APP商品价格权限：开启后可设置售价，关闭可设置成本价": "供应商APP商品价格权限：开启后可设置售价，关闭可设置成本价",
  "供应商入驻协议": "供应商入驻协议",
  "供应商名称": "供应商名称",
  "供应商名称搜索": "供应商名称搜索",
  "供应商周期结算": "供应商周期结算",
  "供应商商品上架审核": "供应商商品上架审核",
  "供应商商品权限": "供应商商品权限",
  "供应商商品的库存余量及每日供应量作为下单依据": "供应商商品的库存余量及每日供应量作为下单依据",
  "供应商店推荐": "供应商店推荐",
  "供应商店铺": "供应商店铺",
  "供应商承担金额": "供应商承担金额",
  "供应商新增商品由平台审核": "供应商新增商品由平台审核",
  "供应商来筐": "供应商来筐",
  "供应商清单+采购员": "供应商清单+采购员",
  "供应商管理": "供应商管理",
  "供应商结算单": "供应商结算单",
  "供应对账结算": "供应对账结算",
  "供应库存": "供应库存",
  "供应报账申请": "供应报账申请",
  "供应清单": "供应清单",
  "供应退货": "供应退货",
  "供货": "供货",
  "供货中": "供货中",
  "供货人员": "供货人员",
  "供货价": "供货价",
  "供货任务": "供货任务",
  "供货任务数据列表": "供货任务数据列表",
  "供货任务清单": "供货任务清单",
  "供货单": "供货单",
  "供货员": "供货员",
  "供货商": "供货商",
  "供货商LOGO": "供货商LOGO",
  "供货商信息": "供货商信息",
  "供货商分拣任务是否显示客户名称": "供货商分拣任务是否显示客户名称",
  "供货商名称": "供货商名称",
  "供货商品待审核": "供货商品待审核",
  "供货商商品": "供货商商品",
  "供货商家": "供货商家",
  "供货商家名称": "供货商家名称",
  "供货商店铺主页": "供货商店铺主页",
  "供货商显示客户名称": "供货商显示客户名称",
  "供货商申请入驻注册": "供货商申请入驻注册",
  "供货商管理": "供货商管理",
  "供货完成度": "供货完成度",
  "供货对方": "供货对方",
  "供货对账单": "供货对账单",
  "供货成功": "供货成功",
  "供货支出": "供货支出",
  "供货数量": "供货数量",
  "供货时间": "供货时间",
  "供货来源": "供货来源",
  "供货状态": "供货状态",
  "供货重量": "供货重量",
  "供货量": "供货量",
  "供货金额": "供货金额",
  "促销": "促销",
  "促销商品": "促销商品",
  "保存": "保存",
  "保存关联并提交": "保存关联并提交",
  "保存后生效": "保存后生效",
  "保存已收金额": "保存已收金额",
  "保存成功": "保存成功",
  "保质": "保质",
  "保质到期": "保质到期",
  "保质期": "保质期",
  "修改": "修改",
  "修改为": "修改为",
  "修改后再导入刚才的文件即可": "修改后再导入刚才的文件即可",
  "修改密码": "修改密码",
  "修改成功": "修改成功",
  "修改报价": "修改报价",
  "修改数量": "修改数量",
  "修改结算": "修改结算",
  "修改结算金额": "修改结算金额",
  "修改补录送货单": "修改补录送货单",
  "修改退款金额": "修改退款金额",
  "借出数": "借出数",
  "停售中": "停售中",
  "停用": "停用",
  "元": "元",
  "充值余额": "充值余额",
  "免费使用": "免费使用",
  "免配送费不能为空": "免配送费不能为空",
  "免配送费标准": "免配送费标准",
  "入住时间": "入住时间",
  "入库": "入库",
  "入库份量": "入库份量",
  "入库制单人": "入库制单人",
  "入库单": "入库单",
  "入库单价": "入库单价",
  "入库单号": "入库单号",
  "入库单备注": "入库单备注",
  "入库单据表": "入库单据表",
  "入库单数": "入库单数",
  "入库单自定义编号": "入库单自定义编号",
  "入库商品{num}种": "入库商品{num}种",
  "入库完成度": "入库完成度",
  "入库审核修改": "入库审核修改",
  "入库待结算": "入库待结算",
  "入库总价": "入库总价",
  "入库总金额": "入库总金额",
  "入库成功": "入库成功",
  "入库批次号": "入库批次号",
  "入库操作": "入库操作",
  "入库数量": "入库数量",
  "入库时不会强制商品和供应商关系": "入库时不会强制商品和供应商关系",
  "入库时将强制供货商关系，跟进库存数量": "入库时将强制供货商关系，跟进库存数量",
  "入库时间": "入库时间",
  "入库类型": "入库类型",
  "入库重量": "入库重量",
  "入库量": "入库量",
  "入库量(必填)": "入库量(必填)",
  "入库量/剩余单位量": "入库量/剩余单位量",
  "入库量不能为0": "入库量不能为0",
  "入库金额": "入库金额",
  "入库额": "入库额",
  "全屏": "全屏",
  "全选": "全选",
  "全部": "全部",
  "全部付款": "全部付款",
  "全部付款金额": "全部付款金额",
  "全部分类": "全部分类",
  "全部到款": "全部到款",
  "全部加入单的商品": "全部加入单的商品",
  "全部商品": "全部商品",
  "全部客户": "全部客户",
  "全部支付": "全部支付",
  "全部收款": "全部收款",
  "全部标识": "全部标识",
  "全部正常验货": "全部正常验货",
  "全部状态": "全部状态",
  "全部装车": "全部装车",
  "全部金额": "全部金额",
  "公司": "公司",
  "公告": "公告",
  "公告内容": "公告内容",
  "公告头条": "公告头条",
  "公告头条区": "公告头条区",
  "公斤": "公斤",
  "共": "共",
  "共{num}个单位待分包操作": "共{num}个单位待分包操作",
  "共{num}个商品待分拣": "共{num}个商品待分拣",
  "共{num}人": "共{num}人",
  "关于我们": "关于我们",
  "关联下级人员": "关联下级人员",
  "关联个人用户数": "关联个人用户数",
  "关联商品": "关联商品",
  "关联客户": "关联客户",
  "关联采购单": "关联采购单",
  "关键词": "关键词",
  "关闭": "关闭",
  "关闭其他": "关闭其他",
  "关闭异常": "关闭异常",
  "关闭成功": "关闭成功",
  "关闭所有": "关闭所有",
  "其中": "其中",
  "其中在线支付": "其中在线支付",
  "其他": "其他",
  "其他入库": "其他入库",
  "其他出库": "其他出库",
  "其他结算": "其他结算",
  "其他补充": "其他补充",
  "其它": "其它",
  "其它结算": "其它结算",
  "内容": "内容",
  "内容优化": "内容优化",
  "内容统计": "内容统计",
  "内容详情": "内容详情",
  "内部链接": "内部链接",
  "内链": "内链",
  "农残检测": "农残检测",
  "农残检测详情": "农残检测详情",
  "冲账入库": "冲账入库",
  "冲账出库": "冲账出库",
  "冻结": "冻结",
  "净重": "净重",
  "净重审核入库": "净重审核入库",
  "净重审核出库": "净重审核出库",
  "减": "减",
  "减去": "减去",
  "减扣": "减扣",
  "减钱": "减钱",
  "凭证": "凭证",
  "凭证上传": "凭证上传",
  "出产地": "出产地",
  "出借中": "出借中",
  "出借信息": "出借信息",
  "出借数量": "出借数量",
  "出借时间": "出借时间",
  "出借记录": "出借记录",
  "出入库凭证": "出入库凭证",
  "出入库商品": "出入库商品",
  "出入库操作": "出入库操作",
  "出入库日志": "出入库日志",
  "出库": "出库",
  "出库24小时收货后自动发起结算": "出库24小时收货后自动发起结算",
  "出库任务": "出库任务",
  "出库份数": "出库份数",
  "出库利润": "出库利润",
  "出库制单人": "出库制单人",
  "出库单": "出库单",
  "出库单中商品信息，可点击“验货”按钮进行修改。": "出库单中商品信息，可点击“验货”按钮进行修改。",
  "出库单价": "出库单价",
  "出库单数": "出库单数",
  "出库商品": "出库商品",
  "出库总额": "出库总额",
  "出库成本": "出库成本",
  "出库操作为订单发货必要环节。": "出库操作为订单发货必要环节。",
  "出库数量": "出库数量",
  "出库日期": "出库日期",
  "出库时间": "出库时间",
  "出库类型": "出库类型",
  "出库送货单": "出库送货单",
  "出库配送": "出库配送",
  "出库量": "出库量",
  "出库量利润": "出库量利润",
  "出库量成本": "出库量成本",
  "出库金额": "出库金额",
  "出库额": "出库额",
  "出货": "出货",
  "出货成本：订单商品的实际出货数量*成本价的和": "出货成本：订单商品的实际出货数量*成本价的和",
  "出货金额": "出货金额",
  "出货金额：订单商品的实际出货数量*售单价的和": "出货金额：订单商品的实际出货数量*售单价的和",
  "分割商品利润": "分割商品利润",
  "分割子商品": "分割子商品",
  "分包": "分包",
  "分包任务": "分包任务",
  "分包任务清单": "分包任务清单",
  "分包分拣端": "分包分拣端",
  "分包员": "分包员",
  "分包报缺损": "分包报缺损",
  "分包明细": "分包明细",
  "分包缺货": "分包缺货",
  "分拣": "分拣",
  "分拣人员": "分拣人员",
  "分拣任务": "分拣任务",
  "分拣任务清单": "分拣任务清单",
  "分拣分包": "分拣分包",
  "分拣包装": "分拣包装",
  "分拣员": "分拣员",
  "分拣员查看全部任务": "分拣员查看全部任务",
  "分拣员签字": "分拣员签字",
  "分拣商品": "分拣商品",
  "分拣报缺损": "分拣报缺损",
  "分拣损耗": "分拣损耗",
  "分拣损耗/斤</br>(领料量-还料量-分拣量)": "分拣损耗/斤</br>(领料量-还料量-分拣量)",
  "分拣操作": "分拣操作",
  "分拣数量": "分拣数量",
  "分拣清单": "分拣清单",
  "分拣端": "分拣端",
  "分拣管理": "分拣管理",
  "分拣缺货": "分拣缺货",
  "分拣进度": "分拣进度",
  "分拣领料": "分拣领料",
  "分类": "分类",
  "分类名称": "分类名称",
  "分类排序": "分类排序",
  "分类提成比例必须大于0": "分类提成比例必须大于0",
  "分类未设置提成的，按默认比例结算": "分类未设置提成的，按默认比例结算",
  "分类比例": "分类比例",
  "切换语言将刷新页面，确认继续切换?": "切换语言将刷新页面，确认继续切换?",
  "创建": "创建",
  "创建个人账号": "创建个人账号",
  "创建任务时间": "创建任务时间",
  "创建优惠券": "创建优惠券",
  "创建供应商": "创建供应商",
  "创建促销": "创建促销",
  "创建入库": "创建入库",
  "创建出库": "创建出库",
  "创建商品": "创建商品",
  "创建对账单": "创建对账单",
  "创建对账单成功!": "创建对账单成功!",
  "创建并制单成功": "创建并制单成功",
  "创建开始日期": "创建开始日期",
  "创建开始时间": "创建开始时间",
  "创建新供货商": "创建新供货商",
  "创建新卡券": "创建新卡券",
  "创建时间": "创建时间",
  "创建活动": "创建活动",
  "创建特价活动": "创建特价活动",
  "创建结束日期": "创建结束日期",
  "创建结束时间": "创建结束时间",
  "创建结算": "创建结算",
  "创建配送路线": "创建配送路线",
  "初期利润": "初期利润",
  "删子单": "删子单",
  "删除": "删除",
  "删除人员账号": "删除人员账号",
  "删除商品": "删除商品",
  "删除成功": "删除成功",
  "删除报价": "删除报价",
  "删除角色岗位": "删除角色岗位",
  "利润": "利润",
  "利润 = 出库额 - (初期库存额 + 入库额 -期末节余额)": "利润 = 出库额 - (初期库存额 + 入库额 -期末节余额)",
  "利润合计": "利润合计",
  "利润方式": "利润方式",
  "利润比例 = 成本价 × $SPLIT$%": "利润比例 = 成本价 × $SPLIT$%",
  "利润比率": "利润比率",
  "利润率": "利润率",
  "利润率需大于0小于100": "利润率需大于0小于100",
  "利润金额": "利润金额",
  "利润预估": "利润预估",
  "利润：出货金额-出货成本": "利润：出货金额-出货成本",
  "别名": "别名",
  "到付": "到付",
  "到款开始日期": "到款开始日期",
  "到款收款": "到款收款",
  "到款结束日期": "到款结束日期",
  "到款账户": "到款账户",
  "制单": "制单",
  "制单人": "制单人",
  "制单人员": "制单人员",
  "制单员": "制单员",
  "制单收付": "制单收付",
  "制单时间": "制单时间",
  "制定采购": "制定采购",
  "制定顺序": "制定顺序",
  "制表": "制表",
  "制表时间": "制表时间",
  "刷新": "刷新",
  "刷新排序": "刷新排序",
  "剩余": "剩余",
  "剩余差额": "剩余差额",
  "剩余应付": "剩余应付",
  "剩余应付款": "剩余应付款",
  "剩余应收": "剩余应收",
  "剩余应收款": "剩余应收款",
  "剩余短信数": "剩余短信数",
  "剩余量": "剩余量",
  "功能": "功能",
  "加": "加",
  "加入对账统计": "加入对账统计",
  "加入特价清单": "加入特价清单",
  "加入采购计划": "加入采购计划",
  "加工任务列表": "加工任务列表",
  "加工品入库": "加工品入库",
  "加工商品": "加工商品",
  "加工工序": "加工工序",
  "加工工艺管理": "加工工艺管理",
  "加工标准": "加工标准",
  "加工状态": "加工状态",
  "加工费": "加工费",
  "加载中": "加载中",
  "加载更多": "加载更多",
  "加钱": "加钱",
  "勾选后客户不可见": "勾选后客户不可见",
  "包": "包",
  "包ID": "包ID",
  "包含运费": "包含运费",
  "包装": "包装",
  "包装份数": "包装份数",
  "包装商品": "包装商品",
  "包装商品的子商品不能为空": "包装商品的子商品不能为空",
  "包装成本": "包装成本",
  "包装物": "包装物",
  "包装费": "包装费",
  "包装重量": "包装重量",
  "匹配商品": "匹配商品",
  "匹配完成后，请校对商品，再加入购物车": "匹配完成后，请校对商品，再加入购物车",
  "区域仓库名称": "区域仓库名称",
  "区域仓库地址": "区域仓库地址",
  "区域仓库简称": "区域仓库简称",
  "区域仓负责人": "区域仓负责人",
  "区域合作提成": "区域合作提成",
  "区域合作提成：按配送电子围栏区域内的用户订单进行提成": "区域合作提成：按配送电子围栏区域内的用户订单进行提成",
  "升级方式": "升级方式",
  "半价秒杀": "半价秒杀",
  "半价秒杀页主图": "半价秒杀页主图",
  "协": "协",
  "协议价": "协议价",
  "协议价导入": "协议价导入",
  "协议报价单": "协议报价单",
  "单": "单",
  "单个分页打印是否打印表头": "单个分页打印是否打印表头",
  "单个规格可选": "单个规格可选",
  "单价": "单价",
  "单价/单位": "单价/单位",
  "单价不能小于0": "单价不能小于0",
  "单位": "单位",
  "单位如袋 瓶": "单位如袋 瓶",
  "单位数量": "单位数量",
  "单位数量时的售价": "单位数量时的售价",
  "单位数量时的成本": "单位数量时的成本",
  "单位领导签字": "单位领导签字",
  "单号": "单号",
  "单号/自定义编号": "单号/自定义编号",
  "单号/自编号": "单号/自编号",
  "单号备注": "单号备注",
  "单品采购入库": "单品采购入库",
  "单据": "单据",
  "单据信息": "单据信息",
  "单据备注": "单据备注",
  "单据拍照上传": "单据拍照上传",
  "单据状态": "单据状态",
  "单据金额": "单据金额",
  "单数": "单数",
  "单笔出库": "单笔出库",
  "单笔盘点": "单笔盘点",
  "单页打印列表行数": "单页打印列表行数",
  "卡券ID": "卡券ID",
  "卡券信息": "卡券信息",
  "卡券名称": "卡券名称",
  "卡券权益说明": "卡券权益说明",
  "卡号": "卡号",
  "卡户名字": "卡户名字",
  "即时": "即时",
  "即时送": "即时送",
  "即时配送": "即时配送",
  "历史购买": "历史购买",
  "原价": "原价",
  "原价上涨": "原价上涨",
  "原价下调": "原价下调",
  "原供采方": "原供采方",
  "原因": "原因",
  "原数据导出": "原数据导出",
  "原料加工清单": "原料加工清单",
  "原送货单号": "原送货单号",
  "原食材选择": "原食材选择",
  "去皮": "去皮",
  "去皮审核入": "去皮审核入",
  "去皮审核出库": "去皮审核出库",
  "去皮数量不能高于商品数量": "去皮数量不能高于商品数量",
  "去绘制商圈": "去绘制商圈",
  "参与报价": "参与报价",
  "参数错误": "参数错误",
  "反馈人": "反馈人",
  "发卡": "发卡",
  "发卡商家": "发卡商家",
  "发布时间": "发布时间",
  "发票": "发票",
  "发票到期时间": "发票到期时间",
  "发票号": "发票号",
  "发票开具": "发票开具",
  "发票日期": "发票日期",
  "发票编号": "发票编号",
  "发结算-待付款": "发结算-待付款",
  "发结算-待到款": "发结算-待到款",
  "发结算-待支付": "发结算-待支付",
  "发结算-待收款": "发结算-待收款",
  "发结算待到款": "发结算待到款",
  "发行数量": "发行数量",
  "发起": "发起",
  "发起入库报账": "发起入库报账",
  "发起对账单": "发起对账单",
  "发起收款": "发起收款",
  "发起新入库": "发起新入库",
  "发起线上询价": "发起线上询价",
  "发起结算成功!": "发起结算成功!",
  "发起退款成功": "发起退款成功",
  "发起退货": "发起退货",
  "发起退货收款单": "发起退货收款单",
  "取件商品": "取件商品",
  "取件回库任务": "取件回库任务",
  "取件量": "取件量",
  "取消供货": "取消供货",
  "取消供货成功": "取消供货成功",
  "取消出库": "取消出库",
  "取消新增": "取消新增",
  "取消编辑": "取消编辑",
  "只": "只",
  "只有输入商品列表或活动列表生成的内部链接，广告图跳转才可生效": "只有输入商品列表或活动列表生成的内部链接，广告图跳转才可生效",
  "只能上传一个视频文件，以最终上传文件为准": "只能上传一个视频文件，以最终上传文件为准",
  "可借总量": "可借总量",
  "可出借总量": "可出借总量",
  "可分批打印送货单,勾选打印后,则该商品显示已打印;可点击“已打印”按钮,将状态改回,防止勾选错误情况": "可分批打印送货单,勾选打印后,则该商品显示已打印;可点击“已打印”按钮,将状态改回,防止勾选错误情况",
  "可用来区分客户子账号部门下单，选择后，订单信息中会增加体现该岗位信息": "可用来区分客户子账号部门下单，选择后，订单信息中会增加体现该岗位信息",
  "可设置哪些日期不可配送，选择后，客户在小程序指定日期下单时，无法选择这天下单": "可设置哪些日期不可配送，选择后，客户在小程序指定日期下单时，无法选择这天下单",
  "司机": "司机",
  "司机位置": "司机位置",
  "合并": "合并",
  "合并入库单": "合并入库单",
  "合并成功!": "合并成功!",
  "合并打印": "合并打印",
  "合并打印装车单": "合并打印装车单",
  "合并报账": "合并报账",
  "合并生成入库单": "合并生成入库单",
  "合计": "合计",
  "合计商品": "合计商品",
  "合计应付": "合计应付",
  "合计总额": "合计总额",
  "合计金额": "合计金额",
  "同一商品(不同规格)的任务合并": "同一商品(不同规格)的任务合并",
  "同一天多次采购时取均衡价，自动成为售卖方式的成本价": "同一天多次采购时取均衡价，自动成为售卖方式的成本价",
  "同一客户的未分拣订单才可合并": "同一客户的未分拣订单才可合并",
  "同意": "同意",
  "名称": "名称",
  "名称及手机号": "名称及手机号",
  "名称排序": "名称排序",
  "名称搜索": "名称搜索",
  "后续在客户详情中更换模板": "后续在客户详情中更换模板",
  "启用": "启用",
  "启用: 执行采购时,实时价必须低于或等于建议价,否则需后台审核,调整建议价": "启用: 执行采购时,实时价必须低于或等于建议价,否则需后台审核,调整建议价",
  "启用:调价更新订单中的商品下单价时，也更新商品原价": "启用:调价更新订单中的商品下单价时，也更新商品原价",
  "启用：客户投篮编号按下单顺序自动编号": "启用：客户投篮编号按下单顺序自动编号",
  "员工管理": "员工管理",
  "周一": "周一",
  "周三": "周三",
  "周二": "周二",
  "周五": "周五",
  "周六": "周六",
  "周四": "周四",
  "周日": "周日",
  "周期": "周期",
  "周结": "周结",
  "周转框押金": "周转框押金",
  "周转筐信息": "周转筐信息",
  "周转筐借出": "周转筐借出",
  "周转筐押金": "周转筐押金",
  "周转筐管理": "周转筐管理",
  "品名": "品名",
  "品牌商": "品牌商",
  "品种名称": "品种名称",
  "售价": "售价",
  "售价 = 成本/(1 - 扣点)": "售价 = 成本/(1 - 扣点)",
  "售价 = 成本价 + 预计利润 + 包装成本 + 运输成本 + 税费成本": "售价 = 成本价 + 预计利润 + 包装成本 + 运输成本 + 税费成本",
  "售价倒推成本": "售价倒推成本",
  "售卖": "售卖",
  "售卖方式": "售卖方式",
  "售卖规格": "售卖规格",
  "售后": "售后",
  "售后原因": "售后原因",
  "售后商品": "售后商品",
  "售后描述": "售后描述",
  "售后申请": "售后申请",
  "售后说明": "售后说明",
  "售后退款": "售后退款",
  "商业保险单": "商业保险单",
  "商品": "商品",
  "商品({title})已添加过，不可重复添加": "商品({title})已添加过，不可重复添加",
  "商品ID": "商品ID",
  "商品ID(必填)": "商品ID(必填)",
  "商品一级分类": "商品一级分类",
  "商品与描述不符": "商品与描述不符",
  "商品主图": "商品主图",
  "商品二级分类": "商品二级分类",
  "商品产地": "商品产地",
  "商品价格趋势": "商品价格趋势",
  "商品份数": "商品份数",
  "商品供应": "商品供应",
  "商品促销": "商品促销",
  "商品信息": "商品信息",
  "商品入库审核": "商品入库审核",
  "商品共计{num}种": "商品共计{num}种",
  "商品分割入库": "商品分割入库",
  "商品分包任务分配机制": "商品分包任务分配机制",
  "商品分类": "商品分类",
  "商品分类区": "商品分类区",
  "商品分类比例": "商品分类比例",
  "商品列表": "商品列表",
  "商品利润": "商品利润",
  "商品别名": "商品别名",
  "商品合并": "商品合并",
  "商品名称": "商品名称",
  "商品名称不能为空": "商品名称不能为空",
  "商品名称及规格": "商品名称及规格",
  "商品名称和规格，如可乐500毫升": "商品名称和规格，如可乐500毫升",
  "商品名称或商品序列号": "商品名称或商品序列号",
  "商品名称或编号或首字母": "商品名称或编号或首字母",
  "商品售价将以调整后金额为准。": "商品售价将以调整后金额为准。",
  "商品售价必须大于0!": "商品售价必须大于0!",
  "商品售价趋势": "商品售价趋势",
  "商品售后": "商品售后",
  "商品售后处理": "商品售后处理",
  "商品图": "商品图",
  "商品图片": "商品图片",
  "商品在保存时长、打包、运输过程中的自然货损": "商品在保存时长、打包、运输过程中的自然货损",
  "商品备注": "商品备注",
  "商品定价": "商品定价",
  "商品导入": "商品导入",
  "商品导出": "商品导出",
  "商品展示区": "商品展示区",
  "商品已存在列表": "商品已存在列表",
  "商品库存低量超量警告": "商品库存低量超量警告",
  "商品总价值": "商品总价值",
  "商品总重量": "商品总重量",
  "商品总量": "商品总量",
  "商品总额": "商品总额",
  "商品成本": "商品成本",
  "商品批次": "商品批次",
  "商品批次即将到期警告": "商品批次即将到期警告",
  "商品损耗": "商品损耗",
  "商品损耗率": "商品损耗率",
  "商品换货": "商品换货",
  "商品排序": "商品排序",
  "商品描述": "商品描述",
  "商品提成比例必须大于0": "商品提成比例必须大于0",
  "商品搜索": "商品搜索",
  "商品数": "商品数",
  "商品数量": "商品数量",
  "商品数量问题": "商品数量问题",
  "商品整体图": "商品整体图",
  "商品明细": "商品明细",
  "商品显示单": "商品显示单",
  "商品条码库": "商品条码库",
  "商品来源": "商品来源",
  "商品标签": "商品标签",
  "商品标签图": "商品标签图",
  "商品清单": "商品清单",
  "商品溯源信息录入（将在商城的商品详情页中展示）": "商品溯源信息录入（将在商城的商品详情页中展示）",
  "商品状态": "商品状态",
  "商品种类": "商品种类",
  "商品种类统计": "商品种类统计",
  "商品管理": "商品管理",
  "商品类型": "商品类型",
  "商品类目": "商品类目",
  "商品统计": "商品统计",
  "商品编号": "商品编号",
  "商品自定义序列号": "商品自定义序列号",
  "商品装车单": "商品装车单",
  "商品规格": "商品规格",
  "商品规格不能为空": "商品规格不能为空",
  "商品规格条形码": "商品规格条形码",
  "商品视频": "商品视频",
  "商品详情": "商品详情",
  "商品货损率": "商品货损率",
  "商品质量问题": "商品质量问题",
  "商品退货": "商品退货",
  "商品选择": "商品选择",
  "商品采买": "商品采买",
  "商品采购操作时的成本价自动成为售卖方式的成本价": "商品采购操作时的成本价自动成为售卖方式的成本价",
  "商品采购时价或供货时价，每次随采购时价而更新": "商品采购时价或供货时价，每次随采购时价而更新",
  "商品金额": "商品金额",
  "商品销售": "商品销售",
  "商品限购": "商品限购",
  "商品验货": "商品验货",
  "商品验货成功": "商品验货成功",
  "商圈": "商圈",
  "商圈下单限制": "商圈下单限制",
  "商圈围栏": "商圈围栏",
  "商圈围栏不限": "商圈围栏不限",
  "商圈或者客户对象必须有一个存在值": "商圈或者客户对象必须有一个存在值",
  "商城": "商城",
  "商城2.0版个人中心功能开关": "商城2.0版个人中心功能开关",
  "商城下单时间": "商城下单时间",
  "商城主题颜色": "商城主题颜色",
  "商城有新版本更新时，系统管理员会代为发起审核。": "商城有新版本更新时，系统管理员会代为发起审核。",
  "商城送货方式": "商城送货方式",
  "商城配置": "商城配置",
  "商城采购主账号(限手机号)": "商城采购主账号(限手机号)",
  "商家推荐页主图": "商家推荐页主图",
  "商家登录": "商家登录",
  "商户号": "商户号",
  "商户名称": "商户名称",
  "团长": "团长",
  "团长代收点": "团长代收点",
  "团长代收点注册": "团长代收点注册",
  "团长信息": "团长信息",
  "团长奖金金额": "团长奖金金额",
  "团长推广背景图(300*400)": "团长推广背景图(300*400)",
  "固定毛利 = $SPLIT${yuan} / 商品": "固定毛利 = $SPLIT${yuan} / 商品",
  "图标": "图标",
  "图标展示排序": "图标展示排序",
  "图片": "图片",
  "图片上传": "图片上传",
  "上传失败，请重新上传": "上传失败，请重新上传",
  "图片名称": "图片名称",
  "在分拣端电脑上分包称重过程中，商品报缺货，将产生异常报警到平台管理端，响应处理。以及报缺货商品数量为0，体现到打印出库单上。": "在分拣端电脑上分包称重过程中，商品报缺货，将产生异常报警到平台管理端，响应处理。以及报缺货商品数量为0，体现到打印出库单上。",
  "在售": "在售",
  "在客户收货后，实收数量与原订单发生差价，如少钱则会记负数到钱包余额，如多钱则不会立即退款，需后台线下介入，再售后退款金额。": "在客户收货后，实收数量与原订单发生差价，如少钱则会记负数到钱包余额，如多钱则不会立即退款，需后台线下介入，再售后退款金额。",
  "在线": "在线",
  "在线商品": "在线商品",
  "在线客服": "在线客服",
  "在线支付": "在线支付",
  "在线支付方式的订单金额，直接进入微信商户账户，请前往 $SPLIT$ 登录账号查看流水。": "在线支付方式的订单金额，直接进入微信商户账户，请前往 $SPLIT$ 登录账号查看流水。",
  "在线支付：客户在小程序下单时，需要先付款才能下单成功": "在线支付：客户在小程序下单时，需要先付款才能下单成功",
  "在线结算": "在线结算",
  "在线询价说明": "在线询价说明",
  "在线购买升级，选择等级，在线付款。": "在线购买升级，选择等级，在线付款。",
  "在订单完成时进行提成计算，金额发放到账户余额": "在订单完成时进行提成计算，金额发放到账户余额",
  "地址": "地址",
  "均价": "均价",
  "均摊": "均摊",
  "均衡成本": "均衡成本",
  "坐标": "坐标",
  "坐标地址": "坐标地址",
  "基本信息": "基本信息",
  "基本设置": "基本设置",
  "基本量": "基本量",
  "基础设置": "基础设置",
  "增加": "增加",
  "增加供货方": "增加供货方",
  "增加售卖方式": "增加售卖方式",
  "增加工序": "增加工序",
  "增加方案": "增加方案",
  "处理": "处理",
  "处理失败": "处理失败",
  "处理结果": "处理结果",
  "处理结果备注": "处理结果备注",
  "备注": "备注",
  "备注信息": "备注信息",
  "备注原因": "备注原因",
  "备注发票编号": "备注发票编号",
  "备注说明": "备注说明",
  "复制": "复制",
  "复制成功": "复制成功",
  "多个签名请以/分隔，比如：分拣员/送货员": "多个签名请以/分隔，比如：分拣员/送货员",
  "多单收一单的配送费": "多单收一单的配送费",
  "多单收款": "多单收款",
  "多退少补": "多退少补",
  "大屏管理系统": "大屏管理系统",
  "天": "天",
  "头像主图": "头像主图",
  "头部背景图": "头部背景图",
  "套餐子商品": "套餐子商品",
  "女": "女",
  "好生意 第四方支付": "好生意 第四方支付",
  "好生意商户号": "好生意商户号",
  "好生意支付密钥": "好生意支付密钥",
  "好货推荐": "好货推荐",
  "好货推荐页主图": "好货推荐页主图",
  "如:10000张": "如:10000张",
  "如:{num}{yuan}": "如:{num}{yuan}",
  "如:快乐购积分卡": "如:快乐购积分卡",
  "如:特价限时购": "如:特价限时购",
  "如九折 请输入99.85": "如九折 请输入99.85",
  "如客户下单鲫鱼3条，每条鱼重2斤左右，采购单价{num1}{yuan}/斤，售价{num2}{yuan}/斤，即共重6斤，采购成本{num3}{yuan}，销售价{num4}{yuan}": "如客户下单鲫鱼3条，每条鱼重2斤左右，采购单价{num1}{yuan}/斤，售价{num2}{yuan}/斤，即共重6斤，采购成本{num3}{yuan}，销售价{num4}{yuan}",
  "如：袋、件、箱": "如：袋、件、箱",
  "姓名": "姓名",
  "子单": "子单",
  "子品销售": "子品销售",
  "子商品": "子商品",
  "子商品不能与源商品相同": "子商品不能与源商品相同",
  "子平台": "子平台",
  "子部门": "子部门",
  "子部门管理": "子部门管理",
  "存储条件": "存储条件",
  "存入购物车": "存入购物车",
  "存入购物车成功": "存入购物车成功",
  "存在去库存采购完成的商品，请重新选择!": "存在去库存采购完成的商品，请重新选择!",
  "存在已采购完成的商品，请重新选择!": "存在已采购完成的商品，请重新选择!",
  "存放仓库": "存放仓库",
  "存放分仓": "存放分仓",
  "存放区域": "存放区域",
  "存放库区": "存放库区",
  "存量": "存量",
  "存量价值": "存量价值",
  "存量出货": "存量出货",
  "存量结算": "存量结算",
  "学校": "学校",
  "完成数": "完成数",
  "定价": "定价",
  "定位商品": "定位商品",
  "定期采购说明": "定期采购说明",
  "定期采购首页显示": "定期采购首页显示",
  "实付": "实付",
  "实付金额": "实付金额",
  "实付额": "实付额",
  "实拣数量": "实拣数量",
  "实收": "实收",
  "实收量": "实收量",
  "实收金额": "实收金额",
  "实称": "实称",
  "实采": "实采",
  "实采价超出采购建议价，请重新议价或申请调整建议价，确定继续申请调整建议价?": "实采价超出采购建议价，请重新议价或申请调整建议价，确定继续申请调整建议价?",
  "实采量": "实采量",
  "实际入库量有差异或拒收时，请与商家及取件员线下确认!": "实际入库量有差异或拒收时，请与商家及取件员线下确认!",
  "实际分拣员": "实际分拣员",
  "实际利润": "实际利润",
  "实际拣货数量": "实际拣货数量",
  "实际采购数量": "实际采购数量",
  "审核": "审核",
  "审核上架": "审核上架",
  "审核失败": "审核失败",
  "审核成功": "审核成功",
  "审核拒绝": "审核拒绝",
  "审核状态": "审核状态",
  "审核通过": "审核通过",
  "客户": "客户",
  "客户ID": "客户ID",
  "客户下单": "客户下单",
  "客户不可见": "客户不可见",
  "客户企业名称": "客户企业名称",
  "客户信息": "客户信息",
  "客户列表": "客户列表",
  "客户协议价 （在客户管理列表 协议价商品设置）。": "客户协议价 （在客户管理列表 协议价商品设置）。",
  "客户协议价导出": "客户协议价导出",
  "客户单位": "客户单位",
  "客户单位名称": "客户单位名称",
  "客户可见": "客户可见",
  "客户名称": "客户名称",
  "客户名称、手机号、编码": "客户名称、手机号、编码",
  "客户名称和企业编号搜索": "客户名称和企业编号搜索",
  "客户名称和编号搜索": "客户名称和编号搜索",
  "客户名称或手机号": "客户名称或手机号",
  "客户名称查询": "客户名称查询",
  "客户周期结算": "客户周期结算",
  "客户图片": "客户图片",
  "客户在线支付方式订单，只有客户在小程序商取消订单或修改订单时才直接现金退款，订单原路退款到客户微信钱包。": "客户在线支付方式订单，只有客户在小程序商取消订单或修改订单时才直接现金退款，订单原路退款到客户微信钱包。",
  "客户地图": "客户地图",
  "客户地址": "客户地址",
  "客户对象": "客户对象",
  "客户导入模板": "客户导入模板",
  "客户已存在列表": "客户已存在列表",
  "客户建议": "客户建议",
  "客户折扣价 （在客户管理详情中指定的享受折扣比例）。": "客户折扣价 （在客户管理详情中指定的享受折扣比例）。",
  "客户拜访": "客户拜访",
  "客户指定送货时间": "客户指定送货时间",
  "客户收货后自动发起结算": "客户收货后自动发起结算",
  "客户数": "客户数",
  "客户文件号": "客户文件号",
  "客户清单": "客户清单",
  "客户端不可见": "客户端不可见",
  "客户端可见": "客户端可见",
  "客户等级": "客户等级",
  "客户签字": "客户签字",
  "客户签收": "客户签收",
  "客户管理": "客户管理",
  "客户编号": "客户编号",
  "客户自主注册": "客户自主注册",
  "客户要求送货时间": "客户要求送货时间",
  "客户详情": "客户详情",
  "客服": "客服",
  "客服电话": "客服电话",
  "客服电话不能为空": "客服电话不能为空",
  "家": "家",
  "寄售出库": "寄售出库",
  "寄售商品利润": "寄售商品利润",
  "寄售商品库": "寄售商品库",
  "寄售商品日志": "寄售商品日志",
  "寄售报账单": "寄售报账单",
  "寄售结算": "寄售结算",
  "寄售结算列表": "寄售结算列表",
  "寄售铺货": "寄售铺货",
  "寄售销售出库": "寄售销售出库",
  "密码修改成功": "密码修改成功",
  "密码长度在 6 到 16 个字符": "密码长度在 6 到 16 个字符",
  "密钥不能为空": "密钥不能为空",
  "对在线支付和线下结算订单都调价": "对在线支付和线下结算订单都调价",
  "对在线支付订单不调价": "对在线支付订单不调价",
  "对报缺量异常的商品，进行代客下单，手动方式重新下发新的线下结算方式订单。": "对报缺量异常的商品，进行代客下单，手动方式重新下发新的线下结算方式订单。",
  "对方": "对方",
  "对方上传凭证": "对方上传凭证",
  "对方信息": "对方信息",
  "对方名称": "对方名称",
  "对该异常信息记录下问题产生原因，以备后期跟踪追责。": "对该异常信息记录下问题产生原因，以备后期跟踪追责。",
  "对该异常情况不作处理，或线下处理后将其状态关闭。": "对该异常情况不作处理，或线下处理后将其状态关闭。",
  "对账单": "对账单",
  "对账单号": "对账单号",
  "对账单详情": "对账单详情",
  "对账对方": "对账对方",
  "对账待付款": "对账待付款",
  "对账待到款": "对账待到款",
  "对账结算": "对账结算",
  "对账结算备注": "对账结算备注",
  "对账金额": "对账金额",
  "导入": "导入",
  "导入Excel文件": "导入Excel文件",
  "导入只能新增预采补采任务，无法修改": "导入只能新增预采补采任务，无法修改",
  "导入商品": "导入商品",
  "导入商品未完善": "导入商品未完善",
  "导入商品条码": "导入商品条码",
  "导入说明": "导入说明",
  "导出": "导出",
  "导出EXCEL": "导出EXCEL",
  "导出PDF": "导出PDF",
  "导出下载": "导出下载",
  "导出商品模板": "导出商品模板",
  "导出商品清单": "导出商品清单",
  "导出填充": "导出填充",
  "导出数据不能为空": "导出数据不能为空",
  "导出标签记录": "导出标签记录",
  "导出模板": "导出模板",
  "导出用卡": "导出用卡",
  "导出表格是否填充": "导出表格是否填充",
  "将对可转采购商品进行批量操作，不可转采购商品将过滤，是否确认继续批量操作?": "将对可转采购商品进行批量操作，不可转采购商品将过滤，是否确认继续批量操作?",
  "将提交{num}条商品数据，请确认后提交": "将提交{num}条商品数据，请确认后提交",
  "将本商品的采购量进行拆分为多家采买或更换采买对方。确认提交后，将会自动产出供货任务或采购任务至对方账号中，由其进行线下供货。最新报价为各供货商账号在APP上报价提供": "将本商品的采购量进行拆分为多家采买或更换采买对方。确认提交后，将会自动产出供货任务或采购任务至对方账号中，由其进行线下供货。最新报价为各供货商账号在APP上报价提供",
  "将询价小程序二维码，发送给指定供货商，由供货商登录填写，提交收集价格。": "将询价小程序二维码，发送给指定供货商，由供货商登录填写，提交收集价格。",
  "小时内，允许客户申请售后": "小时内，允许客户申请售后",
  "小程序APPID": "小程序APPID",
  "小程序代码提交请联系技术客服。": "小程序代码提交请联系技术客服。",
  "小程序价格显示": "小程序价格显示",
  "小程序客服": "小程序客服",
  "小程序密钥": "小程序密钥",
  "小程序对接": "小程序对接",
  "小程序是否显示时价": "小程序是否显示时价",
  "小程序管理后台填入企业微信ID": "小程序管理后台填入企业微信ID",
  "小菜下单端": "小菜下单端",
  "少量应退款": "少量应退款",
  "局部问题图": "局部问题图",
  "展示位置": "展示位置",
  "展示截止时间": "展示截止时间",
  "展示时间": "展示时间",
  "展示费": "展示费",
  "属性名称": "属性名称",
  "岗位人员签名": "岗位人员签名",
  "岗位名称": "岗位名称",
  "岗位角色": "岗位角色",
  "工作APP端": "工作APP端",
  "工作人员": "工作人员",
  "工作人员服务态度": "工作人员服务态度",
  "工作人员统计": "工作人员统计",
  "工作端-客户电子签名": "工作端-客户电子签名",
  "工作量分布": "工作量分布",
  "工序": "工序",
  "工序名称": "工序名称",
  "工序标准": "工序标准",
  "差价处理": "差价处理",
  "差额": "差额",
  "已上传": "已上传",
  "已下架": "已下架",
  "已付订单": "已付订单",
  "已付金额": "已付金额",
  "已使用": "已使用",
  "已供": "已供",
  "已停用": "已停用",
  "已入库量": "已入库量",
  "已关联{num}家客户对象": "已关联{num}家客户对象",
  "已关联的商品{num}种": "已关联的商品{num}种",
  "已关闭": "已关闭",
  "已冻结": "已冻结",
  "已出借量": "已出借量",
  "已分拣": "已分拣",
  "已到款-已结算": "已到款-已结算",
  "已到款订单无法再次发起收款": "已到款订单无法再次发起收款",
  "已加工": "已加工",
  "已取到": "已取到",
  "已取消": "已取消",
  "已取货回": "已取货回",
  "已取量": "已取量",
  "已处理": "已处理",
  "已存在相同数据,相同数据未添加": "已存在相同数据,相同数据未添加",
  "已存在锁定订单": "已存在锁定订单",
  "已完成": "已完成",
  "已完结": "已完结",
  "已审核": "已审核",
  "已开具": "已开具",
  "已开票": "已开票",
  "已截止": "已截止",
  "已打印": "已打印",
  "已报账已结算": "已报账已结算",
  "已报账未结算": "已报账未结算",
  "已报账过单据无法再次报账": "已报账过单据无法再次报账",
  "已报账部分到款": "已报账部分到款",
  "已报账金额": "已报账金额",
  "已拆分为多个送货单": "已拆分为多个送货单",
  "已拒绝": "已拒绝",
  "已排单": "已排单",
  "已支付": "已支付",
  "已支付-待确款": "已支付-待确款",
  "已收": "已收",
  "已收款": "已收款",
  "已收款金额": "已收款金额",
  "已收货-待结算": "已收货-待结算",
  "已收货待结算": "已收货待结算",
  "已收金额": "已收金额",
  "已有商品发起报账，无法生成入库单": "已有商品发起报账，无法生成入库单",
  "已有商品合并生成过入库单，无法生成入库单": "已有商品合并生成过入库单，无法生成入库单",
  "已有账号，直接登录": "已有账号，直接登录",
  "已有锁定的订单，请管理员主账号解除锁定": "已有锁定的订单，请管理员主账号解除锁定",
  "已满减{num}{yuan}": "已满减{num}{yuan}",
  "已生成B账单": "已生成B账单",
  "已生效-处理中": "已生效-处理中",
  "已生效处理中": "已生效处理中",
  "已确款-全部到款": "已确款-全部到款",
  "已确款-部分到款": "已确款-部分到款",
  "已线下支付": "已线下支付",
  "已经线下付款": "已经线下付款",
  "已经线下阅读《合作协议》": "已经线下阅读《合作协议》",
  "已结次数": "已结次数",
  "已结算": "已结算",
  "已结算-已到款": "已结算-已到款",
  "已结算-待付款": "已结算-待付款",
  "已结算付款": "已结算付款",
  "已结算差额": "已结算差额",
  "已结算已到款": "已结算已到款",
  "已结算收款": "已结算收款",
  "已结金额": "已结金额",
  "已补采": "已补采",
  "已装完": "已装完",
  "已转为修改单": "已转为修改单",
  "已转单": "已转单",
  "已过期": "已过期",
  "已退框": "已退框",
  "已退筐": "已退筐",
  "已退货": "已退货",
  "已退货量": "已退货量",
  "已退还": "已退还",
  "已送/应送": "已送/应送",
  "已送订单/今日": "已送订单/今日",
  "已送达": "已送达",
  "已选了星级全部，无法增加方案": "已选了星级全部，无法增加方案",
  "已选商品": "已选商品",
  "已选商品清单的商品({num}种)": "已选商品清单的商品({num}种)",
  "已选客户": "已选客户",
  "已采": "已采",
  "已采数量": "已采数量",
  "已采用": "已采用",
  "已锁定": "已锁定",
  "已领料": "已领料",
  "已驳回": "已驳回",
  "已验货-送货中": "已验货-送货中",
  "市场原价": "市场原价",
  "市场售价": "市场售价",
  "市场售价 （在未设置前述价格时，即按此价格正常销售）。": "市场售价 （在未设置前述价格时，即按此价格正常销售）。",
  "帐号": "帐号",
  "帮助": "帮助",
  "帮助封面图": "帮助封面图",
  "帮助详情": "帮助详情",
  "平台": "平台",
  "平台供应": "平台供应",
  "平台供货": "平台供货",
  "平台商品": "平台商品",
  "平台库存": "平台库存",
  "平台扣点": "平台扣点",
  "平台承担金额": "平台承担金额",
  "平台方信息": "平台方信息",
  "平台根据订单中商品的分类，及其关联的分拣人员，分给其任务。": "平台根据订单中商品的分类，及其关联的分拣人员，分给其任务。",
  "平台根据订单客户所在配送线路，及其关联的分拣人员，分给其任务。": "平台根据订单客户所在配送线路，及其关联的分拣人员，分给其任务。",
  "平台注册号": "平台注册号",
  "平台自发 或 供应商": "平台自发 或 供应商",
  "平台自采": "平台自采",
  "平均损耗率": "平均损耗率",
  "平均毛利率": "平均毛利率",
  "平库": "平库",
  "广告图": "广告图",
  "广告轮播图": "广告轮播图",
  "序": "序",
  "序号": "序号",
  "库内分区": "库内分区",
  "库内商品": "库内商品",
  "库区": "库区",
  "库存": "库存",
  "库存信息": "库存信息",
  "库存商品": "库存商品",
  "库存商品存量": "库存商品存量",
  "库存商品金额": "库存商品金额",
  "库存帐表": "库存帐表",
  "库存数量": "库存数量",
  "库存现货": "库存现货",
  "库存量": "库存量",
  "库存量必须大于0": "库存量必须大于0",
  "库存量警报": "库存量警报",
  "库存额": "库存额",
  "库房": "库房",
  "库房信息": "库房信息",
  "库房设置": "库房设置",
  "应付": "应付",
  "应付供应商报账表": "应付供应商报账表",
  "应付入库报账表": "应付入库报账表",
  "应付实付": "应付实付",
  "应付订单": "应付订单",
  "应付退货入库报账表": "应付退货入库报账表",
  "应付金额": "应付金额",
  "应付项目": "应付项目",
  "应供": "应供",
  "应加工": "应加工",
  "应取量": "应取量",
  "应报账金额": "应报账金额",
  "应收": "应收",
  "应收出库报账表": "应收出库报账表",
  "应收实收": "应收实收",
  "应收寄售报账表": "应收寄售报账表",
  "应收金额": "应收金额",
  "应收项目": "应收项目",
  "应结总额": "应结总额",
  "应结款": "应结款",
  "应结算": "应结算",
  "应结算订单": "应结算订单",
  "应结算金额": "应结算金额",
  "应结订单": "应结订单",
  "应结金额": "应结金额",
  "应转金额": "应转金额",
  "应退的金额": "应退的金额",
  "应采": "应采",
  "应采总量": "应采总量",
  "应采数量": "应采数量",
  "应采量": "应采量",
  "店铺推荐展示": "店铺推荐展示",
  "建单": "建单",
  "建单开始日期": "建单开始日期",
  "建单结束日期": "建单结束日期",
  "建议": "建议",
  "建议使用{a}谷歌google{a}浏览器": "建议使用{a}谷歌google{a}浏览器",
  "建议采购价": "建议采购价",
  "建议采购价申请": "建议采购价申请",
  "建议采购量": "建议采购量",
  "开具发票": "开具发票",
  "开发票申请": "开发票申请",
  "开启": "开启",
  "开启会员制，商城个人中心会员模块": "开启会员制，商城个人中心会员模块",
  "开启后分包任务商品不合并": "开启后分包任务商品不合并",
  "开启后同一客户、日期、收货地、相同订单状态、强制订单合并，商品可重复，金额累加": "开启后同一客户、日期、收货地、相同订单状态、强制订单合并，商品可重复，金额累加",
  "开启后在线支付订单收货后自动按差量退款": "开启后在线支付订单收货后自动按差量退款",
  "开启后订单导入商品和分拣任务不合并": "开启后订单导入商品和分拣任务不合并",
  "开启后，新下订单的订单商品按录单顺序排序": "开启后，新下订单的订单商品按录单顺序排序",
  "开启向该客户铺货寄售业务方式": "开启向该客户铺货寄售业务方式",
  "开启平第四方支付": "开启平第四方支付",
  "开始": "开始",
  "开始日期": "开始日期",
  "开始时间": "开始时间",
  "开始时间不能超过结束时间，请重新筛选!": "开始时间不能超过结束时间，请重新筛选!",
  "开户分行": "开户分行",
  "开户行": "开户行",
  "开户银行": "开户银行",
  "开户银行不能为空": "开户银行不能为空",
  "开放注册": "开放注册",
  "开放注册，后审核": "开放注册，后审核",
  "开票": "开票",
  "开票内容": "开票内容",
  "开票状态": "开票状态",
  "开票税率": "开票税率",
  "开设新的配送中心子平台，请联系客服": "开设新的配送中心子平台，请联系客服",
  "开通收银员功能": "开通收银员功能",
  "异常": "异常",
  "异常原因": "异常原因",
  "异常图片": "异常图片",
  "异常类型": "异常类型",
  "异常订单": "异常订单",
  "异常通知": "异常通知",
  "张": "张",
  "当前供货": "当前供货",
  "当前只打印补货单": "当前只打印补货单",
  "当前只打印退货单": "当前只打印退货单",
  "当前已减{num1}{yuan}，还差{num2}{yuan}可减{num3}{yuan}": "当前已减{num1}{yuan}，还差{num2}{yuan}可减{num3}{yuan}",
  "当前已选电子围栏已删除，已清空已选围栏": "当前已选电子围栏已删除，已清空已选围栏",
  "当前库存": "当前库存",
  "当前无电子围栏，请先添加电子围栏": "当前无电子围栏，请先添加电子围栏",
  "当前未到达订单的指定送货日期，请确认是否订单送达!": "当前未到达订单的指定送货日期，请确认是否订单送达!",
  "当前浏览器不支持此功能": "当前浏览器不支持此功能",
  "当前版本": "当前版本",
  "当前状态": "当前状态",
  "当前订单还差{num1}{yuan}可减{num2}{yuan}": "当前订单还差{num1}{yuan}可减{num2}{yuan}",
  "当前记录超上限，最大可导出255条记录，请重新筛选后再试!": "当前记录超上限，最大可导出255条记录，请重新筛选后再试!",
  "当前记录超上限，最大可导出3000条记录，请重新筛选后再试!": "当前记录超上限，最大可导出3000条记录，请重新筛选后再试!",
  "当前语言不支持高德地图": "当前语言不支持高德地图",
  "当前账号已在其它地方登陆，请重新登陆": "当前账号已在其它地方登陆，请重新登陆",
  "当前配送员无路线，无法转单": "当前配送员无路线，无法转单",
  "当前销量": "当前销量",
  "当商品下单重量 满$SPLIT$起，需搭配下单$SPLIT$1个": "当商品下单重量 满$SPLIT$起，需搭配下单$SPLIT$1个",
  "当商品下单重量 超$SPLIT$时，且超出的重量达到满起标准时，会再自动配备第2个包装筐": "当商品下单重量 超$SPLIT$时，且超出的重量达到满起标准时，会再自动配备第2个包装筐",
  "待使用": "待使用",
  "待分拣": "待分拣",
  "待加工": "待加工",
  "待取件": "待取件",
  "待取货回": "待取货回",
  "待处理": "待处理",
  "待完成": "待完成",
  "待审核": "待审核",
  "待开票": "待开票",
  "待支付": "待支付",
  "待支付订单才可发起收款": "待支付订单才可发起收款",
  "待收款": "待收款",
  "待收钱": "待收钱",
  "待确款": "待确款",
  "待确认": "待确认",
  "待结算": "待结算",
  "待结算单": "待结算单",
  "待结算订单": "待结算订单",
  "待结算订单金额": "待结算订单金额",
  "待结算金额": "待结算金额",
  "待结表单": "待结表单",
  "待结订单": "待结订单",
  "待结退货": "待结退货",
  "待结退货入库单": "待结退货入库单",
  "待结退货出库单": "待结退货出库单",
  "待结采购入库单": "待结采购入库单",
  "待结金额": "待结金额",
  "待补采": "待补采",
  "待装车": "待装车",
  "待退还": "待退还",
  "待送订单": "待送订单",
  "待送货": "待送货",
  "待送货订单": "待送货订单",
  "微信": "微信",
  "微信下单": "微信下单",
  "微信商户账号": "微信商户账号",
  "微信在线": "微信在线",
  "微信线下": "微信线下",
  "微信结算": "微信结算",
  "微信群反馈交流": "微信群反馈交流",
  "微信账户不能为空": "微信账户不能为空",
  "必": "必",
  "快捷功能入口": "快捷功能入口",
  "总价": "总价",
  "总份量": "总份量",
  "总提现金额": "总提现金额",
  "总收款金额": "总收款金额",
  "总毛利": "总毛利",
  "总重量": "总重量",
  "总量": "总量",
  "总量{num}斤": "总量{num}斤",
  "总金额": "总金额",
  "总额": "总额",
  "恢复": "恢复",
  "您好": "您好",
  "您已登录此平台": "您已登录此平台",
  "您还未设置支付证书，不能选择在线支付方式，请上传证书后选择!": "您还未设置支付证书，不能选择在线支付方式，请上传证书后选择!",
  "您还未选择客户": "您还未选择客户",
  "您选择的日期无法配送哦，请联系平台客服了解情况!": "您选择的日期无法配送哦，请联系平台客服了解情况!",
  "成功": "成功",
  "成功生成结算单!": "成功生成结算单!",
  "成功送达": "成功送达",
  "成功选为平台商品!": "成功选为平台商品!",
  "成本": "成本",
  "成本 + 供应商扣点定价": "成本 + 供应商扣点定价",
  "成本+扣点定价": "成本+扣点定价",
  "成本价": "成本价",
  "成本利润核价": "成本利润核价",
  "我的收藏": "我的收藏",
  "截止": "截止",
  "截止时间": "截止时间",
  "截止时间不能为空": "截止时间不能为空",
  "截止时间不能为过去时间": "截止时间不能为过去时间",
  "所属仓库": "所属仓库",
  "所属行业": "所属行业",
  "所选任务已完成，不能转单": "所选任务已完成，不能转单",
  "所选商品无规格": "所选商品无规格",
  "手动出借篮筐": "手动出借篮筐",
  "手动创建": "手动创建",
  "手动创建出借": "手动创建出借",
  "手动创建来筐": "手动创建来筐",
  "手工下单": "手工下单",
  "手改表单": "手改表单",
  "手机号": "手机号",
  "打单": "打单",
  "打单开始日期": "打单开始日期",
  "打单时间": "打单时间",
  "打单结束日期": "打单结束日期",
  "打印": "打印",
  "打印入库单": "打印入库单",
  "打印单号": "打印单号",
  "打印商品客户内容": "打印商品客户内容",
  "打印商品成本单价": "打印商品成本单价",
  "打印小数": "打印小数",
  "打印时间": "打印时间",
  "打印模板设置": "打印模板设置",
  "打印清单": "打印清单",
  "打印补货单": "打印补货单",
  "打印退货单": "打印退货单",
  "打印预览": "打印预览",
  "打印默认": "打印默认",
  "打开后送货员隐藏复称出库按钮": "打开后送货员隐藏复称出库按钮",
  "打开导出的文件，在“修改协议价”那一列填入价格；注意是在“修改协议价”这一列填入数据，不要修改“协议价”这一列的数据": "打开导出的文件，在“修改协议价”那一列填入价格；注意是在“修改协议价”这一列填入数据，不要修改“协议价”这一列的数据",
  "打开开关": "打开开关",
  "打折": "打折",
  "打拣货单": "打拣货单",
  "扣点": "扣点",
  "扣点率%": "扣点率%",
  "扣点设置": "扣点设置",
  "扣点金额": "扣点金额",
  "扩展": "扩展",
  "扫码": "扫码",
  "批次": "批次",
  "批次修改": "批次修改",
  "批次编号": "批次编号",
  "批量上架": "批量上架",
  "批量下架": "批量下架",
  "批量供应商库存": "批量供应商库存",
  "批量供应日供量": "批量供应日供量",
  "批量修改活动时间": "批量修改活动时间",
  "批量入库": "批量入库",
  "批量关闭": "批量关闭",
  "批量出库": "批量出库",
  "批量分包": "批量分包",
  "批量删除": "批量删除",
  "批量删除协议价": "批量删除协议价",
  "批量删除篮筐": "批量删除篮筐",
  "批量去库存采购": "批量去库存采购",
  "批量去库存采购成功!": "批量去库存采购成功!",
  "批量发起结算": "批量发起结算",
  "批量商品改价": "批量商品改价",
  "批量完成分拣": "批量完成分拣",
  "批量审核通过": "批量审核通过",
  "批量导入协议价": "批量导入协议价",
  "批量已开票": "批量已开票",
  "批量库存置零": "批量库存置零",
  "批量库存警报": "批量库存警报",
  "批量打单": "批量打单",
  "批量打印": "批量打印",
  "批量打拣货单": "批量打拣货单",
  "批量拒绝": "批量拒绝",
  "批量添加为我的商品": "批量添加为我的商品",
  "批量盘点": "批量盘点",
  "批量结算": "批量结算",
  "批量编辑": "批量编辑",
  "批量订单商品改价,重算订单": "批量订单商品改价,重算订单",
  "批量设置商品显示": "批量设置商品显示",
  "批量设置库存": "批量设置库存",
  "批量调价": "批量调价",
  "批量调利润": "批量调利润",
  "批量转单": "批量转单",
  "批量转库存现货": "批量转库存现货",
  "批量转采购": "批量转采购",
  "批量转预售采购": "批量转预售采购",
  "批量还筐": "批量还筐",
  "批量送达": "批量送达",
  "批量选择{num}个订单": "批量选择{num}个订单",
  "批量通过": "批量通过",
  "批量采购": "批量采购",
  "批量采购成功!": "批量采购成功!",
  "承担金额": "承担金额",
  "把押金计不入本出库单": "把押金计不入本出库单",
  "把押金计入本出库单中合计金额": "把押金计入本出库单中合计金额",
  "投线": "投线",
  "投线任务": "投线任务",
  "折扣": "折扣",
  "折扣比例": "折扣比例",
  "折扣类型": "折扣类型",
  "折扣金额": "折扣金额",
  "折扣：订单金额按折扣比例减免。例：一星客户，设置百分之90，则一星客户订单商品金额打9折；选择“全部”设置比例后，无法再为其他星级设置比例": "折扣：订单金额按折扣比例减免。例：一星客户，设置百分之90，则一星客户订单商品金额打9折；选择“全部”设置比例后，无法再为其他星级设置比例",
  "报价": "报价",
  "报价信息": "报价信息",
  "报价商家": "报价商家",
  "报价截止": "报价截止",
  "报价方案": "报价方案",
  "报价时间": "报价时间",
  "报损": "报损",
  "报损原因": "报损原因",
  "报损数量": "报损数量",
  "报损量": "报损量",
  "报损量不能大于寄存量": "报损量不能大于寄存量",
  "报损量必须大于0": "报损量必须大于0",
  "报缺": "报缺",
  "报缺货": "报缺货",
  "报缺货成功": "报缺货成功",
  "报账": "报账",
  "报账单": "报账单",
  "报账单号": "报账单号",
  "报账单数": "报账单数",
  "报账商品": "报账商品",
  "报账成功!": "报账成功!",
  "报账状态": "报账状态",
  "报账结算": "报账结算",
  "报账金额": "报账金额",
  "报销结算时间": "报销结算时间",
  "报销结算状态": "报销结算状态",
  "抬头": "抬头",
  "抹零": "抹零",
  "押金": "押金",
  "押金支付": "押金支付",
  "押金金额": "押金金额",
  "抽成比例": "抽成比例",
  "拆分": "拆分",
  "拆单": "拆单",
  "拒收": "拒收",
  "拒绝": "拒绝",
  "拒绝任务": "拒绝任务",
  "拒绝供应商商品通过原因": "拒绝供应商商品通过原因",
  "拒绝入库": "拒绝入库",
  "拒绝后将取消该任务，确认拒绝?": "拒绝后将取消该任务，确认拒绝?",
  "拜访": "拜访",
  "拜访客户": "拜访客户",
  "拜访时间": "拜访时间",
  "拜访目的": "拜访目的",
  "拣货": "拣货",
  "指定协议价": "指定协议价",
  "指定售价": "指定售价",
  "指定建议价": "指定建议价",
  "指定日期": "指定日期",
  "指定日期下单转换时间": "指定日期下单转换时间",
  "指定日期开始时间": "指定日期开始时间",
  "指定日期截止时间": "指定日期截止时间",
  "指定日期限制": "指定日期限制",
  "指定送": "指定送",
  "指定配送时间限制": "指定配送时间限制",
  "指定采购价": "指定采购价",
  "指定限制时间不能相同!": "指定限制时间不能相同!",
  "按下单量统计": "按下单量统计",
  "按份数打印": "按份数打印",
  "按供货售价进行平台扣点，扣点优先顺序为：单品、分类、默认三层": "按供货售价进行平台扣点，扣点优先顺序为：单品、分类、默认三层",
  "按入库量占比分摊": "按入库量占比分摊",
  "按出库量占比分摊": "按出库量占比分摊",
  "按商品": "按商品",
  "按商品出库重量统计": "按商品出库重量统计",
  "按商品分拣清单": "按商品分拣清单",
  "按商品分类统计": "按商品分类统计",
  "按商品统计": "按商品统计",
  "按商品销售价金额的默认扣点比例": "按商品销售价金额的默认扣点比例",
  "按商品销售价金额的默认提成比例": "按商品销售价金额的默认提成比例",
  "按基本数量打印": "按基本数量打印",
  "按客户": "按客户",
  "按客户导出": "按客户导出",
  "按客户统计": "按客户统计",
  "按订单付款统计": "按订单付款统计",
  "按订单收款统计": "按订单收款统计",
  "按退货商品": "按退货商品",
  "按金额占比分摊": "按金额占比分摊",
  "按钮文字颜色": "按钮文字颜色",
  "按钮颜色": "按钮颜色",
  "按销售员统计": "按销售员统计",
  "损溢原因": "损溢原因",
  "损耗": "损耗",
  "损耗总量": "损耗总量",
  "损耗成本": "损耗成本",
  "损耗率": "损耗率",
  "损耗率%</br>(损耗总量/采购量)": "损耗率%</br>(损耗总量/采购量)",
  "损耗统计": "损耗统计",
  "损耗量": "损耗量",
  "排单锁定后不可再次排单，凭主账号密码解除锁定!": "排单锁定后不可再次排单，凭主账号密码解除锁定!",
  "排序": "排序",
  "排序号": "排序号",
  "排序方式": "排序方式",
  "接口名称": "接口名称",
  "控制下单生成采购任务一定时间后，自动执行采购任务": "控制下单生成采购任务一定时间后，自动执行采购任务",
  "控制订单详情是否显示商品成本，修改成本只对该订单有效": "控制订单详情是否显示商品成本，修改成本只对该订单有效",
  "推荐展现": "推荐展现",
  "推荐展示中": "推荐展示中",
  "描边": "描边",
  "提交": "提交",
  "提交前请先存入购物车!": "提交前请先存入购物车!",
  "提交反馈": "提交反馈",
  "提交后生效": "提交后生效",
  "提交失败": "提交失败",
  "提交成功": "提交成功",
  "提交订单": "提交订单",
  "提交退货成功": "提交退货成功",
  "提前分包": "提前分包",
  "提前送货": "提前送货",
  "提前采购": "提前采购",
  "提成分类提成": "提成分类提成",
  "提成商品提成": "提成商品提成",
  "提成奖励": "提成奖励",
  "提成扣点率%": "提成扣点率%",
  "提成方案": "提成方案",
  "提成方案配置": "提成方案配置",
  "提成比例": "提成比例",
  "提成类型": "提成类型",
  "提成金额": "提成金额",
  "提现金额": "提现金额",
  "提示": "提示",
  "提示：操作前请确认对方账户信息": "提示：操作前请确认对方账户信息",
  "提示：操作前请确认账户收到款项": "提示：操作前请确认账户收到款项",
  "提示：通过Tab键切换下一项": "提示：通过Tab键切换下一项",
  "提示：通过方向键切换商品，Tab键切换到规格": "提示：通过方向键切换商品，Tab键切换到规格",
  "搜索": "搜索",
  "搜索商品名称": "搜索商品名称",
  "搜索客户名称": "搜索客户名称",
  "搜索线路": "搜索线路",
  "摘要": "摘要",
  "撤销对账单": "撤销对账单",
  "操作": "操作",
  "操作人": "操作人",
  "操作信息": "操作信息",
  "操作参见": "操作参见",
  "操作员": "操作员",
  "操作失败": "操作失败",
  "操作开始时间": "操作开始时间",
  "操作成功": "操作成功",
  "操作日志": "操作日志",
  "操作时间": "操作时间",
  "操作端": "操作端",
  "操作类型": "操作类型",
  "操作结束时间": "操作结束时间",
  "支付": "支付",
  "支付宝": "支付宝",
  "支付宝结算": "支付宝结算",
  "支付密钥": "支付密钥",
  "支付密钥不能为空": "支付密钥不能为空",
  "支付方式": "支付方式",
  "支付款支付": "支付款支付",
  "支付证书": "支付证书",
  "支出": "支出",
  "支持商品自定义编号及商品首字母搜索。": "支持商品自定义编号及商品首字母搜索。",
  "支持客户企业编号及客户名称首字母搜索。": "支持客户企业编号及客户名称首字母搜索。",
  "收付": "收付",
  "收付信息": "收付信息",
  "收入": "收入",
  "收到票据": "收到票据",
  "收取押金": "收取押金",
  "收支合计": "收支合计",
  "收支状态": "收支状态",
  "收款": "收款",
  "收款企业名称": "收款企业名称",
  "收款信息": "收款信息",
  "收款情况": "收款情况",
  "收款方": "收款方",
  "收款方名称": "收款方名称",
  "收款日期": "收款日期",
  "收款类型": "收款类型",
  "收款统计": "收款统计",
  "收款记录": "收款记录",
  "收款账户": "收款账户",
  "收款金额": "收款金额",
  "收溢": "收溢",
  "收货入库": "收货入库",
  "收货入库&制业务单": "收货入库&制业务单",
  "收货单": "收货单",
  "收货单导出": "收货单导出",
  "收货地址": "收货地址",
  "收货对方": "收货对方",
  "收货待结算": "收货待结算",
  "收货数量": "收货数量",
  "收费会员制": "收费会员制",
  "收起": "收起",
  "收银员": "收银员",
  "数据大屏": "数据大屏",
  "数据导出下单日期时间范围超出31天，请重新选择下单日期，并筛选后再导": "数据导出下单日期时间范围超出31天，请重新选择下单日期，并筛选后再导",
  "数据导出时间范围超出31天，请重新选择时间，并筛选后再导": "数据导出时间范围超出31天，请重新选择时间，并筛选后再导",
  "数据导出送货时间范围超出31天，请重新选择送货日期，并筛选后再导": "数据导出送货时间范围超出31天，请重新选择送货日期，并筛选后再导",
  "数据未保存，确认离开该页面?": "数据未保存，确认离开该页面?",
  "数据错误": "数据错误",
  "数量": "数量",
  "数量不能为空": "数量不能为空",
  "数量必须大于0": "数量必须大于0",
  "整体进度": "整体进度",
  "文件上传成功，请等待后台自动导入!": "文件上传成功，请等待后台自动导入!",
  "文件上传错误": "文件上传错误",
  "文件只能为pem格式，请检查文件类型!": "文件只能为pem格式，请检查文件类型!",
  "斤": "斤",
  "新品上架": "新品上架",
  "新品特惠页主图": "新品特惠页主图",
  "新增": "新增",
  "新增一级标签": "新增一级标签",
  "新增代收点": "新增代收点",
  "新增供货商": "新增供货商",
  "新增入库": "新增入库",
  "新增分割商品": "新增分割商品",
  "新增客户": "新增客户",
  "新增工序": "新增工序",
  "新增成功": "新增成功",
  "新增报价": "新增报价",
  "新增星级配送费": "新增星级配送费",
  "新增篮筐": "新增篮筐",
  "新增询价": "新增询价",
  "新增调价": "新增调价",
  "新增账户": "新增账户",
  "新增退货": "新增退货",
  "新密码": "新密码",
  "新密码不一致!": "新密码不一致!",
  "新建线路时非必选": "新建线路时非必选",
  "新手指南": "新手指南",
  "新拜访": "新拜访",
  "新订单-待生效": "新订单-待生效",
  "新订单待生效": "新订单待生效",
  "新账号冻结需后台开启": "新账号冻结需后台开启",
  "新闻": "新闻",
  "新闻详情": "新闻详情",
  "方式": "方式",
  "方案": "方案",
  "方案名称": "方案名称",
  "无": "无",
  "无入库单号": "无入库单号",
  "无可拆分数量": "无可拆分数量",
  "无可提交的入库量": "无可提交的入库量",
  "无商品可提交": "无商品可提交",
  "日供应量": "日供应量",
  "日志": "日志",
  "日期": "日期",
  "旧密码": "旧密码",
  "时间": "时间",
  "时间/批次": "时间/批次",
  "时间排序": "时间排序",
  "时间点": "时间点",
  "时间范围：客户当天可选择的送货时间，默认为00:00-23:59": "时间范围：客户当天可选择的送货时间，默认为00:00-23:59",
  "时间要求": "时间要求",
  "明细": "明细",
  "明细备注": "明细备注",
  "星期一": "星期一",
  "星期三": "星期三",
  "星期二": "星期二",
  "星期四": "星期四",
  "星期五": "星期五",
  "星期六": "星期六",
  "星期天": "星期天",
  "星期日": "星期日",
  "星级": "星级",
  "星级指定价 （针对不同客户等级的指定销售价格）。": "星级指定价 （针对不同客户等级的指定销售价格）。",
  "星级配送费": "星级配送费",
  "星级阶梯价格": "星级阶梯价格",
  "星级阶梯优惠 （商品的某星级一个订单中数量达标准 即按成本加本级利润的价格）。": "星级阶梯优惠 （商品的某星级一个订单中数量达标准 即按成本加本级利润的价格）。",
  "昨天": "昨天",
  "是否停用该篮筐": "是否停用该篮筐",
  "是否允许供货商修改分拣数量": "是否允许供货商修改分拣数量",
  "是否减库存采购": "是否减库存采购",
  "是否删除商品?": "是否删除商品?",
  "是否删除商品该星级指定价": "是否删除商品该星级指定价",
  "是否删除所有协议价?": "是否删除所有协议价?",
  "是否删除该数据": "是否删除该数据",
  "是否删除该加工任务": "是否删除该加工任务",
  "是否删除该商品?": "是否删除该商品?",
  "是否删除选中篮筐?": "是否删除选中篮筐?",
  "是否合并相同商品": "是否合并相同商品",
  "是否启用该篮筐": "是否启用该篮筐",
  "是否打印供货商": "是否打印供货商",
  "是否打印出库时间": "是否打印出库时间",
  "是否打印分拣员": "是否打印分拣员",
  "是否打印商品自定义编号": "是否打印商品自定义编号",
  "是否打印固定行数": "是否打印固定行数",
  "是否打印联系方式": "是否打印联系方式",
  "是否打印送货人电话": "是否打印送货人电话",
  "是否打印送货时间": "是否打印送货时间",
  "是否打印送货时间方式": "是否打印送货时间方式",
  "是否打印金额大写": "是否打印金额大写",
  "是否拒绝退筐": "是否拒绝退筐",
  "是否提交?": "是否提交?",
  "是否撤销该对账单": "是否撤销该对账单",
  "是否显示修改按钮": "是否显示修改按钮",
  "是否显示完成路径": "是否显示完成路径",
  "是否显示距离": "是否显示距离",
  "是否清空购物车?": "是否清空购物车?",
  "是否确认修改?": "是否确认修改?",
  "是否确认冻结/解冻?": "是否确认冻结/解冻?",
  "是否确认删除?": "是否确认删除?",
  "是否确认删除订单?": "是否确认删除订单?",
  "是否确认取消订单?": "是否确认取消订单?",
  "是否确认执行该操作?": "是否确认执行该操作?",
  "是否确认移除该关联订单?": "是否确认移除该关联订单?",
  "是否要提前转分包，操作后无法撤回": "是否要提前转分包，操作后无法撤回",
  "是否要提前转送货，操作后无法撤回": "是否要提前转送货，操作后无法撤回",
  "是否要提前转采购，操作后无法撤回": "是否要提前转采购，操作后无法撤回",
  "是否进行批量删除?": "是否进行批量删除?",
  "是否进行退筐操作?": "是否进行退筐操作?",
  "是否需要显示单位领导签字": "是否需要显示单位领导签字",
  "昵称": "昵称",
  "显示": "显示",
  "显示名称": "显示名称",
  "显示客户名称(注意:客户数量过多会导致页面卡顿)": "显示客户名称(注意:客户数量过多会导致页面卡顿)",
  "显示库存量为0的商品": "显示库存量为0的商品",
  "显示排序": "显示排序",
  "普通商品": "普通商品",
  "智能小菜提醒": "智能小菜提醒",
  "暂无": "暂无",
  "暂无商品信息": "暂无商品信息",
  "暂无商品可生成，请选择微信导入或excel导入!": "暂无商品可生成，请选择微信导入或excel导入!",
  "暂无数据": "暂无数据",
  "暂无更多商品": "暂无更多商品",
  "更换": "更换",
  "更改角色岗位将影响下级人员(不是该角色岗位的下级都会移除)": "更改角色岗位将影响下级人员(不是该角色岗位的下级都会移除)",
  "更新内容": "更新内容",
  "最低起购数量": "最低起购数量",
  "最多上传5张活动图": "最多上传5张活动图",
  "最多上传{limit}张图片": "最多上传{limit}张图片",
  "最多保存20个模板": "最多保存20个模板",
  "最多筛选31天时间内数据": "最多筛选31天时间内数据",
  "最多筛选一个月时间范围数据": "最多筛选一个月时间范围数据",
  "最多能搜索两个月内数据": "最多能搜索两个月内数据",
  "最小起购量": "最小起购量",
  "最新报价": "最新报价",
  "最近": "最近",
  "最近下单": "最近下单",
  "最高警报库存量 必须大于 最低警报库存量": "最高警报库存量 必须大于 最低警报库存量",
  "最高限购应大于最低起购数": "最高限购应大于最低起购数",
  "最高限购数量": "最高限购数量",
  "月结": "月结",
  "有效保质期": "有效保质期",
  "有效时间": "有效时间",
  "有效期": "有效期",
  "有效期至": "有效期至",
  "有效期限": "有效期限",
  "期初存量": "期初存量",
  "期初金额": "期初金额",
  "期末节余": "期末节余",
  "期末金额": "期末金额",
  "未分拣": "未分拣",
  "未匹配到正确商品，请核对商品名称及规格、单价、数量!": "未匹配到正确商品，请核对商品名称及规格、单价、数量!",
  "未发起报账": "未发起报账",
  "未处理": "未处理",
  "未完成": "未完成",
  "未审核": "未审核",
  "未开票": "未开票",
  "未打印": "未打印",
  "未找到对应地址": "未找到对应地址",
  "未排单": "未排单",
  "未支付": "未支付",
  "未支付，订单未含押金": "未支付，订单未含押金",
  "未收到客户货款前，本页类目商品为本公司所有": "未收到客户货款前，本页类目商品为本公司所有",
  "未收到票据": "未收到票据",
  "未知": "未知",
  "未警报": "未警报",
  "未转单": "未转单",
  "未过期": "未过期",
  "未配置打印模板": "未配置打印模板",
  "未锁定": "未锁定",
  "本件货品清单": "本件货品清单",
  "本商品的售价定价方式采用了公式计价，所以此刻只能对规格成本一栏进行编辑，商品定价请在 采购一询价定价 页面设置!": "本商品的售价定价方式采用了公式计价，所以此刻只能对规格成本一栏进行编辑，商品定价请在 采购一询价定价 页面设置!",
  "本商品详情信息变动，商品定价方式将自动更新为指定售价方式，如需按成本利润率自动变更计算商品售价，请到采购菜单的商品定价页面对本商品进行设置!": "本商品详情信息变动，商品定价方式将自动更新为指定售价方式，如需按成本利润率自动变更计算商品售价，请到采购菜单的商品定价页面对本商品进行设置!",
  "本批次所实际采购数量，低于应采购数量": "本批次所实际采购数量，低于应采购数量",
  "本次付款": "本次付款",
  "本次实收": "本次实收",
  "本次实收金额": "本次实收金额",
  "本次应收金额": "本次应收金额",
  "本次收款": "本次收款",
  "本次询价结果的有效期，将延续到下次询价时价格的更新。请注意及时询价以保证商品价格及时性。": "本次询价结果的有效期，将延续到下次询价时价格的更新。请注意及时询价以保证商品价格及时性。",
  "本页商品已经确认验收": "本页商品已经确认验收",
  "机关": "机关",
  "条": "条",
  "条形码": "条形码",
  "条形码不能为空": "条形码不能为空",
  "来筐商家": "来筐商家",
  "来筐时间": "来筐时间",
  "查看": "查看",
  "查看入库单": "查看入库单",
  "查看商品": "查看商品",
  "查看更多": "查看更多",
  "查看更多今日经营数据": "查看更多今日经营数据",
  "查看清单": "查看清单",
  "查看结算单": "查看结算单",
  "查看订单": "查看订单",
  "查看记录": "查看记录",
  "查看详单": "查看详单",
  "查看送货单": "查看送货单",
  "查询": "查询",
  "标准": "标准",
  "标准模板": "标准模板",
  "标准模板打印": "标准模板打印",
  "标准量": "标准量",
  "标签": "标签",
  "标签名不能为空": "标签名不能为空",
  "标签名称": "标签名称",
  "标签商品信息": "标签商品信息",
  "标签商品名称": "标签商品名称",
  "标签已存在": "标签已存在",
  "标签打印Logo": "标签打印Logo",
  "标签打印二维码": "标签打印二维码",
  "标签模板": "标签模板",
  "标签模板编号": "标签模板编号",
  "标签码记录": "标签码记录",
  "标识": "标识",
  "标识状态": "标识状态",
  "标题名称": "标题名称",
  "样品编号": "样品编号",
  "根据利润率直接计算出售价": "根据利润率直接计算出售价",
  "根据运营周期内完成采购任务的数据计算得出": "根据运营周期内完成采购任务的数据计算得出",
  "框选": "框选",
  "检测上传时间": "检测上传时间",
  "检测人": "检测人",
  "检测人员": "检测人员",
  "检测信息": "检测信息",
  "检测值": "检测值",
  "检测地址": "检测地址",
  "检测数值": "检测数值",
  "检测日期": "检测日期",
  "检测结果": "检测结果",
  "检测项目": "检测项目",
  "检疫人员": "检疫人员",
  "模块名称": "模块名称",
  "模板": "模板",
  "模板名称": "模板名称",
  "模板样式示意": "模板样式示意",
  "模板类型": "模板类型",
  "欠款": "欠款",
  "欠款金额": "欠款金额",
  "欠款限制": "欠款限制",
  "欢迎在售后客服": "欢迎在售后客服",
  "欢迎登录": "欢迎登录",
  "欢迎登录-蔬果云专业生鲜配送系统": "欢迎登录-蔬果云专业生鲜配送系统",
  "欢迎页": "欢迎页",
  "款": "款",
  "正在上传数据，无法打印": "正在上传数据，无法打印",
  "正在为{name}下单": "正在为{name}下单",
  "正在创建导出任务，完成后即可在右侧窗口下载": "正在创建导出任务，完成后即可在右侧窗口下载",
  "正在提交数据，无法关闭": "正在提交数据，无法关闭",
  "正常": "正常",
  "正常供货": "正常供货",
  "正常出库": "正常出库",
  "正常出库流程为，配送人员在APP端，参照订单商品清单，验货并出库，以保证商品齐全。": "正常出库流程为，配送人员在APP端，参照订单商品清单，验货并出库，以保证商品齐全。",
  "正常售价": "正常售价",
  "正整数且最多两位小数": "正整数且最多两位小数",
  "此为子账号的岗位名称，非必选": "此为子账号的岗位名称，非必选",
  "此处信息请勿随意更改，可能引起小程序错误，信息配置请咨询技术客服人员": "此处信息请勿随意更改，可能引起小程序错误，信息配置请咨询技术客服人员",
  "此操作将下载excel文件, 是否继续?": "此操作将下载excel文件, 是否继续?",
  "此操作将全部验货成功, 是否继续?": "此操作将全部验货成功, 是否继续?",
  "此操作将删除该周转筐, 是否继续?": "此操作将删除该周转筐, 是否继续?",
  "此操作将删除该数据，是否继续?": "此操作将删除该数据，是否继续?",
  "此操作将导出excel文件, 是否继续?": "此操作将导出excel文件, 是否继续?",
  "此操作将批量入库申请, 是否继续?": "此操作将批量入库申请, 是否继续?",
  "此操作将拒绝入库申请, 是否继续?": "此操作将拒绝入库申请, 是否继续?",
  "此操作将无法撤回，是否确认提交?": "此操作将无法撤回，是否确认提交?",
  "此操作将清空所填写数据，是否继续?": "此操作将清空所填写数据，是否继续?",
  "此操作将直接加入订单, 是否继续?(若需删除周转筐,可至配送任务出库中确认删除)": "此操作将直接加入订单, 是否继续?(若需删除周转筐,可至配送任务出库中确认删除)",
  "此操作将移除该入库单, 是否继续?": "此操作将移除该入库单, 是否继续?",
  "此订单有商品售价低于成本价哦，是否继续出库": "此订单有商品售价低于成本价哦，是否继续出库",
  "每一{unit}产出": "每一{unit}产出",
  "每人每天限购": "每人每天限购",
  "每增：$SPLIT$公里，运费加$SPLIT${yuan}": "每增：$SPLIT$公里，运费加$SPLIT${yuan}",
  "每日下单截止时间": "每日下单截止时间",
  "每日经营概况": "每日经营概况",
  "比例只能在0~99之间": "比例只能在0~99之间",
  "毛利": "毛利",
  "毛利=(销售金额-退货金额)-(销售成本-退货成本)": "毛利=(销售金额-退货金额)-(销售成本-退货成本)",
  "毛利润": "毛利润",
  "毛利润 = 出库金额 - (采购结算 - 入库金额) - 存量出货 + 盘点金额": "毛利润 = 出库金额 - (采购结算 - 入库金额) - 存量出货 + 盘点金额",
  "毛利润 = 结算金额 - 出库成本- 损耗成本": "毛利润 = 结算金额 - 出库成本- 损耗成本",
  "毛利润额": "毛利润额",
  "毛利润：出库额-（库存额+入库额-节余额）。": "毛利润：出库额-（库存额+入库额-节余额）。",
  "毛利率": "毛利率",
  "毛利率 = 毛利润 / 结算金额": "毛利率 = 毛利润 / 结算金额",
  "毛利率=毛利 / (销售金额-退货金额)": "毛利率=毛利 / (销售金额-退货金额)",
  "毛利率排序": "毛利率排序",
  "毛利统计为已收货后的订单": "毛利统计为已收货后的订单",
  "没有更多了": "没有更多了",
  "没有账期限制，什么时候结算对下单都不影响": "没有账期限制，什么时候结算对下单都不影响",
  "注册": "注册",
  "注册号": "注册号",
  "注册成功，请复制链接到PC端登录": "注册成功，请复制链接到PC端登录",
  "注册用户协议": "注册用户协议",
  "注册隐私协议": "注册隐私协议",
  "活动ID": "活动ID",
  "活动主题": "活动主题",
  "活动价": "活动价",
  "活动信息": "活动信息",
  "活动名搜索": "活动名搜索",
  "活动名称": "活动名称",
  "活动商品": "活动商品",
  "活动商品模板": "活动商品模板",
  "活动商家": "活动商家",
  "活动图": "活动图",
  "活动图上传失败": "活动图上传失败",
  "活动图标名称": "活动图标名称",
  "活动图标描述": "活动图标描述",
  "活动时间": "活动时间",
  "活动有效期": "活动有效期",
  "活动标题": "活动标题",
  "活动特价": "活动特价",
  "活动类型": "活动类型",
  "活动统计": "活动统计",
  "活动详情": "活动详情",
  "活动说明": "活动说明",
  "活动链接": "活动链接",
  "活动页背景图": "活动页背景图",
  "活动页背景色": "活动页背景色",
  "流水号": "流水号",
  "流水记录": "流水记录",
  "消息": "消息",
  "消费金额满$SPLIT${yuan}/单，减免$SPLIT${yuan}": "消费金额满$SPLIT${yuan}/单，减免$SPLIT${yuan}",
  "添加": "添加",
  "添加为我的商品": "添加为我的商品",
  "添加人员": "添加人员",
  "添加人员账号": "添加人员账号",
  "添加仓库": "添加仓库",
  "添加供货来筐": "添加供货来筐",
  "添加公告": "添加公告",
  "添加分类": "添加分类",
  "添加到": "添加到",
  "添加商品": "添加商品",
  "添加商品成功!": "添加商品成功!",
  "添加均摊": "添加均摊",
  "添加客户": "添加客户",
  "添加工作人员": "添加工作人员",
  "添加广告图": "添加广告图",
  "添加成功": "添加成功",
  "添加报价": "添加报价",
  "添加提成方案": "添加提成方案",
  "添加新客户": "添加新客户",
  "添加时间": "添加时间",
  "添加标签": "添加标签",
  "添加溯源信息": "添加溯源信息",
  "添加电子围栏": "添加电子围栏",
  "添加篮筐": "添加篮筐",
  "添加表单据": "添加表单据",
  "添加规格": "添加规格",
  "添加角色岗位": "添加角色岗位",
  "添加账户": "添加账户",
  "添加购物车成功!": "添加购物车成功!",
  "添加路线": "添加路线",
  "清仓特惠": "清仓特惠",
  "清空": "清空",
  "清空所选": "清空所选",
  "清空购物车": "清空购物车",
  "温馨提示": "温馨提示",
  "温馨提示：到结账日了客户仍无法结算但又需要下单时，可将结账日往后拖延2天 设置哦~": "温馨提示：到结账日了客户仍无法结算但又需要下单时，可将结账日往后拖延2天 设置哦~",
  "游客不可见价格": "游客不可见价格",
  "湖南云商世纪网络信息科技有限公司": "湖南云商世纪网络信息科技有限公司",
  "源商品": "源商品",
  "源商品名称": "源商品名称",
  "满$SPLIT${yuan}/单起送": "满$SPLIT${yuan}/单起送",
  "满$SPLIT${yuan}/单起送或满$SPLIT$kg/单起送": "满$SPLIT${yuan}/单起送或满$SPLIT$kg/单起送",
  "满{ladder}{unit}时{money}{yuan}": "满{ladder}{unit}时{money}{yuan}",
  "满{num}{unit}起配{name}": "满{num}{unit}起配{name}",
  "满减": "满减",
  "满减/积分": "满减/积分",
  "满减促销": "满减促销",
  "满减信息": "满减信息",
  "满减折扣": "满减折扣",
  "满减标准": "满减标准",
  "满减标准不能小于赠券面额": "满减标准不能小于赠券面额",
  "满减：商品金额满{num}{yuan}减{num}{yuan}。例：订单商品满2{num1}{yuan}减{num2}{yuan}": "满减：商品金额满{num}{yuan}减{num}{yuan}。例：订单商品满2{num1}{yuan}减{num2}{yuan}",
  "点“匹配商品”，自动关联查询商品（手工下单方式不用点）": "点“匹配商品”，自动关联查询商品（手工下单方式不用点）",
  "点击上传": "点击上传",
  "点击加载": "点击加载",
  "点击开始描边框选。双击鼠标左键或单击鼠标右键可完成框选 并且进入描边绘制(至少3个点才能描边绘制)": "点击开始描边框选。双击鼠标左键或单击鼠标右键可完成框选 并且进入描边绘制(至少3个点才能描边绘制)",
  "点击查看详情": "点击查看详情",
  "点击标记点可选择(注意:如果客户多个订单,只会选择一个订单)": "点击标记点可选择(注意:如果客户多个订单,只会选择一个订单)",
  "热销商品排名": "热销商品排名",
  "照片": "照片",
  "爆品": "爆品",
  "爆品分类": "爆品分类",
  "特价": "特价",
  "特价促销": "特价促销",
  "特价活动": "特价活动",
  "特价活动审核": "特价活动审核",
  "状态": "状态",
  "状态已变更!": "状态已变更!",
  "状态筛选": "状态筛选",
  "现价": "现价",
  "现货": "现货",
  "现金": "现金",
  "现金结算": "现金结算",
  "理货人员": "理货人员",
  "理货时间": "理货时间",
  "瑞尔": "瑞尔",
  "瓶": "瓶",
  "生产": "生产",
  "生产企业": "生产企业",
  "生产企业不能为空": "生产企业不能为空",
  "生产商信息": "生产商信息",
  "生产商注册号": "生产商注册号",
  "生产地址": "生产地址",
  "生产批次": "生产批次",
  "生产批次不能为空": "生产批次不能为空",
  "生产日期": "生产日期",
  "生产环境照或生产许可证": "生产环境照或生产许可证",
  "生成": "生成",
  "生鲜采购配送系统": "生鲜采购配送系统",
  "用于分批打印送货单，是否打印的提示": "用于分批打印送货单，是否打印的提示",
  "用于结账收支环节的账户记录": "用于结账收支环节的账户记录",
  "用于跟款": "用于跟款",
  "用卡情况": "用卡情况",
  "用户ID": "用户ID",
  "用户信息": "用户信息",
  "用户名": "用户名",
  "用户在小程序商城领取，订单确认时参与减扣结算。": "用户在小程序商城领取，订单确认时参与减扣结算。",
  "用户已领取的优惠券也将同步下架不可使用，确认下架该优惠券?": "用户已领取的优惠券也将同步下架不可使用，确认下架该优惠券?",
  "用户收货后，按订单金额比例提成，发放到账户余额": "用户收货后，按订单金额比例提成，发放到账户余额",
  "用户端-客户电子签名": "用户端-客户电子签名",
  "用户类型": "用户类型",
  "用户账号": "用户账号",
  "甲方签字盖章": "甲方签字盖章",
  "申请": "申请",
  "申请中": "申请中",
  "申请人信息": "申请人信息",
  "申请售后": "申请售后",
  "申请售后时间不能小于1小时(正整数)": "申请售后时间不能小于1小时(正整数)",
  "申请处理": "申请处理",
  "申请建议价": "申请建议价",
  "申请开始时间": "申请开始时间",
  "申请成功": "申请成功",
  "申请数": "申请数",
  "申请状态": "申请状态",
  "申请结束时间": "申请结束时间",
  "申请退框": "申请退框",
  "申请退筐": "申请退筐",
  "申请驳回": "申请驳回",
  "电话": "电话",
  "电话客服": "电话客服",
  "男": "男",
  "登录前请ctrl+F5强制刷新": "登录前请ctrl+F5强制刷新",
  "登录密码": "登录密码",
  "登录帐号": "登录帐号",
  "登录端口": "登录端口",
  "登录账号/手机号": "登录账号/手机号",
  "盘亏": "盘亏",
  "盘存": "盘存",
  "盘存损耗": "盘存损耗",
  "盘存数量": "盘存数量",
  "盘点": "盘点",
  "盘点信息": "盘点信息",
  "盘点记录": "盘点记录",
  "盘点金额": "盘点金额",
  "盘盈": "盘盈",
  "目前客户只有一次，在收货时进行售后的机会，收货时报损或少量，即会发起异常报警记录，后台介入处理售后。": "目前客户只有一次，在收货时进行售后的机会，收货时报损或少量，即会发起异常报警记录，后台介入处理售后。",
  "目的": "目的",
  "相关商品不能为空": "相关商品不能为空",
  "相同规格的任务合并": "相同规格的任务合并",
  "看结算单": "看结算单",
  "知道了，今日不再显示": "知道了，今日不再显示",
  "短信充值": "短信充值",
  "短信发送内容": "短信发送内容",
  "短信发送成功": "短信发送成功",
  "短信宝密码不能为空": "短信宝密码不能为空",
  "短信宝帐号不能为空": "短信宝帐号不能为空",
  "短信宝平台密码": "短信宝平台密码",
  "短信宝平台账号": "短信宝平台账号",
  "短信平台信息配置": "短信平台信息配置",
  "短信通知": "短信通知",
  "确定": "确定",
  "确定出库": "确定出库",
  "确定创建对账单?": "确定创建对账单?",
  "确定要一键关闭库存量足任务吗": "确定要一键关闭库存量足任务吗",
  "确定要一键库存量置零吗?": "确定要一键库存量置零吗?",
  "确定要关闭此任务吗": "确定要关闭此任务吗",
  "确定要关闭选中的任务吗?": "确定要关闭选中的任务吗?",
  "确认": "确认",
  "确认上架该优惠券?": "确认上架该优惠券?",
  "确认上架该推荐?": "确认上架该推荐?",
  "确认上架该特价活动?": "确认上架该特价活动?",
  "确认下架商品?": "确认下架商品?",
  "确认下架该推荐?": "确认下架该推荐?",
  "确认下架该特价活动?": "确认下架该特价活动?",
  "确认付款": "确认付款",
  "确认以该业务员账号创建客户?": "确认以该业务员账号创建客户?",
  "确认关闭该审核": "确认关闭该审核",
  "确认删除客户?": "确认删除客户?",
  "确认删除改记录?": "确认删除改记录?",
  "确认删除改询价记录?": "确认删除改询价记录?",
  "确认删除角色岗位?(只能删除当前岗位下无人员账号)": "确认删除角色岗位?(只能删除当前岗位下无人员账号)",
  "确认删除该人员账号": "确认删除该人员账号",
  "确认删除该入库退货单?": "确认删除该入库退货单?",
  "确认删除该商品吗?": "确认删除该商品吗?",
  "确认删除该报账单?": "确认删除该报账单?",
  "确认删除该提成方案?": "确认删除该提成方案?",
  "确认删除该活动": "确认删除该活动",
  "确认删除该记录": "确认删除该记录",
  "确认删除该账户?": "确认删除该账户?",
  "确认审核拒绝该优惠券?": "确认审核拒绝该优惠券?",
  "确认审核拒绝该特价活动?": "确认审核拒绝该特价活动?",
  "确认审核通过该优惠券?": "确认审核通过该优惠券?",
  "确认审核通过该特价活动?": "确认审核通过该特价活动?",
  "确认密码": "确认密码",
  "确认将已选商品批量转库存现货?": "确认将已选商品批量转库存现货?",
  "确认将已选商品批量转转预售采购?": "确认将已选商品批量转转预售采购?",
  "确认将已选商品直接入库?": "确认将已选商品直接入库?",
  "确认将该审核通过?": "确认将该审核通过?",
  "确认批量修改已选商品的活动时间?": "确认批量修改已选商品的活动时间?",
  "确认批量处理已选项已开票?": "确认批量处理已选项已开票?",
  "确认批量处理已选项拒绝开票?": "确认批量处理已选项拒绝开票?",
  "确认批量收款?": "确认批量收款?",
  "确认提交": "确认提交",
  "确认提交后可打印": "确认提交后可打印",
  "确认提交报账?": "确认提交报账?",
  "确认提交此发票编号?": "确认提交此发票编号?",
  "确认收款": "确认收款",
  "确认新增围栏": "确认新增围栏",
  "确认更改客户状态?": "确认更改客户状态?",
  "确认移除该商品?(如果该商品绑定的均摊没有绑定其他商品，均摊也将移除)": "确认移除该商品?(如果该商品绑定的均摊没有绑定其他商品，均摊也将移除)",
  "确认移除该均摊?(移除后关联商品将重新计算均摊数据!)": "确认移除该均摊?(移除后关联商品将重新计算均摊数据!)",
  "确认编辑围栏": "确认编辑围栏",
  "确认要删除文件吗?": "确认要删除文件吗?",
  "确认要删除该仓库?": "确认要删除该仓库?",
  "确认要删除该农残记录?": "确认要删除该农残记录?",
  "确认要删除该商品溯源记录?": "确认要删除该商品溯源记录?",
  "确认该记录已全部装车?": "确认该记录已全部装车?",
  "确认转取货任务?": "确认转取货任务?",
  "确认转派": "确认转派",
  "确认退货该商品吗?": "确认退货该商品吗?",
  "确认驳回该售后申请?": "确认驳回该售后申请?",
  "禁止送货复称出库": "禁止送货复称出库",
  "种": "种",
  "种类": "种类",
  "秘密不能为空": "秘密不能为空",
  "积分": "积分",
  "积分余额": "积分余额",
  "积分抵扣": "积分抵扣",
  "积分支出": "积分支出",
  "积分收入": "积分收入",
  "积分流水": "积分流水",
  "积分自动兑换到余额(每天的营业截止时间点)，积分账户金额的$SPLIT$%，兑换比例: {num}{yuan}=$SPLIT$积分": "积分自动兑换到余额(每天的营业截止时间点)，积分账户金额的$SPLIT$%，兑换比例: {num}{yuan}=$SPLIT$积分",
  "积分调节": "积分调节",
  "移除": "移除",
  "移除商品": "移除商品",
  "移除均摊": "移除均摊",
  "移除成功": "移除成功",
  "稍后更新": "稍后更新",
  "税号": "税号",
  "税率": "税率",
  "税费成本": "税费成本",
  "税额": "税额",
  "立即更新": "立即更新",
  "立即注册": "立即注册",
  "笔": "笔",
  "等级": "等级",
  "等级名称": "等级名称",
  "等级管理": "等级管理",
  "等级阶梯折扣": "等级阶梯折扣",
  "筐": "筐",
  "筐号": "筐号",
  "筛选": "筛选",
  "签字": "签字",
  "签收": "签收",
  "签章": "签章",
  "管理": "管理",
  "管理人员": "管理人员",
  "管理员": "管理员",
  "管理员权限不可更改": "管理员权限不可更改",
  "管理员编号": "管理员编号",
  "管理商品分类": "管理商品分类",
  "管理端": "管理端",
  "管理设置": "管理设置",
  "管理账号": "管理账号",
  "箱": "箱",
  "篮号": "篮号",
  "篮筐": "篮筐",
  "篮筐信息": "篮筐信息",
  "篮筐号": "篮筐号",
  "篮筐名称": "篮筐名称",
  "篮筐商品": "篮筐商品",
  "篮筐图片": "篮筐图片",
  "篮筐状态": "篮筐状态",
  "篮筐租借记录": "篮筐租借记录",
  "篮筐管理": "篮筐管理",
  "篮筐类型": "篮筐类型",
  "类型": "类型",
  "类目": "类目",
  "粘贴": "粘贴",
  "紧急联系人": "紧急联系人",
  "累入库额": "累入库额",
  "累出库额": "累出库额",
  "累积采购数量": "累积采购数量",
  "累计下单金额": "累计下单金额",
  "累计入库量": "累计入库量",
  "累计出库成本": "累计出库成本",
  "累计出货金额": "累计出货金额",
  "累计利润": "累计利润",
  "累计剩余量": "累计剩余量",
  "累计商品种类": "累计商品种类",
  "累计客户": "累计客户",
  "累计成本": "累计成本",
  "累计批次": "累计批次",
  "累计损耗量": "累计损耗量",
  "累计订单": "累计订单",
  "累计采购": "累计采购",
  "累计采购单": "累计采购单",
  "累计采购总量": "累计采购总量",
  "累计采购数量": "累计采购数量",
  "累计采购额": "累计采购额",
  "累计重量": "累计重量",
  "累计金额": "累计金额",
  "累计销售": "累计销售",
  "累计销售额": "累计销售额",
  "累计销量": "累计销量",
  "约": "约",
  "纬度": "纬度",
  "线上": "线上",
  "线上询价": "线上询价",
  "线下": "线下",
  "线下与门店结算": "线下与门店结算",
  "线下到付": "线下到付",
  "线下到付：客户需要把上一个订单结算后才能继续下单": "线下到付：客户需要把上一个订单结算后才能继续下单",
  "线下周结": "线下周结",
  "线下周结：选择周一至周日为结账日，到结账日时，未结账客户无法继续下单": "线下周结：选择周一至周日为结账日，到结账日时，未结账客户无法继续下单",
  "线下支付": "线下支付",
  "线下月结": "线下月结",
  "线下月结：选择日期为结账日，到结账日时，未结账客户无法继续下单": "线下月结：选择日期为结账日，到结账日时，未结账客户无法继续下单",
  "线下结算": "线下结算",
  "线路": "线路",
  "线路名称": "线路名称",
  "线路简称": "线路简称",
  "线路管理": "线路管理",
  "线路篮号": "线路篮号",
  "组件": "组件",
  "组织结构": "组织结构",
  "经度": "经度",
  "经手": "经手",
  "经营周期": "经营周期",
  "经营商品描述": "经营商品描述",
  "经营地址": "经营地址",
  "经营数据": "经营数据",
  "经营时间": "经营时间",
  "经营行业": "经营行业",
  "绑定情况": "绑定情况",
  "结束": "结束",
  "结束日期": "结束日期",
  "结束时间": "结束时间",
  "结果": "结果",
  "结算": "结算",
  "结算优先机制": "结算优先机制",
  "结算信息": "结算信息",
  "结算利润": "结算利润",
  "结算单": "结算单",
  "结算单号": "结算单号",
  "结算单或入库单号": "结算单或入库单号",
  "结算单收款": "结算单收款",
  "结算单状态": "结算单状态",
  "结算单详情": "结算单详情",
  "结算单进度": "结算单进度",
  "结算完成": "结算完成",
  "结算对账单": "结算对账单",
  "结算对账单到款金额": "结算对账单到款金额",
  "结算方式": "结算方式",
  "结算时间": "结算时间",
  "结算状态": "结算状态",
  "结算类型": "结算类型",
  "结算金额": "结算金额",
  "结算金额 = 销售金额 - 扣点金额": "结算金额 = 销售金额 - 扣点金额",
  "统计": "统计",
  "统计所有已出库的有效订单里的订单商品（已出库且非取消的订单）": "统计所有已出库的有效订单里的订单商品（已出库且非取消的订单）",
  "统计报表": "统计报表",
  "继续采购": "继续采购",
  "续费延期$SPLIT$联系客服": "续费延期$SPLIT$联系客服",
  "编号": "编号",
  "编号：{num} 商品已报账，无法继续报账!": "编号：{num} 商品已报账，无法继续报账!",
  "编辑": "编辑",
  "编辑优惠券": "编辑优惠券",
  "编辑加工": "编辑加工",
  "编辑客户": "编辑客户",
  "编辑客户条形码": "编辑客户条形码",
  "编辑对账单": "编辑对账单",
  "编辑成功": "编辑成功",
  "编辑星级配送费": "编辑星级配送费",
  "编辑特价活动": "编辑特价活动",
  "编辑的销量不能大于当前存量+原数据销量": "编辑的销量不能大于当前存量+原数据销量",
  "编辑篮筐": "编辑篮筐",
  "编辑账户": "编辑账户",
  "缺": "缺",
  "缺货": "缺货",
  "缺货商品是否打印": "缺货商品是否打印",
  "缺货无货": "缺货无货",
  "网络请求失败!": "网络请求失败!",
  "网络请求超时": "网络请求超时",
  "罚款金额": "罚款金额",
  "美元": "美元",
  "联系": "联系",
  "联系人": "联系人",
  "联系人及电话": "联系人及电话",
  "联系方式": "联系方式",
  "联系电话": "联系电话",
  "背景图上传失败": "背景图上传失败",
  "自动关联": "自动关联",
  "自动将库存商品为负数置零": "自动将库存商品为负数置零",
  "自动库存置零": "自动库存置零",
  "自动执行时间必须大于等于0": "自动执行时间必须大于等于0",
  "自动收货": "自动收货",
  "自动收货时间": "自动收货时间",
  "自动篮筐编号": "自动篮筐编号",
  "自动结算": "自动结算",
  "自动输入历史信息": "自动输入历史信息",
  "自动退款": "自动退款",
  "自定": "自定",
  "自定义": "自定义",
  "自定义信息": "自定义信息",
  "自定义分拣员": "自定义分拣员",
  "自定义周期": "自定义周期",
  "自定义时间": "自定义时间",
  "自定义签名添加": "自定义签名添加",
  "自定义编号": "自定义编号",
  "自定义表格信息": "自定义表格信息",
  "自定义订单收货时间，设置”2“后，代表订单送达或者出库2小时后自动收货": "自定义订单收货时间，设置”2“后，代表订单送达或者出库2小时后自动收货",
  "自定义首页": "自定义首页",
  "自然意外损耗": "自然意外损耗",
  "自编单号": "自编单号",
  "自编号": "自编号",
  "至少保留一个打印模板": "至少保留一个打印模板",
  "至少提交一条记录": "至少提交一条记录",
  "至少选择一个供应商或者客户": "至少选择一个供应商或者客户",
  "节余量": "节余量",
  "节余量：（库存量+入库量-出库量）。": "节余量：（库存量+入库量-出库量）。",
  "节余额": "节余额",
  "节余额 = 最后一次出库之后的存量*均衡成本": "节余额 = 最后一次出库之后的存量*均衡成本",
  "获取成功": "获取成功",
  "获取短信数量": "获取短信数量",
  "获取详情失败": "获取详情失败",
  "获取验证码": "获取验证码",
  "菜单导航搜索": "菜单导航搜索",
  "营业截止时间": "营业截止时间",
  "营业执照": "营业执照",
  "营销管理": "营销管理",
  "蔬果云生鲜ERP系统": "蔬果云生鲜ERP系统",
  "蔬果云管理后台": "蔬果云管理后台",
  "蔬果云管理后台-注册": "蔬果云管理后台-注册",
  "蔬果云管理后台-登录": "蔬果云管理后台-登录",
  "行业": "行业",
  "行程跟踪": "行程跟踪",
  "补录送货单修改": "补录送货单修改",
  "补货": "补货",
  "补货单": "补货单",
  "补送货单": "补送货单",
  "补齐余额": "补齐余额",
  "补齐时间": "补齐时间",
  "表单名称": "表单名称",
  "表项内容": "表项内容",
  "袋": "袋",
  "装": "装",
  "装车中": "装车中",
  "要求供货时间": "要求供货时间",
  "覆盖配送线路": "覆盖配送线路",
  "规格": "规格",
  "规格ID": "规格ID",
  "规格价": "规格价",
  "规格价格": "规格价格",
  "规格信息": "规格信息",
  "规格单价": "规格单价",
  "规格名称": "规格名称",
  "规格描述 如 2斤装": "规格描述 如 2斤装",
  "规格数量": "规格数量",
  "规格条形码": "规格条形码",
  "规格条形码搜索": "规格条形码搜索",
  "角色岗位": "角色岗位",
  "角色岗位权限配置": "角色岗位权限配置",
  "解冻": "解冻",
  "解锁": "解锁",
  "警告": "警告",
  "警报": "警报",
  "警报库存": "警报库存",
  "警报库存数量": "警报库存数量",
  "计价方式": "计价方式",
  "计划量": "计划量",
  "计算说明": "计算说明",
  "计量单位": "计量单位",
  "订单": "订单",
  "订单|任务查看权限开关": "订单|任务查看权限开关",
  "订单不存在": "订单不存在",
  "订单份量/实际份量": "订单份量/实际份量",
  "订单佣金": "订单佣金",
  "订单信息": "订单信息",
  "订单出库后": "订单出库后",
  "订单出库成功!": "订单出库成功!",
  "订单分拣任务分配机制": "订单分拣任务分配机制",
  "订单列表": "订单列表",
  "订单利润": "订单利润",
  "订单利润统计": "订单利润统计",
  "订单单号": "订单单号",
  "订单发起退货售后，即创建一条售后记录，请到售后管理页面跟进处理。": "订单发起退货售后，即创建一条售后记录，请到售后管理页面跟进处理。",
  "订单取消通知": "订单取消通知",
  "订单取消，只有订单未被采购和分拣操作前，才能予以删除订单，并退回款项和清除采购量等数据。": "订单取消，只有订单未被采购和分拣操作前，才能予以删除订单，并退回款项和清除采购量等数据。",
  "订单号": "订单号",
  "订单号查询": "订单号查询",
  "订单合并": "订单合并",
  "订单商品": "订单商品",
  "订单商品出库操作只有一次机会且不可修改!!!": "订单商品出库操作只有一次机会且不可修改!!!",
  "订单商品排序": "订单商品排序",
  "订单商品收货": "订单商品收货",
  "订单在配送员送出后，如客户未在小程序端执行收货操作，平台默认自动24小时后收货，并最终核算订单。": "订单在配送员送出后，如客户未在小程序端执行收货操作，平台默认自动24小时后收货，并最终核算订单。",
  "订单备注": "订单备注",
  "订单导入": "订单导入",
  "订单导出(营销)": "订单导出(营销)",
  "订单已出库通知": "订单已出库通知",
  "订单总额": "订单总额",
  "订单打印设置": "订单打印设置",
  "订单折扣": "订单折扣",
  "订单指定价 （在订单详情修改或代客下单输入的价格）。": "订单指定价 （在订单详情修改或代客下单输入的价格）。",
  "订单支付方式": "订单支付方式",
  "订单收货完成后，凭订单金额获赠积分。{num}{yuan}=$SPLIT$积分": "订单收货完成后，凭订单金额获赠积分。{num}{yuan}=$SPLIT$积分",
  "订单数": "订单数",
  "订单数量": "订单数量",
  "订单机制说明": "订单机制说明",
  "订单核计": "订单核计",
  "订单次数": "订单次数",
  "订单消费": "订单消费",
  "订单状态": "订单状态",
  "订单状态为完成状态后，才进行提成分配，金额到账户": "订单状态为完成状态后，才进行提成分配，金额到账户",
  "订单积分": "订单积分",
  "订单管理": "订单管理",
  "订单类型": "订单类型",
  "订单线上支付": "订单线上支付",
  "订单结算": "订单结算",
  "订单结算支付时，积分参与现金抵扣。{num}{yuan}=$SPLIT$积分": "订单结算支付时，积分参与现金抵扣。{num}{yuan}=$SPLIT$积分",
  "订单统计数量": "订单统计数量",
  "订单编号": "订单编号",
  "订单详情": "订单详情",
  "订单详情显示商品成本": "订单详情显示商品成本",
  "订单转交": "订单转交",
  "订单退款": "订单退款",
  "订单送达通知": "订单送达通知",
  "订单量": "订单量",
  "订单金额": "订单金额",
  "订单金额：订单的实际出货金额": "订单金额：订单的实际出货金额",
  "订购量": "订购量",
  "记录": "记录",
  "记录数": "记录数",
  "记录类型": "记录类型",
  "记录编号": "记录编号",
  "记账": "记账",
  "记账待付": "记账待付",
  "记账结算": "记账结算",
  "记账订单（不参与采购、分拣、配送）": "记账订单（不参与采购、分拣、配送）",
  "设备编号": "设备编号",
  "设置公告头条": "设置公告头条",
  "设置分类不可见": "设置分类不可见",
  "设置商品提成比例后优化采用商品提成结算": "设置商品提成比例后优化采用商品提成结算",
  "设置头部背景图": "设置头部背景图",
  "设置如下：计量单位“斤” 规格名称“条” 单位数量“2” 成本价“4” 售价“6”": "设置如下：计量单位“斤” 规格名称“条” 单位数量“2” 成本价“4” 售价“6”",
  "设置广告图": "设置广告图",
  "设置成功": "设置成功",
  "设置扣点": "设置扣点",
  "设置星级后，对应的星级客户在小程序不可见此分类": "设置星级后，对应的星级客户在小程序不可见此分类",
  "设置活动时间范围": "设置活动时间范围",
  "询价中": "询价中",
  "询价商品": "询价商品",
  "询价商品报价结果查看，点击选中商品进行采用，将自动更新为该供货商的报价。": "询价商品报价结果查看，点击选中商品进行采用，将自动更新为该供货商的报价。",
  "询价商品数": "询价商品数",
  "询价时间": "询价时间",
  "询价调价": "询价调价",
  "该商品当前售价小于成本价哦": "该商品当前售价小于成本价哦",
  "该商品规格设置了定价公式,请前往询价定价页面设置。仅指定售价方式才可编辑": "该商品规格设置了定价公式,请前往询价定价页面设置。仅指定售价方式才可编辑",
  "该客户常用商品": "该客户常用商品",
  "该客户没有在客户列表": "该客户没有在客户列表",
  "该客户退出付费制成功，不再享受会员权益": "该客户退出付费制成功，不再享受会员权益",
  "该时间为指定日期订单前一天的转化任务时间。例：设置15:00，那么会在指定日期前一天的15:00自动转化任务": "该时间为指定日期订单前一天的转化任务时间。例：设置15:00，那么会在指定日期前一天的15:00自动转化任务",
  "该规格已经被删除": "该规格已经被删除",
  "该记录已生效，确认移除?": "该记录已生效，确认移除?",
  "详情": "详情",
  "说明": "说明",
  "说明描述": "说明描述",
  "说明：供货商在APP设置成本价格，公司在每个供货商设置扣点。根据公式 成本/(1-供应商扣点) = 售价": "说明：供货商在APP设置成本价格，公司在每个供货商设置扣点。根据公式 成本/(1-供应商扣点) = 售价",
  "说明：创建入库单和入库审核列表，可生成入库单": "说明：创建入库单和入库审核列表，可生成入库单",
  "说明：在送货任务执行出库时自动生成出库单": "说明：在送货任务执行出库时自动生成出库单",
  "说明：由入库单发起报账，生成报账对账单，用于跟款": "说明：由入库单发起报账，生成报账对账单，用于跟款",
  "说明：选项为选中状态时，商城端的商品展示为可显示。": "说明：选项为选中状态时，商城端的商品展示为可显示。",
  "请上传 300-300px 图片": "请上传 300-300px 图片",
  "请上传200-200PX图片 PNG格式": "请上传200-200PX图片 PNG格式",
  "请上传700-900PX图片": "请上传700-900PX图片",
  "请上传图片": "请上传图片",
  "请上传头像": "请上传头像",
  "请上传篮筐图片": "请上传篮筐图片",
  "请上传视频文件": "请上传视频文件",
  "请上传页面背景图": "请上传页面背景图",
  "请上传首页活动图标": "请上传首页活动图标",
  "请先存入购物车": "请先存入购物车",
  "请先完善现有属性": "请先完善现有属性",
  "请先打印《出库单》，并确认商品出货数量和价格。": "请先打印《出库单》，并确认商品出货数量和价格。",
  "请先添加商品": "请先添加商品",
  "请先添加清单数据": "请先添加清单数据",
  "请先设置计量单位": "请先设置计量单位",
  "请先选中商品": "请先选中商品",
  "请先选择一个时间范围": "请先选择一个时间范围",
  "请关联活动商品": "请关联活动商品",
  "请勿重复添加": "请勿重复添加",
  "请在PC端——商城——小程序配置 页面中预先设置短信平台信息，及短信余额足量": "请在PC端——商城——小程序配置 页面中预先设置短信平台信息，及短信余额足量",
  "请在短信宝平台注册账号并充值": "请在短信宝平台注册账号并充值",
  "请填入企业ID": "请填入企业ID",
  "请填入客服链接": "请填入客服链接",
  "请填入收款银行号-开户银行-开户名,或其他信息": "请填入收款银行号-开户银行-开户名,或其他信息",
  "请填写{name}的退货数量": "请填写{name}的退货数量",
  "请填写人员姓名": "请填写人员姓名",
  "请填写付款金额": "请填写付款金额",
  "请填写修改结算金额": "请填写修改结算金额",
  "请填写入库量": "请填写入库量",
  "请填写入库量或拒收": "请填写入库量或拒收",
  "请填写其他原因": "请填写其他原因",
  "请填写发行数量": "请填写发行数量",
  "请填写均摊金额": "请填写均摊金额",
  "请填写处理结果": "请填写处理结果",
  "请填写客户商品名称": "请填写客户商品名称",
  "请填写客户商品规格": "请填写客户商品规格",
  "请填写客户条形码": "请填写客户条形码",
  "请填写客服链接和企业ID": "请填写客服链接和企业ID",
  "请填写岗位名称": "请填写岗位名称",
  "请填写建议采购价": "请填写建议采购价",
  "请填写手机号作为账号": "请填写手机号作为账号",
  "请填写提成方案名称": "请填写提成方案名称",
  "请填写收款账户信息": "请填写收款账户信息",
  "请填写方案名称": "请填写方案名称",
  "请填写日供应量": "请填写日供应量",
  "请填写日供量": "请填写日供量",
  "请填写最低警报库存量": "请填写最低警报库存量",
  "请填写正确序号": "请填写正确序号",
  "请填写正确手机号": "请填写正确手机号",
  "请填写正确身份证号": "请填写正确身份证号",
  "请填写活动名称": "请填写活动名称",
  "请填写活动标题": "请填写活动标题",
  "请填写活动说明": "请填写活动说明",
  "请填写满减标准": "请填写满减标准",
  "请填写电话客服号码": "请填写电话客服号码",
  "请填写赠券名称": "请填写赠券名称",
  "请填写赠券面额": "请填写赠券面额",
  "请填写采购总量": "请填写采购总量",
  "请填写采购总金额": "请填写采购总金额",
  "请填写采购数量": "请填写采购数量",
  "请填写采购时单价": "请填写采购时单价",
  "请填写默认分类扣点": "请填写默认分类扣点",
  "请填写默认分类提成": "请填写默认分类提成",
  "请复制粘贴下单内容，如苹果5斤/橘子6个": "请复制粘贴下单内容，如苹果5斤/橘子6个",
  "请完善 {text} 存放区域": "请完善 {text} 存放区域",
  "请完善 {text} 商品信息": "请完善 {text} 商品信息",
  "请完善 {text} 商品入库量": "请完善 {text} 商品入库量",
  "请完善 {text} 的下单量": "请完善 {text} 的下单量",
  "请完善 {text} 的入库单价": "请完善 {text} 的入库单价",
  "请完善 {text} 的入库量": "请完善 {text} 的入库量",
  "请完善 {text} 的销售单价": "请完善 {text} 的销售单价",
  "请完善{text}号子商品": "请完善{text}号子商品",
  "请完善促销商品活动价": "请完善促销商品活动价",
  "请完善促销商品限购量": "请完善促销商品限购量",
  "请完善商品退款金额": "请完善商品退款金额",
  "请完善地址信息": "请完善地址信息",
  "请完善实收金额": "请完善实收金额",
  "请完善已收款金额": "请完善已收款金额",
  "请完善已选商品的退货数量": "请完善已选商品的退货数量",
  "请完善第四方支付信息": "请完善第四方支付信息",
  "请截图或复制图片微信发送给供货商": "请截图或复制图片微信发送给供货商",
  "请按模板表格中数据格式，格式不一致会导入失败!": "请按模板表格中数据格式，格式不一致会导入失败!",
  "请查找后选择": "请查找后选择",
  "请核对客户商品清单与查询结果商品，点“存入购物车”，再提交订单。": "请核对客户商品清单与查询结果商品，点“存入购物车”，再提交订单。",
  "请添加商品": "请添加商品",
  "请添加商品协议价格": "请添加商品协议价格",
  "请添加子商品": "请添加子商品",
  "请添加客户": "请添加客户",
  "请确认促销类型": "请确认促销类型",
  "请确认所有商品是否已验货!": "请确认所有商品是否已验货!",
  "请确认是否删除该订单已拆分的全部子供货单?": "请确认是否删除该订单已拆分的全部子供货单?",
  "请联系客服": "请联系客服",
  "请至少完善一条商品数据!": "请至少完善一条商品数据!",
  "请至少选中两个订单": "请至少选中两个订单",
  "请记录处理结果，将返回展示给顾客": "请记录处理结果，将返回展示给顾客",
  "请设置标准量": "请设置标准量",
  "请设置询价商品": "请设置询价商品",
  "请设置起配量": "请设置起配量",
  "请设置需拆分商品": "请设置需拆分商品",
  "请输入": "请输入",
  "请输入上一级区域仓": "请输入上一级区域仓",
  "请输入下单数量": "请输入下单数量",
  "请输入主账号秘密": "请输入主账号秘密",
  "请输入仓库简称,20字内": "请输入仓库简称,20字内",
  "请输入付款金额": "请输入付款金额",
  "请输入代买额度": "请输入代买额度",
  "请输入价格": "请输入价格",
  "请输入企业经营地址": "请输入企业经营地址",
  "请输入企业负责人": "请输入企业负责人",
  "请输入会员价": "请输入会员价",
  "请输入供货商": "请输入供货商",
  "请输入供货商名称": "请输入供货商名称",
  "请输入供货商登录帐号": "请输入供货商登录帐号",
  "请输入内容": "请输入内容",
  "请输入出借篮筐数量": "请输入出借篮筐数量",
  "请输入出库单价": "请输入出库单价",
  "请输入出库数量": "请输入出库数量",
  "请输入分拣数量": "请输入分拣数量",
  "请输入制单人": "请输入制单人",
  "请输入区域仓库名称": "请输入区域仓库名称",
  "请输入区域仓库地址": "请输入区域仓库地址",
  "请输入区域仓负责人": "请输入区域仓负责人",
  "请输入单价": "请输入单价",
  "请输入单位名称": "请输入单位名称",
  "请输入可借总量": "请输入可借总量",
  "请输入名称查询": "请输入名称查询",
  "请输入售价": "请输入售价",
  "请输入商品别名，多个请用/隔开": "请输入商品别名，多个请用/隔开",
  "请输入商品名字": "请输入商品名字",
  "请输入商品名称": "请输入商品名称",
  "请输入商品名称或别名": "请输入商品名称或别名",
  "请输入商品搜索": "请输入商品搜索",
  "请输入商品编号": "请输入商品编号",
  "请输入围栏商圈名称": "请输入围栏商圈名称",
  "请输入固定行数": "请输入固定行数",
  "请输入地址": "请输入地址",
  "请输入均衡成本，将用于利润核算": "请输入均衡成本，将用于利润核算",
  "请输入备注": "请输入备注",
  "请输入备注说明": "请输入备注说明",
  "请输入天数": "请输入天数",
  "请输入客户名称": "请输入客户名称",
  "请输入客服服务电话": "请输入客服服务电话",
  "请输入客服电话": "请输入客服电话",
  "请输入密码": "请输入密码",
  "请输入小程序内部链接": "请输入小程序内部链接",
  "请输入工序名称": "请输入工序名称",
  "请输入库内分区": "请输入库内分区",
  "请输入库存数量": "请输入库存数量",
  "请输入开户银行": "请输入开户银行",
  "请输入总金额": "请输入总金额",
  "请输入手机号": "请输入手机号",
  "请输入手机号作为账号": "请输入手机号作为账号",
  "请输入报损数量": "请输入报损数量",
  "请输入报账金额": "请输入报账金额",
  "请输入抽成比例": "请输入抽成比例",
  "请输入拒绝原因": "请输入拒绝原因",
  "请输入损溢原因": "请输入损溢原因",
  "请输入排序号（范围1-99）": "请输入排序号（范围1-99）",
  "请输入提成奖励": "请输入提成奖励",
  "请输入提成比例": "请输入提成比例",
  "请输入收款方名称": "请输入收款方名称",
  "请输入数量": "请输入数量",
  "请输入最低警报库存量": "请输入最低警报库存量",
  "请输入最高警报库存量": "请输入最高警报库存量",
  "请输入本次付款金额": "请输入本次付款金额",
  "请输入本次收款金额": "请输入本次收款金额",
  "请输入正整数": "请输入正整数",
  "请输入正确价格": "请输入正确价格",
  "请输入正确手机号": "请输入正确手机号",
  "请输入正确数量": "请输入正确数量",
  "请输入正确格式": "请输入正确格式",
  "请输入正确的手机号": "请输入正确的手机号",
  "请输入正确的数量": "请输入正确的数量",
  "请输入正确的电话号码": "请输入正确的电话号码",
  "请输入正确的金额": "请输入正确的金额",
  "请输入生产企业": "请输入生产企业",
  "请输入用户名": "请输入用户名",
  "请输入登录密码": "请输入登录密码",
  "请输入登录账号": "请输入登录账号",
  "请输入盘存数量": "请输入盘存数量",
  "请输入等级名称": "请输入等级名称",
  "请输入篮筐名称": "请输入篮筐名称",
  "请输入紧急联系人手机号": "请输入紧急联系人手机号",
  "请输入经营地址": "请输入经营地址",
  "请输入联系电话": "请输入联系电话",
  "请输入自动执行时间": "请输入自动执行时间",
  "请输入自动收货时间": "请输入自动收货时间",
  "请输入订单备注": "请输入订单备注",
  "请输入调小金额": "请输入调小金额",
  "请输入负责人": "请输入负责人",
  "请输入负责人手机账号": "请输入负责人手机账号",
  "请输入负责人电话": "请输入负责人电话",
  "请输入负责人联系方式": "请输入负责人联系方式",
  "请输入账户名称": "请输入账户名称",
  "请输入账户账号": "请输入账户账号",
  "请输入身份证证件号": "请输入身份证证件号",
  "请输入转出数量": "请输入转出数量",
  "请输入退款备注": "请输入退款备注",
  "请输入退款金额": "请输入退款金额",
  "请输入退筐数量": "请输入退筐数量",
  "请输入退货理由": "请输入退货理由",
  "请输入配送范围名称": "请输入配送范围名称",
  "请输入金额": "请输入金额",
  "请输入银行卡卡户名字": "请输入银行卡卡户名字",
  "请输入银行卡号": "请输入银行卡号",
  "请输入银行卡开户行": "请输入银行卡开户行",
  "请输入银行账号信息": "请输入银行账号信息",
  "请输入项目名称": "请输入项目名称",
  "请输入验证码": "请输入验证码",
  "请输出单价": "请输出单价",
  "请选中同一个客户": "请选中同一个客户",
  "请选中商品": "请选中商品",
  "请选中商品打印": "请选中商品打印",
  "请选中商品报账": "请选中商品报账",
  "请选中批量改价商品": "请选中批量改价商品",
  "请选中订单打印": "请选中订单打印",
  "请选择": "请选择",
  "请选择一级分类": "请选择一级分类",
  "请选择上一级区域仓": "请选择上一级区域仓",
  "请选择上传800*800px尺寸图片": "请选择上传800*800px尺寸图片",
  "请选择下级人员": "请选择下级人员",
  "请选择买赔对象": "请选择买赔对象",
  "请选择二级分类": "请选择二级分类",
  "请选择仓库": "请选择仓库",
  "请选择仓库区域": "请选择仓库区域",
  "请选择付款方式": "请选择付款方式",
  "请选择任务": "请选择任务",
  "请选择供应商": "请选择供应商",
  "请选择供应商或采购员": "请选择供应商或采购员",
  "请选择供货商": "请选择供货商",
  "请选择入库时间": "请选择入库时间",
  "请选择入库类型": "请选择入库类型",
  "请选择关联商品": "请选择关联商品",
  "请选择出库类型": "请选择出库类型",
  "请选择利润方式": "请选择利润方式",
  "请选择发卡商家": "请选择发卡商家",
  "请选择同一个客户的订单": "请选择同一个客户的订单",
  "请选择同一供货商": "请选择同一供货商",
  "请选择同一司机进行打印": "请选择同一司机进行打印",
  "请选择同一客户": "请选择同一客户",
  "请选择周转筐": "请选择周转筐",
  "请选择售卖方式": "请选择售卖方式",
  "请选择商品": "请选择商品",
  "请选择商品主图": "请选择商品主图",
  "请选择商品和客户": "请选择商品和客户",
  "请选择商品或者勾选全部商品": "请选择商品或者勾选全部商品",
  "请选择在{start}-{end}之内的时间": "请选择在{start}-{end}之内的时间",
  "请选择均摊原因": "请选择均摊原因",
  "请选择均摊方式": "请选择均摊方式",
  "请选择均摊类型": "请选择均摊类型",
  "请选择客户": "请选择客户",
  "请选择对方名称": "请选择对方名称",
  "请选择展示时间": "请选择展示时间",
  "请选择岗位权限": "请选择岗位权限",
  "请选择市": "请选择市",
  "请选择性别": "请选择性别",
  "请选择截止时间": "请选择截止时间",
  "请选择所属仓库": "请选择所属仓库",
  "请选择打印内容": "请选择打印内容",
  "请选择提成类型": "请选择提成类型",
  "请选择新订单或者处理中订单": "请选择新订单或者处理中订单",
  "请选择日期": "请选择日期",
  "请选择时间": "请选择时间",
  "请选择有效时间": "请选择有效时间",
  "请选择未发起结算订单": "请选择未发起结算订单",
  "请选择来筐时间": "请选择来筐时间",
  "请选择活动商家": "请选择活动商家",
  "请选择活动时间": "请选择活动时间",
  "请选择活动类型": "请选择活动类型",
  "请选择活动范围": "请选择活动范围",
  "请选择源商品": "请选择源商品",
  "请选择电子围栏": "请选择电子围栏",
  "请选择省": "请选择省",
  "请选择第三级标签": "请选择第三级标签",
  "请选择篮筐": "请选择篮筐",
  "请选择篮筐类型": "请选择篮筐类型",
  "请选择线路": "请选择线路",
  "请选择要创建的订单": "请选择要创建的订单",
  "请选择要结算的订单": "请选择要结算的订单",
  "请选择规格": "请选择规格",
  "请选择角色岗位": "请选择角色岗位",
  "请选择订单": "请选择订单",
  "请选择责任人员": "请选择责任人员",
  "请选择转派司机": "请选择转派司机",
  "请选择送货任务": "请选择送货任务",
  "请选择配送人员": "请选择配送人员",
  "请选择配送员线路": "请选择配送员线路",
  "请选择配送线路": "请选择配送线路",
  "请选择采购员": "请选择采购员",
  "请选择问题原因": "请选择问题原因",
  "请选择需删除的记录": "请选择需删除的记录",
  "请选择需加入的数据": "请选择需加入的数据",
  "请选择需均摊的商品": "请选择需均摊的商品",
  "请选择需报账单据": "请选择需报账单据",
  "请选择需要打印内容": "请选择需要打印内容",
  "请选择需要打印补货单": "请选择需要打印补货单",
  "请选择需要打印退货单": "请选择需要打印退货单",
  "请选择需转单的商品": "请选择需转单的商品",
  "请选要删除的篮筐": "请选要删除的篮筐",
  "请重新保存送货单打印模板": "请重新保存送货单打印模板",
  "请重新筛选导出": "请重新筛选导出",
  "调价": "调价",
  "调价后对后续下单的价格才起效果": "调价后对后续下单的价格才起效果",
  "调价后对本运营时间段内已下订单（线下结算）及后续订单全部生效": "调价后对本运营时间段内已下订单（线下结算）及后续订单全部生效",
  "调价对未出库的订单商品生效": "调价对未出库的订单商品生效",
  "调价对未结算订单商品生效": "调价对未结算订单商品生效",
  "调价时间": "调价时间",
  "调价订单": "调价订单",
  "调建议价": "调建议价",
  "调建议采购价": "调建议采购价",
  "调拨入库": "调拨入库",
  "调拨出库": "调拨出库",
  "调整建议采购价为": "调整建议采购价为",
  "调配已收金额": "调配已收金额",
  "调配总金额与总收款金额不符": "调配总金额与总收款金额不符",
  "调额": "调额",
  "调额类型": "调额类型",
  "负责": "负责",
  "负责人": "负责人",
  "负责人员": "负责人员",
  "负责人姓名": "负责人姓名",
  "负责人姓名和电话为非必填，即不进行商城端登录": "负责人姓名和电话为非必填，即不进行商城端登录",
  "财务": "财务",
  "财务人员": "财务人员",
  "财务收支账户": "财务收支账户",
  "财务收款": "财务收款",
  "财务流水": "财务流水",
  "责任": "责任",
  "责任人员": "责任人员",
  "责任岗位": "责任岗位",
  "账号": "账号",
  "账号/手机号": "账号/手机号",
  "账号信息": "账号信息",
  "账号到期时间": "账号到期时间",
  "账号密码": "账号密码",
  "账号状态": "账号状态",
  "账号角色": "账号角色",
  "账户": "账户",
  "账户余额": "账户余额",
  "账户信息": "账户信息",
  "账户名称": "账户名称",
  "账户名称不能为空": "账户名称不能为空",
  "账户开户行": "账户开户行",
  "账户折扣": "账户折扣",
  "账户积分": "账户积分",
  "账户账号": "账户账号",
  "账户账号不能为空": "账户账号不能为空",
  "账期日期": "账期日期",
  "账期时间": "账期时间",
  "账面": "账面",
  "账面存量": "账面存量",
  "货品共{num}件": "货品共{num}件",
  "货品共{num}种": "货品共{num}种",
  "货损买赔": "货损买赔",
  "质检报告": "质检报告",
  "购物车": "购物车",
  "费用原因": "费用原因",
  "费用均摊": "费用均摊",
  "赠券名称": "赠券名称",
  "赠券面额": "赠券面额",
  "起购量显示": "起购量显示",
  "起送标准": "起送标准",
  "起配量": "起配量",
  "起配量不得大于标准量": "起配量不得大于标准量",
  "超出入库数量": "超出入库数量",
  "超市": "超市",
  "超量少量": "超量少量",
  "超量警报": "超量警报",
  "身份证反面照": "身份证反面照",
  "身份证号": "身份证号",
  "身份证正面照": "身份证正面照",
  "车辆信息": "车辆信息",
  "车辆照片": "车辆照片",
  "车辆行驶证": "车辆行驶证",
  "转企业": "转企业",
  "转修改单": "转修改单",
  "转出数量": "转出数量",
  "转单": "转单",
  "转单成功": "转单成功",
  "转单数量不足!": "转单数量不足!",
  "转单状态": "转单状态",
  "转单给": "转单给",
  "转取货任务": "转取货任务",
  "转换成功": "转换成功",
  "转派取件": "转派取件",
  "转结算单": "转结算单",
  "转给配送人员": "转给配送人员",
  "转让": "转让",
  "转让成功": "转让成功",
  "转让给": "转让给",
  "转采购": "转采购",
  "转量": "转量",
  "输入1，则下单某商品，1分钟后自动执行改商品的采购任务": "输入1，则下单某商品，1分钟后自动执行改商品的采购任务",
  "输入价格": "输入价格",
  "输入价格名称": "输入价格名称",
  "输入信息必须大于0": "输入信息必须大于0",
  "输入数量": "输入数量",
  "输入查找全部内部人员": "输入查找全部内部人员",
  "输入的金额值为上涨或下调的差额，如：原价{num1}{yuan}，上涨{num2}{yuan}，售价则为{num3}{yuan}": "输入的金额值为上涨或下调的差额，如：原价{num1}{yuan}，上涨{num2}{yuan}，售价则为{num3}{yuan}",
  "输入补货数量": "输入补货数量",
  "输入订单编号": "输入订单编号",
  "输入退款金额": "输入退款金额",
  "输入退货理由": "输入退货理由",
  "输入金额": "输入金额",
  "过期": "过期",
  "运营状况": "运营状况",
  "运费": "运费",
  "运输成本": "运输成本",
  "运输损耗": "运输损耗",
  "运输费": "运输费",
  "近30天退货订单": "近30天退货订单",
  "返回": "返回",
  "还没收款金额，无法调配已收金额": "还没收款金额，无法调配已收金额",
  "还筐操作": "还筐操作",
  "进口产地": "进口产地",
  "进口商信息": "进口商信息",
  "进口商注册号": "进口商注册号",
  "进度": "进度",
  "进程": "进程",
  "追加给配送人员": "追加给配送人员",
  "退": "退",
  "退出付费制": "退出付费制",
  "退出登录": "退出登录",
  "退押金筐": "退押金筐",
  "退款备注": "退款备注",
  "退款成功!": "退款成功!",
  "退款详情": "退款详情",
  "退款金额": "退款金额",
  "退款金额不可超过订单金额": "退款金额不可超过订单金额",
  "退筐取件": "退筐取件",
  "退筐退款": "退筐退款",
  "退货": "退货",
  "退货入库": "退货入库",
  "退货入库单表": "退货入库单表",
  "退货出库": "退货出库",
  "退货单": "退货单",
  "退货单号": "退货单号",
  "退货商品": "退货商品",
  "退货商品只能是同一供货商": "退货商品只能是同一供货商",
  "退货备注": "退货备注",
  "退货待退款": "退货待退款",
  "退货成功!": "退货成功!",
  "退货成本": "退货成本",
  "退货数量": "退货数量",
  "退货订单": "退货订单",
  "退货退款": "退货退款",
  "退货量": "退货量",
  "退货金额": "退货金额",
  "退还": "退还",
  "退还押金须知：所退金额到该公司客户的余额账户": "退还押金须知：所退金额到该公司客户的余额账户",
  "退还篮筐": "退还篮筐",
  "送至": "送至",
  "送货中": "送货中",
  "送货人": "送货人",
  "送货人员": "送货人员",
  "送货人签字": "送货人签字",
  "送货任务": "送货任务",
  "送货任务出库": "送货任务出库",
  "送货任务详情": "送货任务详情",
  "送货信息": "送货信息",
  "送货单": "送货单",
  "送货单中的出库重量，默认以分拣端的实际称重量为准。": "送货单中的出库重量，默认以分拣端的实际称重量为准。",
  "送货单号": "送货单号",
  "送货单在送达后点击，或出库后自动送达。主动点击操作后数据状态不可回退。确认该任务送达?": "送货单在送达后点击，或出库后自动送达。主动点击操作后数据状态不可回退。确认该任务送达?",
  "送货单导出": "送货单导出",
  "送货单导出2": "送货单导出2",
  "送货单拆转": "送货单拆转",
  "送货单模板": "送货单模板",
  "送货发票号": "送货发票号",
  "送货员": "送货员",
  "送货员查看全部订单": "送货员查看全部订单",
  "送货损耗/斤</br>(出库量-收货量)": "送货损耗/斤</br>(出库量-收货量)",
  "送货数量": "送货数量",
  "送货方式": "送货方式",
  "送货日期": "送货日期",
  "送货时间": "送货时间",
  "送货要求": "送货要求",
  "送货路径": "送货路径",
  "送货路线": "送货路线",
  "送货进度": "送货进度",
  "送达后自动收货": "送达后自动收货",
  "送达后自动收货并发起结算": "送达后自动收货并发起结算",
  "适用全部商品": "适用全部商品",
  "适用全部客户": "适用全部客户",
  "选中商品暂不支持转采购": "选中商品暂不支持转采购",
  "选中客户": "选中客户",
  "选其供货": "选其供货",
  "选取坐标": "选取坐标",
  "选取文件": "选取文件",
  "选填": "选填",
  "选择一个或多个日期": "选择一个或多个日期",
  "选择一个或多个日期（必填）": "选择一个或多个日期（必填）",
  "选择一个日期": "选择一个日期",
  "选择一个时间点（必填）": "选择一个时间点（必填）",
  "选择业务员": "选择业务员",
  "选择人员": "选择人员",
  "选择人员类型": "选择人员类型",
  "选择仓库名称": "选择仓库名称",
  "选择供应商": "选择供应商",
  "选择供货商": "选择供货商",
  "选择分拣员": "选择分拣员",
  "选择分类": "选择分类",
  "选择加工工序": "选择加工工序",
  "选择单位名称": "选择单位名称",
  "选择商品": "选择商品",
  "选择多个商品，批量调价后，定价核价方式改为 指定售价方式，公式失效!": "选择多个商品，批量调价后，定价核价方式改为 指定售价方式，公式失效!",
  "选择子部门": "选择子部门",
  "选择客户": "选择客户",
  "选择库区": "选择库区",
  "选择打印模板": "选择打印模板",
  "选择日期": "选择日期",
  "选择日期时间": "选择日期时间",
  "选择时间": "选择时间",
  "选择类型": "选择类型",
  "选择规格": "选择规格",
  "选择询价商品，创建询价任务。": "选择询价商品，创建询价任务。",
  "选择送货员": "选择送货员",
  "选择采购员": "选择采购员",
  "选购": "选购",
  "通用商品属性": "通用商品属性",
  "通用默认值": "通用默认值",
  "通过": "通过",
  "邮箱": "邮箱",
  "郑重提示：操作前请确认账户已收付款项": "郑重提示：操作前请确认账户已收付款项",
  "郑重提示：操作前请确认账户已收收款项": "郑重提示：操作前请确认账户已收收款项",
  "部份付款金额": "部份付款金额",
  "部分付款": "部分付款",
  "部分任务已完成，不能转单": "部分任务已完成，不能转单",
  "部分到款": "部分到款",
  "部分支付": "部分支付",
  "部分收款": "部分收款",
  "部分订单无法发起收款": "部分订单无法发起收款",
  "部门人数": "部门人数",
  "部门名称": "部门名称",
  "部门名称查找": "部门名称查找",
  "都不勾选，则默认以手动方式，在财务 - 订单结算页面，发起结算": "都不勾选，则默认以手动方式，在财务 - 订单结算页面，发起结算",
  "配置模板": "配置模板",
  "配送": "配送",
  "配送中": "配送中",
  "配送中-待收货": "配送中-待收货",
  "配送中待收货": "配送中待收货",
  "配送人员": "配送人员",
  "配送人员在APP端可以在验货出库时，修改出库数量，且订单将以此数量，重新核算一次订单金额。": "配送人员在APP端可以在验货出库时，修改出库数量，且订单将以此数量，重新核算一次订单金额。",
  "配送人员线路": "配送人员线路",
  "配送信息": "配送信息",
  "配送取件人/员": "配送取件人/员",
  "配送员": "配送员",
  "配送总里程": "配送总里程",
  "配送排单": "配送排单",
  "配送方式": "配送方式",
  "配送时间": "配送时间",
  "配送管理": "配送管理",
  "配送范围": "配送范围",
  "配送范围详情": "配送范围详情",
  "配送订单": "配送订单",
  "配送费": "配送费",
  "配送费不能为空": "配送费不能为空",
  "配送路线": "配送路线",
  "配送错误": "配送错误",
  "采买成本": "采买成本",
  "采买统计": "采买统计",
  "采用": "采用",
  "采购": "采购",
  "采购-供货进度": "采购-供货进度",
  "采购/供应清单": "采购/供应清单",
  "采购|入库自动调成本": "采购|入库自动调成本",
  "采购下单客户": "采购下单客户",
  "采购下单说明": "采购下单说明",
  "采购人": "采购人",
  "采购人员": "采购人员",
  "采购价格趋势": "采购价格趋势",
  "采购任务": "采购任务",
  "采购任务数据列表": "采购任务数据列表",
  "采购任务清单": "采购任务清单",
  "采购任务清单是否打印商品成本单价": "采购任务清单是否打印商品成本单价",
  "采购任务自动执行时间": "采购任务自动执行时间",
  "采购供货任务合并": "采购供货任务合并",
  "采购供货对账单": "采购供货对账单",
  "采购信息": "采购信息",
  "采购入库": "采购入库",
  "采购入库单": "采购入库单",
  "采购入库商品模板": "采购入库商品模板",
  "采购入库时间": "采购入库时间",
  "采购单": "采购单",
  "采购单价": "采购单价",
  "采购单位": "采购单位",
  "采购单位编号": "采购单位编号",
  "采购单号": "采购单号",
  "采购单详情": "采购单详情",
  "采购历程": "采购历程",
  "采购合作协议": "采购合作协议",
  "采购员": "采购员",
  "采购员查看全部任务": "采购员查看全部任务",
  "采购商品": "采购商品",
  "采购商品名称": "采购商品名称",
  "采购商品清单": "采购商品清单",
  "采购商品种类": "采购商品种类",
  "采购商家": "采购商家",
  "采购商家数": "采购商家数",
  "采购完成度": "采购完成度",
  "采购对账单": "采购对账单",
  "采购少量": "采购少量",
  "采购建议价": "采购建议价",
  "采购总量": "采购总量",
  "采购总金额": "采购总金额",
  "采购总额": "采购总额",
  "采购成本": "采购成本",
  "采购批次": "采购批次",
  "采购报账": "采购报账",
  "采购报账申请": "采购报账申请",
  "采购损耗/斤</br>(采购量-入库量)": "采购损耗/斤</br>(采购量-入库量)",
  "采购操作时即自动增加入库记录，限一个仓库时有效，多仓库情况时采购与入库操作必须分开操作": "采购操作时即自动增加入库记录，限一个仓库时有效，多仓库情况时采购与入库操作必须分开操作",
  "采购支出": "采购支出",
  "采购数量": "采购数量",
  "采购时单价": "采购时单价",
  "采购时间": "采购时间",
  "采购结算": "采购结算",
  "采购结算方式": "采购结算方式",
  "采购统计": "采购统计",
  "采购自动入库": "采购自动入库",
  "采购补货": "采购补货",
  "采购设置": "采购设置",
  "采购超价审核": "采购超价审核",
  "采购退货": "采购退货",
  "采购退货单": "采购退货单",
  "采购退货表": "采购退货表",
  "采购重量": "采购重量",
  "采购量": "采购量",
  "采购金额": "采购金额",
  "采购金额(必填)": "采购金额(必填)",
  "采购额": "采购额",
  "重制密码成功!": "重制密码成功!",
  "重新下单": "重新下单",
  "重绘": "重绘",
  "重置原因": "重置原因",
  "重置后密码": "重置后密码",
  "重置密码": "重置密码",
  "重置库存": "重置库存",
  "重要信息，请勿修改!": "重要信息，请勿修改!",
  "重要星级": "重要星级",
  "重量": "重量",
  "金额": "金额",
  "金额大写": "金额大写",
  "金额小写": "金额小写",
  "金额格式不正确": "金额格式不正确",
  "钱包余额": "钱包余额",
  "铢": "铢",
  "银行信息": "银行信息",
  "银行卡": "银行卡",
  "银行卡号": "银行卡号",
  "银行卡结算": "银行卡结算",
  "银行卡账户名称": "银行卡账户名称",
  "银行卡账户明细": "银行卡账户明细",
  "银行账号信息": "银行账号信息",
  "银行账户": "银行账户",
  "铺货寄售": "铺货寄售",
  "链接": "链接",
  "销售": "销售",
  "销售价": "销售价",
  "销售价格趋势": "销售价格趋势",
  "销售出库": "销售出库",
  "销售利润": "销售利润",
  "销售利润核价": "销售利润核价",
  "销售单价": "销售单价",
  "销售应结算": "销售应结算",
  "销售总额": "销售总额",
  "销售成本": "销售成本",
  "销售扣点": "销售扣点",
  "销售明细": "销售明细",
  "销售毛利表": "销售毛利表",
  "销售订单": "销售订单",
  "销售退货入库": "销售退货入库",
  "销售退货单": "销售退货单",
  "销售量": "销售量",
  "销售量显示": "销售量显示",
  "销售金额": "销售金额",
  "销售额": "销售额",
  "销量": "销量",
  "销量不能大于存量": "销量不能大于存量",
  "销量排序": "销量排序",
  "销量范围": "销量范围",
  "锁定": "锁定",
  "锁定排单": "锁定排单",
  "锁定状态": "锁定状态",
  "错误信息": "错误信息",
  "长度在 1 到 10 个字符": "长度在 1 到 10 个字符",
  "长度在 2 到 10 个字符": "长度在 2 到 10 个字符",
  "长度在 6 到 16 个字符": "长度在 6 到 16 个字符",
  "长度在10字以内": "长度在10字以内",
  "长度在128字以内": "长度在128字以内",
  "长度在200字以内": "长度在200字以内",
  "长度在20字以内": "长度在20字以内",
  "长度在32字以内": "长度在32字以内",
  "长度在40字以内": "长度在40字以内",
  "长度在6-16之间": "长度在6-16之间",
  "长度在64字以内": "长度在64字以内",
  "长度在8字以内": "长度在8字以内",
  "长度在1000字以内": "长度在1000字以内",
  "长按拖拽至桌面$SPLIT$生成快捷入口": "长按拖拽至桌面$SPLIT$生成快捷入口",
  "门店": "门店",
  "门店展示收费标准": "门店展示收费标准",
  "门店推荐展示": "门店推荐展示",
  "问题内容": "问题内容",
  "问题原因": "问题原因",
  "问题描述": "问题描述",
  "阶梯优惠价": "阶梯优惠价",
  "阶梯优惠价=成本+毛利": "阶梯优惠价=成本+毛利",
  "附送货单共{num}张": "附送货单共{num}张",
  "限制": "限制",
  "限制客户在商城端禁止下单": "限制客户在商城端禁止下单",
  "限购": "限购",
  "隐藏商品": "隐藏商品",
  "隔日送": "隔日送",
  "隔日送达": "隔日送达",
  "隔日配送": "隔日配送",
  "需求反馈": "需求反馈",
  "需求量": "需求量",
  "非同一对方，无法报账": "非同一对方，无法报账",
  "非在线支付方式的，将以线下结算方式进行。": "非在线支付方式的，将以线下结算方式进行。",
  "非必填": "非必填",
  "非标准模板打印": "非标准模板打印",
  "面额": "面额",
  "页背景图": "页背景图",
  "项目": "项目",
  "项目LOGO": "项目LOGO",
  "项目协议": "项目协议",
  "项目名不能为空": "项目名不能为空",
  "项目名称": "项目名称",
  "顾客连续3天不下单，积分账户即停止自动兑换到余额机制。再次下单时重新继续兑换。": "顾客连续3天不下单，积分账户即停止自动兑换到余额机制。再次下单时重新继续兑换。",
  "预估利润": "预估利润",
  "预售": "预售",
  "预售采购": "预售采购",
  "预期利润": "预期利润",
  "预期利润：订单金额-采购成本": "预期利润：订单金额-采购成本",
  "预计利润": "预计利润",
  "预计采买": "预计采买",
  "预采补采任务": "预采补采任务",
  "领取": "领取",
  "领导": "领导",
  "领用": "领用",
  "食堂": "食堂",
  "餐饮": "餐饮",
  "首先导出模板": "首先导出模板",
  "首页": "首页",
  "首页头部背景图": "首页头部背景图",
  "首页弹窗广告图": "首页弹窗广告图",
  "首页推荐": "首页推荐",
  "首页显示": "首页显示",
  "首页活动图标": "首页活动图标",
  "首页活动标上传失败": "首页活动标上传失败",
  "首页活动标题": "首页活动标题",
  "首页轮播图": "首页轮播图",
  "首页轮播广告图": "首页轮播广告图",
  "驳回": "驳回",
  "验货": "验货",
  "默认": "默认",
  "默认付款方式": "默认付款方式",
  "默认分类提成": "默认分类提成",
  "默认密码: 123456": "默认密码: 123456",
  "默认扣点": "默认扣点",
  "默认星级为": "默认星级为",
  "默认路线": "默认路线",
  "鼠标左击绘制不规则多边形,编辑框选对应客户(需要确认操作)": "鼠标左击绘制不规则多边形,编辑框选对应客户(需要确认操作)",
  "鼠标左键按住框选,可按住Shift或者Ctrl键重复框选": "鼠标左键按住框选,可按住Shift或者Ctrl键重复框选",
  "鼠标按下可框选。按下Shift或者Ctrl键 实现重复框选": "鼠标按下可框选。按下Shift或者Ctrl键 实现重复框选"
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js